import { Vector3, Quaternion, Euler } from 'three';
import { Circ, gsap, Expo, Power2 } from 'gsap';
import $ from 'jquery';
import { Scene3D } from "./Scene3D";
import { SCENE_INTERACTION } from './constants/scene';
import { WEBRTC_EVENTS, RTC_EVENTS } from './constants/webrtc';
import { MODEL_EVENTS, SCENE_EVENTS } from './components/MVC/Model';
// import { getCookie, setCookie } from './components/engine/helpers/cookie';
import { SOCKET_EVENTS } from './socket/Socket';
import { SCENE_OBJECT_TYPES } from './constants/SceneObjects';
import { areInSameScene } from './components/MVC/dataHelpers';
import { getLowResImageUrl } from './components/engine/helpers/getImageType';
import { initShopSlider, changeSlide, resizeSlider } from './components/Modals/Slider';
import Xwiper from 'xwiper';
import { NOTIFICATION_EVENTS } from './constants/notifications';
import {
  applyForcedWorldLanguage,
  isAndroid,
  isChrome,
  isIOS,
  isMobile,
  isNavigationMenuEnabled,
  isPlaying,
  isSafari,
  pushMeta,
  unshiftMeta
} from './components/engine/helpers/worldHelpers';
import { getImgThumb } from './components/engine/helpers/getImageType';
import { ANT_MEDIA_SERVER_BAGELSS_EVENTS, states } from './components/WebRTC/constants';
import { SCREEN_SHARE_SEAT_TYPE } from './components/engine/VRTourScreenShare';
import { GuestWelcomeModal } from './components/Users/GuestWelcomeModal';
import { SpaceConsentModal } from './components/Users/SpaceConsentModal';
import { CUSTOM_TOUR_EVENTS } from './socket/Events';
import TourBanner from './components/engine/tour/TourBanner';
import { ChairInvite } from './components/Modals/ChairInvite';
import { ChessInvite } from './components/Modals/ChessIvnite';
import InitDeviceCheck from './components/Modals/InitDeviceCheck';
import { LocationMenu } from './components/Navbar/LocationMenu';
import { TourStartMenu } from './components/Navbar/TourStartMenu';
import { UserTracking } from "./components/Tracking/UserTracking";
import { ParticipantMode } from "./components/Navbar/Navbar";
import { SettingMenu } from "./components/Settings/SettingMenu";
import { notificationSettings } from "./components/engine/data/globalState";
import {
  CONFIRM_BUTTON_SIZE,
  CONFIRM_NOTIFICATION_SIZE,
  CONFIRM_NOTIFICATION_THEME,
  CONFIRM_NOTIFICATION_TYPE,
} from "./components/Modals/Notifications/ConfirmNotification";
import { ICON } from "./components/Icons/Icons";
import { requestMediaPermissions } from "./components/engine/helpers/userMediaHelper";
import { GAME_EVENTS } from './constants/game';
import { FEATURE_NAMES } from "./components/MVC/rolesHelper";
import { mergeLibraryAgentIntoChairConfig, isWelcomeEventTarget, isSceneLevelSource, SCENE_SOURCE_TYPE, WELCOME_SOURCE_TYPE } from './constants/eventActions';
import { slugifyFieldKey } from './components/Tracking/sessionInputStore';
import WelcomeScreen from './components/Modals/WelcomeScreen';
import { roomGuide484 } from './components/vapi-room-guide/RoomGuide484.js';
import { Postit } from './components/engine/HTMLElements/Postit';
import { ClickPointAnimation } from './plugins/click-point-animation/ClickPointAnimation';
const css3DContainer = document.querySelector('#css3d');
const audioElement = document.querySelector('#audio-notification');
const audiotest = document.getElementById('audio-test');

function isVideoPlayerType(type) {
  return type === 'videoPlayer' || type === 'videoPlayerWebGL';
}

/** Debug: what the indicator handler will do (matches indicatorClickEvent handlers). */
function describeIndicatorClickAction(className) {
  const c = className || '';
  if (c.includes('chair-indicator')) return 'Run _chairClickEvent() – chair / guest seat UI';
  if (c.includes('tour-screen-share-indicator')) return 'Open tour screen-share device modal (onTourSelectSourceDeviceModal)';
  if (c.includes('screen-share-indicator')) return 'Run _screenStreamClickEvent() – start screen sharing';
  if (c.includes('web-link-indicator')) return 'Run _linkClickEvent(false, true) – open web link from indicator';
  if (c.includes('scene-change-indicator')) return 'Run _sceneChangeClickEvent() – navigate to another scene';
  if (c.includes('paypal-donation-indicator')) return 'Run _payPalDonationClickEvent() – PayPal donation flow';
  if (c.includes('chess-indicator')) return 'Run _chessGameClickEvent() and resize chess board';
  if (c.includes('info-indicator')) return 'Run _infoElementClickEvent() – open info modal';
  if (c.includes('video-player-indicator')) return 'Run onVideoPlayerClick() – play video';
  if (c.includes('shop-indicator')) return 'Run _shopLinkClickEvent() – shop';
  if (c.includes('embedded-webpage-indicator')) return 'Run _embeddedWebpageClickEvent()';
  if (c.includes('image-gallery-indicator')) return 'Run onImageGalleryClick()';
  return 'Clear last screen-share / peer-chair highlight borders (base .indicator handler)';
}

function describeViewCss3dClickAction(type) {
  const m = {
    vraiAgent: 'VAPI agent chair – DOM interaction / call (no extra switch case in view)',
    vapiUserCamera: 'User camera CSS3D – selection only',
    vapiTranscription: 'Transcription CSS3D – selection only',
    vapiButton: 'Agent button CSS3D – selection only',
    vapiCamera2: 'Camera mesh type – selection only',
    vapiTranscription2: 'Transcription mesh type – selection only',
  };
  return m[type] || `Select CSS3D-linked object (${type})`;
}

function describeViewRaytraceClickAction(meshType) {
  const m = {
    guestSeat: 'Run _chairClickEvent() – chair menu / seat',
    screenStream: 'Track screen-share seat highlight (mobile: addBorderHighlight)',
    sceneChange: 'Run _sceneChangeClickEvent() – change scene',
    webLink: 'Run _linkClickEvent() – open web link',
    baglessRoom: 'Run _linkClickEvent(true) – bagless room link',
    profile: 'Run _profileClickEvent()',
    userInfo: 'Run _userInfoEvent()',
    chessGame: 'Run _chessGameClickEvent()',
    chessAvatar: 'Run _chessGameAvatarClickEvent()',
    payPalDonation: 'Run _payPalDonationClickEvent()',
    shopLink: 'Run _shopLinkClickEvent()',
    infoElement: 'Run _infoElementClickEvent() – open info modal',
    embeddedWebpage: 'Run _embeddedWebpageClickEvent()',
    tourScreenShare: 'Run onTourScreenShareSelectedElement()',
    imageGallery: 'Run onImageGalleryClick()',
    seatCamera: 'Run onSeatCameraClick()',
    seatMic: 'Run onSeatMicrophoneClick()',
    videoGallery: 'Run onVideoGalleryClick()',
    videoPlayer: 'Run onVideoPlayerClick()',
    videoPlayerWebGL: 'Run onVideoPlayerClick()',
    vrMusicObject: 'Run _vrMusicObjectClickEvent() – trigger click actions only',
    vrInvisibleAction: 'Run _vrInvisibleActionClickEvent() – trigger click actions only',
    vapiCamera2: 'Camera component – no handler in switch (selection only)',
    vapiTranscription2: 'Transcription component – no handler in switch (selection only)',
  };
  return m[meshType] || `Raycast hit – check object type (${meshType})`;
}

class ModeView extends Scene3D {
  constructor(props) {
    if (!(props)) {
      console.log('No props ModeView!');
      return;
    }
    super(props);
    // console.log(props);

    const self = this;

    this.model = props.model;
    applyForcedWorldLanguage(this.model.sceneData);
    this.model.view = this;
    this.tracking = new UserTracking({ model: this.model });
    this._roomEnteredViaSceneChange = false;
    this._directEntryRoomEnteredScheduled = false;
    this._pendingRoomEntered = false;
    this._entryGateModalObserver = null;
    this._raycastHoverSourceId = null;
    this._clickHintTrackingActive = false;
    this._clickHintTrackingEnabled = false;
    this._clickHintInViewIds = new Set();
    this._clickHintOffFrames = new Map();
    this._clickHintFrame = 0;
    this._clickHintWorldPos = new Vector3();
    this._clickHintCamPos = new Vector3();
    this._clickHintCamDir = new Vector3();
    this._clickHintToMesh = new Vector3();
    this._onVapiAgentCallStarted = (e) => {
      const sourceId = e?.data?.vapiAgentId;
      this._executeEventActions(sourceId, 'callStarted');
    };
    this._onVapiAgentCallEnded = (e) => {
      if (e?.data?.sceneChange) return;
      const sourceId = e?.data?.vapiAgentId;
      // Defer so chair call-end handlers can snapshot transcript before chained actions (e.g. startCall).
      setTimeout(() => {
        this._executeEventActions(sourceId, 'callEnded');
      }, 0);
    };
    this.model.addEventListener('vapi-agent-call-start', this._onVapiAgentCallStarted);
    this.model.addEventListener('vapi-agent-call-end', this._onVapiAgentCallEnded);
    this._activeVapiTopStatusAgentId = null;
    this._activeVapiTopStatusState = '';
    this._activeVapiTopStatusMessage = '';
    this._setupVapiTopStatusIndicator();
    this._onVapiAgentTopStatusStarted = (e) => {
      const agentId = e?.data?.vapiAgentId ?? null;
      const agentName = e?.data?.vapiAgentName || '';
      this._activeVapiTopStatusAgentId = agentId;
      const state = this._activeVapiTopStatusState;
      const alreadyInConversation = state === 'agent' || state === 'agent-talking' || state === 'agent-thinking';
      // Web calls are listening when call-start fires. The websocket call is not
      // ready until a later in-progress status, so keep "Connecting to AI".
      if (e?.data?.listening && !alreadyInConversation) {
        this._activeVapiTopStatusState = 'agent';
        this._activeVapiTopStatusMessage = '';
      } else if (!alreadyInConversation) {
        this._activeVapiTopStatusState = 'connecting';
        this._activeVapiTopStatusMessage = '';
      }
      this._refreshVapiTopStatus(agentId, agentName);
    };
    this._onVapiAgentTopStatusEnded = (e) => {
      this._hideVapiTopStatus(e?.data?.vapiAgentId ?? null);
    };
    this._onVapiAgentTopStatusUpdated = (e) => {
      const state = e?.data?.state || '';
      const agentId = e?.data?.vapiAgentId ?? null;
      const agentName = e?.data?.vapiAgentName || '';
      const message = e?.data?.message || '';
      if (agentId != null) {
        this._activeVapiTopStatusAgentId = agentId;
      }
      if (this._isNormalVapiCallEnd(e?.data?.error) || this._isNormalVapiEndMessage(message)) {
        this._hideVapiTopStatus(agentId);
        return;
      }
      if (state === 'request-media' || state === 'connecting' || state === 'agent-thinking' || state === 'agent-talking' || state === 'agent') {
        this._activeVapiTopStatusState = state;
        this._activeVapiTopStatusMessage = message;
        this._refreshVapiTopStatus(agentId, agentName);
        return;
      }
      if (state === 'connect-failed' || state === 'no-assistant' || state === 'media-failed') {
        this._activeVapiTopStatusState = state;
        this._activeVapiTopStatusMessage = message || this._getVapiTopStatusErrorText(state, e?.data);
        this._refreshVapiTopStatus(agentId, agentName, true);
        return;
      }
    };
    this._onVapiAgentTopStatusError = (e) => {
      if (this._isNormalVapiCallEnd(e?.data?.error)) {
        this._hideVapiTopStatus(e?.data?.vapiAgentId ?? null);
        return;
      }
      const agentId = e?.data?.vapiAgentId ?? null;
      const agentName = e?.data?.vapiAgentName || '';
      const message = this._formatVapiAgentError(e?.data?.error)
        || ((typeof $trans !== 'undefined' && $trans('vrai-agent-connect-failed')) || 'Connection failed');
      if (agentId != null) {
        this._activeVapiTopStatusAgentId = agentId;
      }
      this._activeVapiTopStatusState = 'connect-failed';
      this._activeVapiTopStatusMessage = message;
      this._refreshVapiTopStatus(agentId, agentName, true);
    };
    this._onVapiTopStatusSceneChange = () => {
      this._hideVapiTopStatus();
    };
    this.model.addEventListener('vapi-agent-call-start', this._onVapiAgentTopStatusStarted);
    this.model.addEventListener('vapi-agent-call-end', this._onVapiAgentTopStatusEnded);
    this.model.addEventListener('vapi-agent-status', this._onVapiAgentTopStatusUpdated);
    this.model.addEventListener('vapi-agent-error', this._onVapiAgentTopStatusError);
    this.model.addEventListener(SCENE_EVENTS.START_SCENE_CHANGE, this._onVapiTopStatusSceneChange);

    ///initial setup
    this.model.userWantsAudio = true;
    this.model.userWantsCamera = true;
    //this.config = props.CONFIG;

    // VALIDATE TICKET IF PAID LOCATION
    this.validateTicketIfPaidLocation().then((valid) => {
      const redirectURL = `https://bagless.io/spaces/`;
      !valid && (window.location.href = redirectURL);
    });
    // Prevent object interaction while orbiting around
    this.controlsActive = true;

    this.model.userAvatarTexture = this.textureLoaderSilent.load(this.getAvatar());
    let hasLowRes = (this.model.sceneHasLowResImage[this.currentScene.id]);
    if (hasLowRes) {
      hasLowRes = getLowResImageUrl(this.currentScene.background.mediumPath)
      const backgroundDiv = document.getElementById('background');
      if (backgroundDiv) {
        backgroundDiv.style.backgroundImage = 'url(' + hasLowRes + ')';
      }
    } else {
      this.webglRenderer.setClearColor(0x000000, 1);
    }

    this._viewModeControls(this);
    this._initClickPointAnimation();

    this.model.iStream.video = true;
    this.iSit = false;
    this.readyForClick = true;

    this.isDividerDragging = false;
    this.tourModeBanner = $("#tour_mode_banner");
    this.assistModeBanner = $("#assist_mode_banner");
    this.guideModeBanner = $("#guided_mode_banner");

    this.isSessionDeactivated = false;
    this.intervalDeactivate = null;
    this.intervalSkipDeactivation = null;
    this.intervalDeactivateDelay = 30 * 60; // 30 minutes
    this.modalDeactivateDelay = 60; // 60 seconds

    this.settingMenu = new SettingMenu({ model: this.model, socket: props.socket });
    this.settingMenu.deviceSettingMenu.onSaveCallBack = () => {
      this.model.streamController.userSetNewCamera()
    }
    this.deviceSettingsMenu = this.settingMenu.deviceSettingMenu

    this.spaceConsentModal = new SpaceConsentModal({ model: this.model });
    this.guestWelcomeModal = new GuestWelcomeModal({ model: this.model })
    this.chairInviteModal = new ChairInvite({ model: this.model, socket: this.model.socket });
    this.chessInviteModal = new ChessInvite({ model: this.model, socket: this.model.socket });
    this.tourBanner = new TourBanner({ model: this.model });
    // this.selfCheckModal = new SelfCheckModal({ model: this.model })

    this.model.addEventListener(SCENE_EVENTS.USER_INIT_MODAL_CLOSE, () => {
      this.onStartIntroAnimations();
    });
    this.model.addEventListener(SCENE_EVENTS.TINY_WORLD_ANIMATION_ENDED, () => {
      this._scheduleDirectEntryRoomEntered();
      this._playClickableIndicatorHints();
      this._startClickHintTracking();
    });

    this.deviceCheckScreen = new InitDeviceCheck({ model: this.model, container: "#welcomeCheckModal" });
    this.deviceCheckScreen.close();
    if (this.preloaderCompleted) {
      this.onStartIntroAnimations();
    }

    /**
    * Crosshair
     */
    this.addCursor(false);

    this.autoDeactivateUser();

    // Allow edit mode only to the owner and contributor
    if (this.model.config.isContributor || this.model.config.isOwner || (this.model.config.role && this.model.config.role === "Admin")) {
      $('#toggleModes').show();
      $('#editRoom').show();
      $('#mobile-dropdown-editmode').show();
    } else {
      $('#toggleModes').hide();
      $('#editRoom').hide();
      $('#mobile-dropdown-editmode').hide();
      $('#mobile-dropdown-editmode').hide();
      $('#showSpaceEditRoom').hide();

    }
    this.tourStartMenu = new TourStartMenu({ model: this.model });
    let locationDropDownMenu = isNavigationMenuEnabled(this.model.sceneData);
    if (locationDropDownMenu) {
      this.locationMenu = new LocationMenu({ model: this.model })
    } else {
      $('.icon-compass, #locationsButton').addClass('disabled');
      // $("#location_menu_toggle").remove();
    }

    $(".settings-menu").remove();
    $(".bottom-bar-room-settings").remove();

    /**
     * Event listeners
     */

    this.model.addEventListener(SCENE_INTERACTION.SOCKET_USER_INFO_CHANGE_REQUESTED, (e) => {
      this._applyRequestedSeatMicState(e);
    });

    this.webRTCScopeType = null;

    this.switchTo3dRenderEvents = [SCENE_EVENTS.TOUR_CONTROLLER_INITIALIZED, SCENE_EVENTS.TOUR_MODE_STARTED];
    this.switchTo3dRenderEvents.forEach((eventName) => {
      this.model.addEventListener(eventName, (e) => {
        this.customRenderMode = false;
        this.render3DWorld = true;
      })
    });
    this.model.addEventListener(SCENE_EVENTS.OPEN_CHESS_MODAL, (e) => {
      console.log("OPEN_CHESS_MODAL", e);
      if (this.filtered3DObjects.chessGame && this.filtered3DObjects.chessGame.length > 0 && e?.data?.gameId) {
        this.filtered3DObjects.chessGame.forEach((item) => {
          if (e?.data?.gameId === item.dbConfig.id) {
            this.elementSelected = item.mesh;
            this._chessGameClickEvent();
          }
        });
      }
    });
    this.model.addEventListener(SCENE_INTERACTION.TAKE_FIRST_EMPTY_SEAT, async (e) => {
      this.model.autoSeat = false;
      if (this.model.sceneData.space_type !== 'premium') {
        if (!await this.model.validatePlanFeature(FEATURE_NAMES.TAKE_SEAT)) {
          if (window.openLoginModal) {
            window.openLoginModal($trans('you-need-to-login-to-take-a-seat'));
          }
          return;
        }
      }
      const onInit = async () => {
        const emptyChair = this.areThereEmptyChairs();
        if (emptyChair) {
          // $("#submit_take_seat").trigger('click')
          const rotateToCamera = () => {
            this.model.removeEventListener(SCENE_EVENTS.TINY_WORLD_ANIMATION_ENDED, rotateToCamera)
            this.animateCameraLookAtVector(new Vector3(), 0);
            this.animateCameraLookAt(emptyChair);
          }
          this.model.addEventListener(SCENE_EVENTS.TINY_WORLD_ANIMATION_ENDED, rotateToCamera);
          if (!(await requestMediaPermissions('all', this.model))) {
            return
          }

          await this.model.streamController.startCamera();
          // this.model.streamController.cameraJoinRoom();
          this.takeSeatNoPrompt(emptyChair);

        } else {
          this.model.alert("success", $trans('no-empty-seat-text'))
          this.model.confirm($trans('empty-seat-reminder-text'), () => {
            this.checkSeatAvailableTimer = setInterval(() => {
              const emptyChair = this.areThereEmptyChairs();
              if (emptyChair) {
                this.checkSeatAvailableTimer && clearInterval(this.checkSeatAvailableTimer)
                this.model.confirm($trans('empty-seat-reminder-text'), async () => {
                  if (emptyChair.state.occupied) {
                    this.model.alert('error', `${$trans('error-take-seat')}!`);
                    return;
                  }
                  await this.model.streamController.startCamera();
                  // this.model.streamController.cameraJoinRoom();
                  this.takeSeatNoPrompt(emptyChair);
                  // this.animateCameraLookAt(emptyChair);
                }, null, () => {
                })

              } else {

              }
            }, 3000)
          }, { header: true, title: $trans('empty-seat-reminder-text') }
          );
        }
      }

      if (!this.model.socket.initUsers) {
        this.model.socket.addEventListener(SOCKET_EVENTS.INIT_USERS, onInit)
      } else {
        onInit();
      }

    });
    this.model.addEventListener(SCENE_EVENTS.CUSTOM_TAKE_SEAT, (e) => {
      const { obj_id, senderId } = e.payload;
      const _obj = this.find3dObject(obj_id);
      const user = this.model.socket.getUsersObject()[senderId];
      if (_obj) {
        this.elementSelected = _obj;
        // this.lookAtObject(this.elementSelected)
        const message = `${user.userName} ${$trans('is-inviting-you-to-take-seat')}`;
        this.model.confirm(message, () => {
          this._chairClickEvent(true);
          this.animateCameraLookAt(this.elementSelected.parent);
        }, null, () => {
          this.model.socket.sendNotificationToUser(senderId, $trans('user-declines-your-request-to-take-a-seat'), { icon: 'cancel' });
        })
      } else {
        const sceneId = this.findSceneFromObjectId(obj_id);
        const message = `${user.userName} ${$trans('is-inviting-you-to-take-seat')}`;
        this.model.confirm(message, () => {
          this.model.dispatchEvent({
            type: SCENE_INTERACTION.JUMP_TO_SCENE, data: {
              sceneId: sceneId,
              onComplete: () => {
                const _obj = this.find3dObject(obj_id);
                this.elementSelected = _obj;
                this._chairClickEvent(true);
                const rotateToObjectCallback = () => {
                  this.model.removeEventListener(SCENE_EVENTS.SCENE_CHANGED_ANIMATION_ENDED, rotateToObjectCallback)
                }
                this.model.addEventListener(SCENE_EVENTS.SCENE_CHANGED_ANIMATION_ENDED, rotateToObjectCallback);
              }
            }
          });
        }, null, () => {
          this.model.socket.sendNotificationToUser(senderId, $trans('user-declines-your-request-to-take-a-seat'), { icon: 'cancel' });
        })
      }
    });

    $("#videoGalleryModal .modal-background").on("click", () => {
      this.model.dispatchEvent({ type: SCENE_INTERACTION.STOP_VIDEO_ON_CLICK });
      if (this.model.iAmGuide()) {
        this.model.socket.socketTour.onTourClicked({ type: "closeVideo" });
      }
    })
    $("#infoElementModal .modal-background").on("click", () => {
      this.model.dispatchEvent({ type: SCENE_INTERACTION.STOP_VIDEO_ON_CLICK });
      if (this.model.iAmGuide()) {
        this.model.socket.socketTour.onTourClicked({ type: "closeModal" });
      }
    })
    $("#infoElementModal .modal-background").on("click", () => {
      this.model.dispatchEvent({ type: SCENE_INTERACTION.STOP_VIDEO_ON_CLICK });
      if (this.model.iAmGuide()) {
        this.model.socket.socketTour.onTourClicked({ type: "closeModal" });
      }

    })
    $("#videoGalleryModal .close-modal").on("click", () => {
      this.model.dispatchEvent({ type: SCENE_INTERACTION.STOP_VIDEO_ON_CLICK });
      if (this.model.iAmGuide()) {
        this.model.socket.socketTour.onTourClicked({ type: "closeVideo" });
      }
    })

    this.model.addEventListener(CUSTOM_TOUR_EVENTS.PROFILE_CLICK, (e) => {
      console.log(e.data)
      this.filtered3DObjects["profile"].forEach((item) => {
        if (e.data.dbConfig.id === item.dbConfig.id) {
          item.showInfo();
        }
      });

    });
    this.model.addEventListener(CUSTOM_TOUR_EVENTS.START_VIDEO, (e) => {
      $("#videoGalleryModal").addClass("is-active");
      const video = $("#videoGalleryVideo")[0];
      video.src = e.data.dbConfig.url;
      video.load();
      video.play();
    });

    this.model.addEventListener(SCENE_EVENTS.START_SCENE_CHANGE, (e) => {
      const video = $("#videoGalleryVideo")[0];
      video && video.pause();
      // Drop stale raycast-hover target so the next scene starts fresh.
      this._raycastHoverSourceId = null;
      this._clickHintTrackingActive = false;
      this._resetClickHintTracking();
    });

    this.model.addEventListener(SCENE_EVENTS.STOP_SCENE_CHANGE, () => {
      if (!this._clickHintTrackingEnabled) return;
      this._resetClickHintTracking();
      this._clickHintTrackingActive = true;
    });

    this.model.addEventListener(CUSTOM_TOUR_EVENTS.INFO_CLICK, (e) => {
      this.filtered3DObjects["infoElement"].forEach((item) => {
        (e.data.dbConfig.id === item.dbConfig.id) && item.openModal();
      });
    });
    this.model.addEventListener(CUSTOM_TOUR_EVENTS.IFRAME_CLICK, (e) => {
      console.log(e.data)
      this.filtered3DObjects["embeddedWebpage"].forEach((item) => {
        if (e.data.dbConfig.id !== item.dbConfig.id) {
          return;
        }
        item.openModal();
      });
    });
    this.model.addEventListener(CUSTOM_TOUR_EVENTS.IMAGE_GALLERY, (e) => {
      console.log(e.data)
      this.filtered3DObjects["imageGallery"].forEach((item) => {
        if (e.data.dbConfig.id !== item.dbConfig.id) {
          return;
        }
        item.openModal();
      });
    });
    this.model.addEventListener(CUSTOM_TOUR_EVENTS.CLOSE_MODALS, (e) => {
      $(".modal").each((index, item) => {
        $(item).removeClass("is-active")
      })
    });
    this.model.addEventListener(CUSTOM_TOUR_EVENTS.SCENE_CHANGE, (e) => {
      const { dbConfig } = e.data;
      $(".modal").each((index, item) => {
        $(item).removeClass("is-active")
      })
      this.model.dispatchEvent({
        type: SCENE_INTERACTION.JUMP_TO_SCENE, data: {
          sceneId: dbConfig.goToSceneId,
        }
      })
    });
    $(".modal .close-modal").on("click", (e) => {
      if (this.model.iAmGuide()) {
        this.model.socket.socketTour.onTourClicked({ type: "closeModal" })
      }
    });
    this.model.addEventListener(ANT_MEDIA_SERVER_BAGELSS_EVENTS.USER_STARTED_PUBLISH_WITH_AUDIO, (e) => {
      this.turnOnAudioIcons();
    });
    this.model.addEventListener(ANT_MEDIA_SERVER_BAGELSS_EVENTS.ERROR_SCREEN_SHARE_PERMISSION_DENIED, (e) => {
      this.standUpFromScreenShare();
    });

    this.model.addEventListener(ANT_MEDIA_SERVER_BAGELSS_EVENTS.LEAVE_ROOM_SUCCESS_SCREEN_SHARE, (e) => {
      this._stopScreenShare();
    });
    this.model.addEventListener(ANT_MEDIA_SERVER_BAGELSS_EVENTS.USER_STARTED_PUBLISH_WITH_NO_AUDIO, (e) => {
      this.turnOffAudioIcons()
    });
    this.model.addEventListener(ANT_MEDIA_SERVER_BAGELSS_EVENTS.USER_STARTED_PUBLISH_WITH_VIDEO, (e) => {
      this.turnOnVideoIconFromUserMenu()
    });
    this.model.addEventListener(ANT_MEDIA_SERVER_BAGELSS_EVENTS.USER_STARTED_PUBLISH_WITH_NO_VIDEO, (e) => {
      this.turnOffVideoIconFromUserMenu()
    });
    this.model.addEventListener(SCENE_EVENTS.CLOSE_SCREEN_SHARE_MENU, (e) => {
      this.closeScreenShareMenu()
    });

    const udpateScreenShareButtonHideEventsFromModel = [
      SCENE_INTERACTION.USER_TAKES_SEAT,
      SCENE_INTERACTION.USER_TAKES_SCREEN_SHARE_SEAT,
      SCENE_INTERACTION.SET_OCCUPIED_SEATS,
      SCENE_INTERACTION.SET_OCCUPIED_SCREEN_SHARE_SEATS,
    ];
    const udpateScreenShareButtonHideEventsFromSocket = [
      SCENE_EVENTS.USER_CHANGED_SCREEN_SHARE_SEAT,
      SCENE_EVENTS.USER_LEAVES_SCREEN_SHARE
    ];

    udpateScreenShareButtonHideEventsFromModel.forEach((eventName) => {
      this.model.addEventListener(eventName, () => {
        if (!this.model.socket.isAnybodyStreaming()) {
          this.model.dispatchEvent({ type: SCENE_EVENTS.SHOW_SCREEN_SHARE_BUTTON_IN_OWN_USER_MENU })
        } else {
          this.model.dispatchEvent({ type: SCENE_EVENTS.HIDE_SCREEN_SHARE_BUTTON_IN_OWN_USER_MENU })
        }
      });
    });

    udpateScreenShareButtonHideEventsFromSocket.forEach((eventName) => {
      this.model.addEventListener(eventName, () => {
        if (!this.model.socket.isAnybodyStreaming()) {
          this.model.dispatchEvent({ type: SCENE_EVENTS.SHOW_SCREEN_SHARE_BUTTON_IN_OWN_USER_MENU })
        } else {
          this.model.dispatchEvent({ type: SCENE_EVENTS.HIDE_SCREEN_SHARE_BUTTON_IN_OWN_USER_MENU })
        }
      });
    });

    this.model.addEventListener(SCENE_EVENTS.GUIDED_MODE_START, (e) => {
      if (this.model.chessGameMode) {
        this.leaveChessGameAndBackToViewMode();
      }
      this.guideButton.addClass("navbar-button-active");
      this.guideButton.addClass("disabled");
      this.guideModeBanner.removeClass("hidden");
      this.followCursor.hide();
      $(".indicator").each((index, item) => {
        $(item).addClass("is-tour-mode")
      })
      const landscapeWarning = $("#orientation-warning");
      if (landscapeWarning) {
        landscapeWarning.addClass("tour-mode")
      }
      this.addIsTourModeClassToIndicators();
    });
    this.model.addEventListener(SCENE_EVENTS.GUIDED_MODE_STOP, (e) => {
      this.guideButton.removeClass("navbar-button-active");
      this.guideButton.removeClass("disabled");
      this.guideModeBanner.addClass("hidden");
      this.removeIsTourModeClassFromIndicators();
      const landscapeWarning = $("#orientation-warning");
      if (landscapeWarning) {
        landscapeWarning.removeClass("tour-mode")
      }
    });
    this.model.addEventListener(SCENE_EVENTS.TOUR_MODE_STARTED, (e) => {
      this.model.info('info', `Tour started`);
      this.tourModeBanner.removeClass("hidden");
      this.enableDeviceOrientationControl = false;
      this.device.disable();
      $("#useDeviceOrientation").hide();
      this.addIsTourModeClassToIndicators();
      this.controls.enabled = false;
      const landscapeWarning = $("#orientation-warning");
      if (landscapeWarning) {
        landscapeWarning.addClass("tour-mode")
      }
    });

    this.model.addEventListener(SCENE_EVENTS.TOUR_MODE_ENDED, (e) => {
      this.tourModeBanner.addClass("hidden");
      this.followCursor.hide();
      this.device.enable();
      this.enableDeviceOrientationControl = true;
      $("#useDeviceOrientation").show();
      this.removeIsTourModeClassFromIndicators();
      this.controls.enabled = true;
      const landscapeWarning = $("#orientation-warning");
      if (landscapeWarning) {
        landscapeWarning.removeClass("tour-mode")
      }
    });

    this.model.addEventListener(WEBRTC_EVENTS.WEBRTC_FAILED_TO_START_USER_VIDEO, (e) => {
      this.model.iStream.video = false;
      this.iSit = false;
      this.readyForClick = true;
      this.model.hideLoading()
      this.model.alert('error', $trans('error-camera-start'), { dataLang: 'error-camera-start' });
    });

    this.model.addEventListener(SCENE_EVENTS.UPDATE_TOUR_UI_ON_SOCKET_DATA, (e) => {
      this.updateGuideButtonVisibility();
      const tour = this.model.iAmInTour();
      if (tour) {
        this.guideButton.addClass("disabled");
      } else {
        if (this.isTourModeAvailable()) {
          this.guideButton.removeClass("disabled");
        } else {
          this.guideButton.addClass("disabled");
        }
      }
      const mySocketId = this.model.socket.getUserData().socketId;
      this.tourModeBanner.addClass("hidden");
      this.guideModeBanner.addClass("hidden");
      this.assistModeBanner.addClass("hidden");
      if (tour) {
        const { owner, contributors, users } = tour;
        if (owner === mySocketId) {
          ///You are guide
          this.guideModeBanner.removeClass("hidden");
          return;
        }
        if (contributors && contributors.filter(contributor => contributor === mySocketId).length > 0) {
          this.assistModeBanner.removeClass("hidden");
          return;
        }
        if (users && users.filter(user => user === mySocketId).length > 0) {
          /// Tou are guest
          this.tourModeBanner.removeClass("hidden");
          return;
        }
      }
    });

    this.model.addEventListener(SCENE_EVENTS.SOMEONE_JOINED_ROOM, (e) => { //TODO username on save
      const users = this.model.socket.getUsers();
      if (users.length === 2) {
        // Not show notification if notification settings turned off
        if (!notificationSettings.peerJoined) {
          return
        }

        const payload = e.data;
        const locationName = this.model.sceneData.name;
        const usersRooms = this.model.getSceneNameFromId(payload.currentSceneId)
        this.model.playAudioNotification('enter1');
        this.model.info('info', `${payload.userName} ${$trans('info-join')} ${locationName}`, { icon: ICON.JOIN });
        this.model.info('info', `${payload.userName} ${$trans('info-enter')} ${usersRooms}`, { icon: ICON.JOIN });
      }
    });

    this.model.addEventListener(SCENE_EVENTS.SOMEONE_LEAVED_ROOM, (e) => {
      // Not show notification if notification settings turned off
      if (!notificationSettings.peerLeave) {
        return
      }

      const payload = e.data;
      this.model.playAudioNotification('leave1');
      const locationName = payload.currentSceneName || this.scenes[0].publicName;
      this.model.alert('error', `${payload.userName} ${$trans('error-left-the')} ${locationName}`);
    });

    this.model.addEventListener(SCENE_EVENTS.START_ANIMTAION_OUTRO, (e) => {
      Object.values(this.sphereController.vrSpheres).forEach((vrSphere) => {
        vrSphere.sphereGroup.visible = false;
      });
      const cameraDirection = new Vector3();
      this.camera.getWorldDirection(cameraDirection);
      const fromPosition = cameraDirection.multiplyScalar(12000);
      const { onEndCallback, onStartCallback } = e.data;
      gsap.to(this.roomGroup.position, {
        duration: .75,
        x: fromPosition.x, y: fromPosition.y, z: fromPosition.z,

        ease: Circ.easeIn,
        onStart: () => {
          onStartCallback && onStartCallback();
          this.model.hideSceneElements();
          $(".indicator").addClass('opacity');
          this.model.dispatchEvent({ type: SCENE_EVENTS.START_TINY_ANIMATION_OUTRO });

        },
        onComplete: () => {
          onEndCallback && onEndCallback();
          this.model.dispatchEvent({ type: SCENE_EVENTS.END_TINIY_ANIMATION_OUTRO });
        }
      })
    });

    this.model.addEventListener(SCENE_INTERACTION.START_ANIMATION, (e) => {
      this.controlsActive = false;
      this.controls.enabled = false;
      this.setControlsUpdate(false);
      this.camera.rotateOnWorldAxis(new Vector3(0, 1, 0), this.pivot.rotation.y);
      this.pivot.rotation.y = 0;
    });

    this.model.addEventListener(SCENE_INTERACTION.STOP_ANIMATION, (e) => {
      this.setControlsUpdate(true);
      this.controls.enabled = true;
      this.controlsActive = true;
    });
    this.model.addEventListener(SCENE_INTERACTION.PLAY_SOUND, (e) => {
      this.model.playAudioNotification(e.url)
    });
    this.model.addEventListener(SCENE_EVENTS.TOUR_MODE_STARTED, (e) => {
      this.elements2dTour.forEach(item => {
        item.removeClass("taken");
        item.addClass("visible");
      })
      // this.elements2dnormal.forEach(item => {
      //   item.removeClass("visible");
      //   item.addClass("taken");
      // })
      this.standUpFromChair();
      this.standUpFromScreenShare();
    });
    this.model.addEventListener(SCENE_EVENTS.TOUR_MODE_ENDED, (e) => {
      this.elements2dTour.forEach(item => {
        item.removeClass("visible");
        item.addClass("taken");
      })
      this.elements2dnormal.forEach(item => {
        item.removeClass("taken");
        item.addClass("visible");
      })
    });
    this.model.addEventListener(SCENE_EVENTS.GUIDED_MODE_START, (e) => {
      this.elements2dTour.forEach(item => {
        item.removeClass("taken");
        item.addClass("visible");
      })
      // this.elements2dnormal.forEach(item => {
      //   item.removeClass("visible");
      //   item.addClass("taken");
      // });
      this.standUpFromChair();
      this.standUpFromScreenShare();
      ///TODO_WEBRTC
      //webrtc.leaveRoom();
    });
    this.model.addEventListener(SCENE_EVENTS.GUIDED_MODE_STOP, (e) => {
      this.elements2dTour.forEach(item => {
        item.removeClass("visible");
        item.addClass("taken");
      })
      this.elements2dnormal.forEach(item => {
        item.removeClass("taken");
        item.addClass("visible");
      })
    });

    this.model.addEventListener(SCENE_INTERACTION.CUSTOM_CHANGE_SCENE, (e) => {
      const { element, onComplete } = e.data;
      this._sceneChangeClickEvent(element, onComplete);
    });

    this.model.addEventListener(WEBRTC_EVENTS.WEBRTC_SOME_VIDEO_STARTED, () => {
      $(".localVideoWrapper").hasClass('grid-mode') && this.model.calculateGridDimensions();
    });

    this.model.addEventListener(WEBRTC_EVENTS.WEBRTC_SOME_VIDEO_STOPPED, () => {
      $(".localVideoWrapper").hasClass('grid-mode') && this.model.calculateGridDimensions();
    });

    this.model.addEventListener(SCENE_EVENTS.SOMEONE_CHANGED_DATA, () => {
      $(".localVideoWrapper").hasClass('grid-mode') && this.model.calculateGridDimensions();
    });

    this.model.addEventListener(SOCKET_EVENTS.REQUEST_RECEIVED, (e) => {
      const { wantedSceneId, senderName } = e.data;
      if (wantedSceneId.toString() !== this.model.currentScene.id) {
        return;
      }
      if (parent.currentUser) {
        this.model.sendRequestToUser = parent.currentUser;
        // this.model.selectedElement = el;
      }
      const promptMessage = senderName + `${$trans('ask-for-unlock')}`;
      this.model.confirm(promptMessage, () => {
        this.model.approveEnterRoomrequest(true);
      }, { header: true, title: 'Somebody is at the door' },
        () => {
          this.model.approveEnterRoomrequest(false, "")
        }
      );
    });

    this.model.addEventListener(SOCKET_EVENTS.REQUEST_ACCEPTED, (e) => {
      const { wantedSceneId, senderId } = e.data;
      if (!this.model.iWantToScene) {
        this.model.clearLockRequestData();
        this.model.dispatchEvent({ type: NOTIFICATION_EVENTS.CLOSE });
        return;
      }
      if (e.data.approve) {
        this._sceneChangeClickEvent(this.model.selectedElement, null, true);
      } else {
        const reason = (e.data.text === "") ? $trans('no-reason-text') : e.data.text;
        this.model.alert('error', `${$trans('error-user-declined-request')} (${reason})`, { icon: ICON.CANCEL });
      }
      this.model.clearLockRequestData();
    });
    this.model.addEventListener(SCENE_INTERACTION.JUMP_TO_SCENE, (e) => {
      ///search for current room scene change object
      let sceneChangeObject = false;
      if (!e.data.hasOwnProperty('linearAnimation')) {
        this.filtered3DObjects[SCENE_OBJECT_TYPES.sceneChange] && this.filtered3DObjects[SCENE_OBJECT_TYPES.sceneChange].map(item => {
          if (e.data.sceneId === item.targetRoomId) {
            const data = {
              element: item.mesh,
              onComplete: e.data.onComplete ? e.data.onComplete : null,
            };
            this.model.customSceneChange(data);
            sceneChangeObject = true;
            return;
          }
        })
      }
      if (sceneChangeObject) {
        return;
      }
      ///if 0 sceneChange objects animate to pointingMesh
      const element = this.cameraPointingMesh;
      this.model.nextSceneId = e.data.sceneId || e.data.currentSceneId;
      // element.dbConfig = item;
      const data = {
        element: element,
        onComplete: e.data.onComplete ? e.data.onComplete : null,
      };
      this.model.customSceneChange(data)
    });


    this.addSocketListeners = (socket) => {
      $("#ownerIsFriend").hide();
      socket.addEventListener(SOCKET_EVENTS.USER_JOINED_SCENE, (e) => {
        const user = socket.getUsersObject()[e.data.senderId];
        const me = socket.getUsersObject()[this.model.config.userId];
        const tourStarted = this.model.iAmInTour();
        if (!tourStarted) {
          return
        }
        const guide = socket.getUserBySocketId(tourStarted.owner);
        if (guide.userId === user.userId) {
          if (user.currentSceneId === me.currentSceneId) {
            return;
          }
          this.model.nextSceneId = user.currentSceneId;
          this.model.dispatchEvent({
            type: SCENE_INTERACTION.JUMP_TO_SCENE, data: {
              sceneId: user.currentSceneId
            }
          });
        }
      })
      socket.addEventListener(SOCKET_EVENTS.USER_LEFT_SCENE, (e) => {
        // const { payload } = e;
        // const socketMe = socket.getUserData();
        // const user = socket.getUsers()[payload.senderId];
        // areInSameScene(user, socketMe, this.model.sceneData.scenes) && this.model.alert('error', `${user.userName} leaves ${user.currentSceneName}`);
      });
      socket.addEventListener(SOCKET_EVENTS.OFFLINE_MESSAGE_SENT, (e) => {
        this.model.info('success', $trans('offline-message-sent'));
      });
    }

    if (this.model.socket) {
      this.addSocketListeners(this.model.socket);
    } else {
      this.model.addEventListener(MODEL_EVENTS.SOCKET_READY, (e) => {
        this.addSocketListeners(e.socket);
      });
    }


    // Toggle the 'is-mobile-mode' class based on the current device type
    const processMobileMode = () => {
      const isMobileMode = isMobile();
      $('body').toggleClass('is-mobile-mode', isMobileMode)
      $('body').toggleClass('is-desktop-mode', !isMobileMode)
      if (!isMobileMode) {
        $('body').removeClass('is-portrait-mode');
        $('body').removeClass('is-landscape-mode');
      } else if (window.matchMedia("(orientation: portrait)").matches) {
        $('body').addClass('is-portrait-mode');
        $('body').removeClass('is-landscape-mode');
      } else {
        $('body').addClass('is-landscape-mode');
        $('body').removeClass('is-portrait-mode');
      }
    }

    let windowResizeDebounce;
    // Listen for window resize events and debounce the execution to prevent excessive updates
    window.addEventListener('resize', () => {
      clearTimeout(windowResizeDebounce);
      windowResizeDebounce = setTimeout(() => {
        // Recalculate grid dimensions if the element is in grid mode
        $(".localVideoWrapper").hasClass('grid-mode') && this.model.calculateGridDimensions();

        processMobileMode()
      }, 200);
    });
    window.addEventListener("pageshow", () => {
      processMobileMode()
    })

    // Initial check to set 'is-mobile-mode' class on page load
    processMobileMode()

    if (window.visualViewport) {
      let resizeTimeout;

      window.visualViewport.addEventListener("resize", () => {
        clearTimeout(resizeTimeout);

        resizeTimeout = setTimeout(() => {
          const newHeight = window.visualViewport.height;
          const modals = document.querySelectorAll(".keyboard-responsive-modal");
          modals.forEach(modal => {
            if (modal.offsetParent !== null && newHeight !== window.innerHeight) {
              modal.style.height = `${newHeight}px`;
            } else {
              modal.style.removeProperty('height');
            }
          });

          const visibleModal = $('.keyboard-responsive-modal:visible');
          if (isIOS()) {
            if (visibleModal.length) {
              visibleModal.css('height', `${newHeight}px`);
            } else {
              visibleModal.css('height', '');
            }
          } else if (visibleModal.length) {
            pushMeta('viewport', 'interactive-widget', 'resizes-content')
          } else {
            unshiftMeta('viewport', 'interactive-widget')
          }
        }, 100);
      });
    }


    /**
     * GRID TOGGLE BUTTON
     */
    $("#gridToggle").on('click', () => {
      this.handleGridToggle();
    });

    $(document).on('click', '.video-wrapper', function () {
      if ($(this).parent()[0].id !== 'localVideoContainer')
        return;

      $(".video-wrapper").not(this).removeClass('focus');
      $(this).toggleClass('focus');

      if ($(this).hasClass('focus')) {
        $("#focused-video").get(0).srcObject = $(this).children('video').get(0).srcObject;
        $("#focused-avatar").attr('src', $(this).children('img')[0].src);
        $("#focused-label").html($(this).children('div')[0].innerText);
        $("#active-focused-element").val($(this).children('video').get(0).id);

        $(".focused_element").toggleClass('hidden', $(this).hasClass('hidden'));

        $(".grid-mode").addClass('focus-mode');
        window.activateOwnVideoInsideGrid(); ////TODO REMOVE

      } else {
        self.resetFocusMode();
        self.model.calculateGridDimensions();
        window.activateOwnVideoInsideGrid(); ////TODO REMOVE
      }
    });


    //* Device setting dialog */

    $('#submit_media_settings').on("click", async (e) => {
      let audio = $("#settings_microphone").val();
      let video = $("#settings_camera").val();
      let soundDevice = $(".speakerSelect").val();

      video = this.deviceSettingsMenu.selected.camera.value;
      audio = this.deviceSettingsMenu.selected.microphone.value;
      ///TODO_WEBRTC
      // video && webrtc.switchVideo(video);
      // audio && webrtc.switchAudio(audio);
      // webrtc.onPublishEnableOrDisableVideo();
      this.closePreviewVideoModal();
      this.model.switchNewCameraVideo();
      if (video) {
        this.deviceSettingsMenu.selected.camera.value = video;
      } if (audio) {
        this.deviceSettingsMenu.selected.microphone.value = audio;
      }
    });

    /**
     * TAKE SEAT take seat
     */
    document.getElementById('submit_take_seat').addEventListener('click', async (e) => {
      const withAudio = $('#startStreamWithAudio').prop('checked');
      const withCamera = $('#startStreamWithVideo').prop('checked');

      let microphoneDevice = $("#useThisMicrophone").val();
      let cameraDevice = $("#useThisCamera").val();
      let soundDevice = $(".speakerSelect").val();

      await this.model.streamController.startCamera();
      this.model.streamController.cameraJoinRoom();

      e.preventDefault();

      if (cameraDevice) {
        this.deviceSettingsMenu.selected.camera.value = cameraDevice;
      } if (microphoneDevice) {
        this.deviceSettingsMenu.selected.microphone.value = microphoneDevice;
      } if (this.deviceSettingsMenu.selected.speaker.value) {
        this.deviceSettingsMenu.setAudioOutputForAllMedia(this.deviceSettingsMenu.selected.speaker.value);
      }
      localStorage.setItem('microphoneDevice', microphoneDevice);
      localStorage.setItem('cameraDevice', cameraDevice);
      localStorage.setItem('soundDevice', soundDevice);
      localStorage.setItem('takeSeatPresets', JSON.stringify({ withCamera, withAudio }));

      const parent = this.elementSelected.parent;

      if (parent.isEmpty()) {

        this.removeMeFromOtherChairs();
        this.model.iSitOnThisVRChair = parent;
        parent.takeSeat(this.model.iStream.video, this.model.userAvatarTexture);

        this.model.showLoading()

        this.readyForClick = false;
        // this.model.dispatchEvent({ type: WEBRTC_EVENTS.WEBRTC_START_SCOPE, data: { 'scopeType': 'scene', 'scopeId': this.currentScene.id, 'scopeName': this.currentScene.publicName, 'withCamera': withCamera, 'withAudio': withAudio, 'constraints': { microphoneDevice, cameraDevice } } });

        this.model.onTakeSeat(parent.dbConfig);
        this.animateCameraLookAt(this.elementSelected)

        this.iSit = true;
        // this.model.takeSeatConfirmModal();
      } else {
        this.model.alert('error', `${$trans('error-take-seat')} ${parent.getUserInfo().userName}!`);
      }
      this.closePreviewVideoModal();
      $(".take-seat").removeClass("is-active");
      this.model.hideLoading()
    });

    /**
     * CORRELATE CHECKBOXES
     */
    $("#startStreamWithVideoPuppet").on("change", function () { $("#startStreamWithVideo").prop("checked", $(this).prop('checked')); });
    $("#startStreamWithAudioPuppet").on("change", function () { $("#startStreamWithAudio").prop("checked", $(this).prop('checked')); });
    $("#startStreamWithVideo").on("change", function () { $("#startStreamWithVideoPuppet").prop("checked", $(this).prop('checked')); });
    $("#startStreamWithAudio").on("change", function () { $("#startStreamWithAudioPuppet").prop("checked", $(this).prop('checked')); });


    this.updateDeviceSelect = () => {
      var savedValueC = this.deviceSettingsMenu.selected.camera.value;
      var savedNameC = this.deviceSettingsMenu.selected.camera.name;

      if (savedValueC) {
        // Set the dropdown to the saved value
        $('.cameraSelect').val(savedValueC);

        // Update the UI to reflect the saved value
        $('.camera-select-container .select-selected').attr('data-value', savedValueC);
        $('.camera-select-container .select-selected').text(savedNameC);
      }
      var savedValueM = this.deviceSettingsMenu.selected.microphone.value;
      var savedNameM = this.deviceSettingsMenu.selected.microphone.name;

      if (savedValueM) {
        // Set the dropdown to the saved value
        $('.microphoneSelect').val(savedValueM);

        // Update the UI to reflect the saved value
        $('.microphone-select-container .select-selected').attr('data-value', savedValueM);
        $('.microphone-select-container .select-selected').text(savedNameM);
      }
      var savedValueS = this.deviceSettingsMenu.selected.speaker.value;
      var savedNameS = this.deviceSettingsMenu.selected.speaker.name;

      if (savedValueS) {
        // Set the dropdown to the saved value
        $('.speakerSelect').val(savedValueS);

        // Update the UI to reflect the saved value
        $('.speaker-select-container .select-selected').attr('data-value', savedValueS);
        $('.speaker-select-container .select-selected').text(savedNameS);
      }
    }

    /**
     * SPEAKER SELECT
    */
    $(".test-sound").on("click", (e) => {
      if (isPlaying(audiotest)) {
        audiotest.pause();
        audiotest.currentTime = 0;
        $(".test-sound").removeClass("active");
      } else {
        $(".test-sound").addClass("active");
        document.getElementById('audio-test').play();
      }
    });

    //stop audio test if modal is closed
    $('.take-seat, .media-settings-form, .shareOnScreen').on('click', function () {
      if (!$(this).hasClass('is-active')) {
        if (isPlaying(audiotest)) {
          audiotest.pause();
          audiotest.currentTime = 0;
        }
      }
    });


    /**
     * CLOSE CTA MENUS
     */
    this.openTourCtaMenu = () => {
      $("#tour-screen-share-menu").addClass("is-active");
    }
    $(".close-cta-menu").on("click", (e) => {
      $(e.currentTarget).parent().removeClass("is-active");
      this.model.lastScreenShareIClicked !== null && this.model.lastScreenShareIClicked.removeBorderHighlight();
      this.model.lastPeerChairIClicked !== null && this.model.lastPeerChairIClicked.removeBorderHighlight();
    });
    /**
     * CLOSE CTA TOUR MENU
     */
    $(".close-tour-cta-menu").on("click", (e) => {
      $(e.currentTarget).parent().removeClass("is-active");
    });

    /**
     * KNOCK CALLBACK
     */
    document.getElementById('enter_room_request').addEventListener('submit', (e) => {
      e.preventDefault();
    });
    $('#peer_info_video').on('click', async (e) => {
      if (!await this.model.validatePlanFeature(FEATURE_NAMES.VIDEO_CALLS)) {
        return;
      }

      let userId;
      if (this.model.userIWantToShowInfo) {
        userId = this.model.userIWantToShowInfo.userId;
      }
      if (this.elementSelected && this.elementSelected.type === "guestSeat") {
        userId = this.elementSelected.parent.userData.userId;
      }
      if (this.elementSelected && this.elementSelected.type === "profile") {
        userId = this.elementSelected.parent.dbConfig.profile.userId;
      }
      if (!userId || !this.model.isUserOnline(userId)) {
        // this.model.alert('error', "error");
        return
      }

      if (!(await requestMediaPermissions('all', this.model))) {
        return
      }

      this.model.startOneOnOneVideoCall(userId)
      $(".peer_info_modal").removeClass('is-active');
    });

    this.model.config.isGuest && $('#peer_info_chat').find('span').addClass('disabled');
    $('#peer_info_chat').on('click', async (e) => {
      if (!await this.model.validatePlanFeature(FEATURE_NAMES.ONE_TO_ONE_CHAT)) {
        return;
      }
      if (!this.elementSelected && this.model.userIWantToShowInfo) {
        $(".peer_info_modal").removeClass('is-active');
        if (this.model.isUserOnline(this.model.userIWantToShowInfo.id)) {
          this.model.socket.dispatchEvent({ type: SOCKET_EVENTS.ADD_ONE_ON_ONE_CHAT, data: this.model.userIWantToShowInfo });
        } else {
          this.model.dispatchEvent({
            type: SCENE_EVENTS.CREATE_OFFLINE_CHAT,
            data: this.model.userIWantToShowInfo,
          });
        }
        return;
      }
      let userId;
      if (this.model.userIWantToShowInfo) {
        userId = this.model.userIWantToShowInfo.userId;
      }
      if (this.elementSelected && this.elementSelected.type === "guestSeat") {
        userId = this.elementSelected.parent.userData.userId;
      }
      if (this.elementSelected && this.elementSelected.type === "profile") {
        userId = this.elementSelected.parent.dbConfig.profile.userId;
      }
      if (!userId || !this.model.isUserOnline(userId)) {
        this.model.dispatchEvent({ type: SCENE_EVENTS.CREATE_OFFLINE_CHAT, data: this.elementSelected.parent.dbConfig.profile });
        $(".peer_info_modal").removeClass('is-active');
        return;
      }
      this.model.dispatchEvent({ type: SCENE_EVENTS.ONE_ON_ONE_CHAT, item: this.model.socket.getUsersObject()[userId] });
      $(".peer_info_modal").removeClass('is-active');
      this.model.userIWantToShowInfo = null;
    });

    $("#peer_info_email").on('click', (e) => {
      $('#copy_container').val($(e.target).text());
      $('#copy_container').select();
      document.execCommand('copy');
      this.model.alert('success', $trans('success-email-copied'));
    });

    $('#peer_jump_to').on('click', async (e) => {
      if ($('#peer_jump_to').hasClass('disabled')) {
        return;
      }
      if (!await this.model.validatePlanFeature(FEATURE_NAMES.INVITE_JUMP_TO_USER)) {
        return;
      }

      let targetSceneId
      let targetWorldId
      if (this.model.userIWantToShowInfo) {
        targetSceneId = this.model.userIWantToShowInfo.currentSceneId
        targetWorldId = this.model.userIWantToShowInfo.worldId
      }
      if (this.elementSelected && this.elementSelected.type === "guestSeat") {
        targetSceneId = this.elementSelected.parent.userData.currentSceneId
        targetWorldId = this.elementSelected.parent.userData.worldId
      }
      if (this.elementSelected && this.elementSelected.type === "profile") {
        targetSceneId = this.elementSelected.parent.dbConfig.profile.currentSceneId
        targetWorldId = this.elementSelected.parent.dbConfig.profile.worldId
      }
      if (!targetSceneId) {
        return
      }

      const currentWorldId = this.model.socket.getUserData().worldId;
      if (targetWorldId && targetWorldId !== currentWorldId) {
        this.model.worldFetcher.getWorldIdSec(targetWorldId, (data) => {
          const callback = () => {
            window.location = `${window.location.protocol}//${window.location.host}/worlds/view?id=${targetWorldId}&security=${data.h}&loc=${targetSceneId}`;
          }
          this.model.dispatchEvent({ type: SCENE_EVENTS.START_ANIMTAION_OUTRO, data: { onEndCallback: () => { callback() } } })
          this.close();
        }, (error) => {
          console.log("error", error);
        })
      } else {
        this.model.dispatchEvent({
          type: SCENE_INTERACTION.JUMP_TO_SCENE,
          data: {
            sceneId: targetSceneId,
          },
        });
      }

      $(".peer_info_modal").removeClass('is-active');
      this.model.userIWantToShowInfo = null;
    })

    $("#toggleModes, .leave_preview_mode, .world-bottom-nav__area__leave-preview-mode, #editRoom, #showSpaceEditRoom").on('click', () => {
      this.model.hideSceneElements();
      this.model.dispatchEvent({ type: SCENE_EVENTS.START_ANIMTAION_OUTRO, data: { onEndCallback: null, onStartCallback: null } })
      const cameraPreservedAngle = this.cameraPreservedAngle(true);

      let url = '';
      if (location.hostname === "apprc.bagless.io" || location.hostname === "app.bagless.io" || location.hostname === "dev.bagless.io") {
        url = `https://${location.hostname}/worlds/update?id=${this.worldID}&rot=${cameraPreservedAngle}&loc=${this.currentScene.id}`;
      } else {
        url = `https://${location.hostname}/worlds/update?id=${this.worldID}&rot=${cameraPreservedAngle}&loc=${this.currentScene.id}`;
        // window.location.search = `?r=worlds%2Fupdate&id=${this.worldID}&rot=${cameraPreservedAngle}&loc=${this.currentScene.id}`;
      }
      if (this.model.previewMode) {
        this.model.markRestoreEditorDraft();
      }
      window.location = url;
      $("#show-space-info").removeClass('is-active');
    });

    $(".compass").addClass('hidden');
    $(".donation-title").text('Donation');

    $("#compass_cta").on("change", (e) => {
      $(".compass").toggleClass('hidden', !$(e.target).prop('checked'));
    });


    if (this.model.ifShopElementExists()) {
      // console.log('ShopElementExists!!!');
      const resizeObserver = new ResizeObserver((entries) => {
        const cr = entries[0].contentRect;
        if (cr.width > 0) {
          let left = parseInt($('#slider_left').val());
          if (left > 0) {
            // let slideWidth = $('.slider__slides').outerWidth();
            // slideWidth = slideWidth.toFixed(0);
            // slideWidth = parseInt(slideWidth);
            resizeSlider(cr.width);
          }
        }

      });

      resizeObserver.observe(document.querySelector('.slider__clip'));

      $('.shop_item_action_arrow').on('click', function (event) {

        event.preventDefault();
        let slideWidth = $('.slider__slides').outerWidth();
        slideWidth = slideWidth.toFixed(0);
        slideWidth = parseInt(slideWidth);
        let numOfSlides = $('.slider__slide').length;
        let slidesWidth = slideWidth * numOfSlides;
        slidesWidth = slidesWidth.toFixed(0); //no decimal, type is string
        slidesWidth = parseInt(slidesWidth); //converts string to num
        let left = parseInt($('#slider_left').val());
        let currentSlide = parseInt($('#slider_currentSlide').val());
        let newLeft = 0;
        let newCurrent = 0;

        if ($(this).hasClass('slider__prev')) {
          if (left === 0) { return; }
          newLeft = left - slideWidth;
          newCurrent = currentSlide - 1;
        } else {
          if (left === slidesWidth - slideWidth) { return; }
          newLeft = left + slideWidth;
          newCurrent = currentSlide + 1;
        }
        $('#slider_left').val(newLeft);
        $('#slider_currentSlide').val(newCurrent);
        changeSlide();

      });

      $('.slider__dots').on('click', 'span', function (event) {

        event.preventDefault();
        var clickedIndex = $(this).data('index');
        let slideWidth = $('.slider__slides').outerWidth();
        slideWidth = slideWidth.toFixed(0);
        let newLeft = slideWidth * clickedIndex;
        let newCurrent = clickedIndex;
        $('#slider_left').val(newLeft);
        $('#slider_currentSlide').val(newCurrent);

        changeSlide();

      });

      // if(this.isMobile){

      const xwiper = new Xwiper('.slider');

      xwiper.onSwipeLeft(() => {
        console.log('swipe left')
        let slideWidth = $('.slider__slides').outerWidth();
        slideWidth = slideWidth.toFixed(0);
        slideWidth = parseInt(slideWidth);
        let numOfSlides = $('.slider__slide').length;
        let slidesWidth = slideWidth * numOfSlides;
        slidesWidth = slidesWidth.toFixed(0); //no decimal, type is string
        slidesWidth = parseInt(slidesWidth); //converts string to num
        let left = parseInt($('#slider_left').val());
        let currentSlide = parseInt($('#slider_currentSlide').val());
        let newLeft = 0;
        let newCurrent = 0;
        if (left === slidesWidth - slideWidth) { return; }
        newLeft = left + slideWidth;
        newCurrent = currentSlide + 1;

        $('#slider_left').val(newLeft);
        $('#slider_currentSlide').val(newCurrent);
        changeSlide();
      });

      xwiper.onSwipeRight(() => {
        console.log('swipe right');
        let slideWidth = $('.slider__slides').outerWidth();
        slideWidth = slideWidth.toFixed(0);
        slideWidth = parseInt(slideWidth);
        let numOfSlides = $('.slider__slide').length;
        let slidesWidth = slideWidth * numOfSlides;
        slidesWidth = slidesWidth.toFixed(0); //no decimal, type is string
        slidesWidth = parseInt(slidesWidth); //converts string to num
        let left = parseInt($('#slider_left').val());
        let currentSlide = parseInt($('#slider_currentSlide').val());
        let newLeft = 0;
        let newCurrent = 0;

        if (left === 0) { return; }
        newLeft = left - slideWidth;
        newCurrent = currentSlide - 1;

        $('#slider_left').val(newLeft);
        $('#slider_currentSlide').val(newCurrent);
        changeSlide();

      });
      // }
    }



    this.prepareDonationModal();

    !this.model.config.isGuest && this.model.getMediaDevices();

    this.loadAmbientAudioPreset();

    this.resizeFocusedElement();

    this.guideButton = $("#guideButton");
    this.updateGuideButtonVisibility();
    this.guideButton.on('click', async () => {
      if (!this.isTourModeAvailable()) {
        return;
      }
      if (this.model.guidedMode || this.model.iAmGuide()) {
        return;
      }
      if (!this.model.config.subscriptionPlan?.plan?.features?.[FEATURE_NAMES.RUN_UNLIMITED_TOURS]?.availability) {
        if (window.openLoginModal) {
          window.openLoginModal($trans('you-need-to-login-to-run-guided-tours'));
        }
        this.model.alert('error', $trans('error-please-login'));
        return;
      }
      if (!(await requestMediaPermissions('all', this.model))) {
        return
      }

      const openTourMenu = () => {
        this.tourStartMenu?.toggle();
      };
      if (this.model.spectatorMode) {
        this.deviceCheckScreen.showMediaRequestModal({
          onSave: () => {
            ParticipantMode.hideButton();
            openTourMenu();
          }
        })
      } else {
        openTourMenu();
      }
      this.model.navbarItemClicked();
    });

    this.createPostitButton = $('#create-postit-button');
    const postitsEnabled = this.model.sceneData.disablePostits === 0 || !this.model.sceneData.disablePostits;
    if (postitsEnabled && !this.model.config.isGuest) {
      this.createPostitButton.on("click", () => {
        Postit.openCreateDialog({ model: this.model, camera: this.camera });
      });
    } else {
      this.createPostitButton.remove();
    }
    this.model.addEventListener(SCENE_EVENTS.SHOW_CHESS_MENU, (e) => {
      this?.createPostitButton?.addClass('disabled');
    });
    this.model.addEventListener(SCENE_EVENTS.HIDE_CHESS_MENU, (e) => {
      this?.createPostitButton?.removeClass('disabled');
    });

    const normalizeExternalUrl = (rawUrl = '') => {
      const url = String(rawUrl || '').trim();
      if (!url) return '';
      if (/^https?:\/\//i.test(url)) return url;
      return `https://${url.replace(/^\/+/, '')}`;
    };

    $(document).on("click", '[data-lang="updates-and-releases-text"]', (e) => {
      const updatesLink = e.currentTarget;
      const sceneUpdatesUrl = this.model?.sceneData?.updatesUrl;
      const normalizedUpdatesUrl = normalizeExternalUrl(sceneUpdatesUrl);
      if (!normalizedUpdatesUrl) return;

      e.preventDefault();
      if (updatesLink) {
        updatesLink.setAttribute('href', normalizedUpdatesUrl);
      }
      window.open(normalizedUpdatesUrl, "_blank");
    });

    // DON'T SHOW WELCOME SCREEN
    $("#dontShowWelcomeScreenAgain").on("change", (e) => {
      const state = $(e.target).prop('checked');
      $("#showWelcomeScreen").prop('checked', !state);
      localStorage.setItem(`welcome_screen_${this.worldID}`, JSON.stringify({ state: !state }));
    });

    $("#showWelcomeScreen").on("change", (e) => {
      const state = $(e.target).prop('checked');
      localStorage.setItem(`welcome_screen_${this.worldID}`, JSON.stringify({ state }));
    });

    $("#infoElementBtnUrl").on("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (this.model.iAmInTour() && !this.model.iAmGuide()) {
        this.model.alert('error', $trans('error-not-available-intour-mode'));
        return;
      }
      if (this.isBlockedByAgentCall()) {
        this.showAgentCallBlockedError();
        return;
      }
      const t = e.currentTarget;

      if ($(t).hasClass('isLocation')) {
        const sceneId = t.href.split('/').pop();
        if (sceneId) {
          $("#infoElementModal").removeClass("is-active");
          this.model.dispatchEvent({ type: SCENE_INTERACTION.JUMP_TO_SCENE, data: { sceneId, linearAnimation: true } });
        } else {
          console.error(`It seems that the id does not exist: ${sceneId}`);
        }
      } else {
        window.open(t.href, "_blank");
      }
    });

    $("#unmute_welcome_screen_video").on("click", function () {
      const videoElement = document.querySelector("#welcomeScreenVideo");
      videoElement.muted = false;
      videoElement.controls = true;
      videoElement.currentTime = 0;
      videoElement.play();
      videoElement.volume = 1;
      $("#welcome_screen_video_holder").removeClass("active");
    });

    $(document).on("click", "#unmute_info_element_video", function () {
      const videoElement = document.querySelector("#infoElementVideo");
      videoElement.muted = false;
      videoElement.controls = true;
      videoElement.currentTime = 0;
      videoElement.play();
      videoElement.volume = 1;
      $("#info_element_video_holder").removeClass("active");
    });


    this.indicatorClickEvent();
    this.ctaMenuClickEvents();

    this.takeScreenCallback = null;

    this.tick();

    if (this.model.sceneData.space_type === 'premium') {
      $(".world-top-nav__logo_area__logo img").attr("src", "/textures/bagless-premium-logo.png");
    } else {
      $(".tune-menu-title.is-premium-space").remove();
      $(".space-info-title-wrapper img").hide();
    }
    if (this.model.sceneData.customLogo && this.model.sceneData.customLogo !== './textures/empty.png') {
      $(".world-top-nav__logo_area__logo img").attr("src", this.model.sceneData.customLogo);
    }

  }//end constructor

  _initClickPointAnimation() {
    this.clickPointAnimation = new ClickPointAnimation({
      camera: this.camera,
      parent: this.roomGroup || this.scene,
    });
  }

  _playClickableIndicatorHints(attempt = 0) {
    if (attempt === 0) {
      window.setTimeout(() => this._playClickableIndicatorHints(1), 500);
      return;
    }
    const elements = this._getVisibleClickableIndicatorElements();
    if (!elements.length && attempt < 16) {
      window.setTimeout(() => this._playClickableIndicatorHints(attempt + 1), 150);
      return;
    }
    this.clickPointAnimation?.playOnElements(elements, { staggerMs: 450, staggerRandom: true });
  }

  _startClickHintTracking() {
    window.setTimeout(() => {
      this._resetClickHintTracking();
      this._clickHintTrackingEnabled = true;
      this._clickHintTrackingActive = true;
    }, 400);
  }

  _resetClickHintTracking() {
    this._clickHintInViewIds.clear();
    this._clickHintOffFrames.clear();
  }

  _updateClickHintTracking() {
    if (!this._clickHintTrackingActive || !this.clickPointAnimation) return;
    this._clickHintFrame = (this._clickHintFrame + 1) | 0;
    if (this._clickHintFrame % 2 !== 0) return;

    const visible = this._getClickHintTargets();
    const visibleIds = new Set(visible.map((t) => t.id));
    const enteringMeshes = [];

    for (const target of visible) {
      this._clickHintOffFrames.delete(target.id);
      if (this._clickHintInViewIds.has(target.id)) continue;
      this._clickHintInViewIds.add(target.id);
      if (target.mesh) enteringMeshes.push(target.mesh);
    }

    for (const id of this._clickHintInViewIds) {
      if (visibleIds.has(id)) continue;
      const misses = (this._clickHintOffFrames.get(id) || 0) + 1;
      if (misses < 3) {
        this._clickHintOffFrames.set(id, misses);
        continue;
      }
      this._clickHintOffFrames.delete(id);
      this._clickHintInViewIds.delete(id);
    }

    this.clickPointAnimation.playOnMeshes(enteringMeshes, { staggerMs: 450, staggerRandom: true });
  }

  _getClickHintTargets() {
    const targets = [];
    const seen = new Set();
    for (const mesh of this._getVisibleClickableComponentMeshes()) {
      const id = `mesh:${mesh.id}`;
      if (seen.has(id)) continue;
      seen.add(id);
      targets.push({ id, mesh });
    }
    return targets;
  }

  _getIndicatorDom(indicator) {
    const key = indicator?.element;
    if (!key) return null;
    let el = this._indicatorDomCache?.get(key);
    if (!el) {
      const list = document.getElementsByClassName(key);
      el = list && list.length ? list[list.length - 1] : null;
      if (el) this._indicatorDomCache?.set(key, el);
    }
    return el || null;
  }

  _getVisibleClickableIndicatorElements() {
    const skipPrefixes = ['vapi-camera2d-', 'vapi-transcription2d-', 'vapi-button2d-'];
    const elements = [];
    const seen = new Set();
    for (const indicator of this.indicatorsArray || []) {
      const key = String(indicator?.element || '');
      if (skipPrefixes.some((prefix) => key.startsWith(prefix))) continue;
      const el = this._getIndicatorDom(indicator);
      if (!el || seen.has(el)) continue;
      if (!el.classList.contains('visible')) continue;
      if (el.classList.contains('taken')) continue;
      if (el.classList.contains('hide-on-start')) continue;
      if (el.classList.contains('hidden-by-action')) continue;
      seen.add(el);
      elements.push(el);
    }
    return elements;
  }

  _isMeshOnScreen(mesh, margin = 0.95) {
    if (!mesh || !this.camera) return false;
    mesh.updateWorldMatrix(true, false);
    const worldPos = mesh.getWorldPosition(this._clickHintWorldPos);
    const camPos = this.camera.getWorldPosition(this._clickHintCamPos);
    this.camera.getWorldDirection(this._clickHintCamDir);
    if (this._clickHintToMesh.copy(worldPos).sub(camPos).dot(this._clickHintCamDir) <= 0) return false;
    mesh.getWorldPosition(worldPos);
    worldPos.project(this.camera);
    return worldPos.x >= -margin && worldPos.x <= margin
      && worldPos.y >= -margin && worldPos.y <= margin
      && worldPos.z >= -1 && worldPos.z <= 1;
  }

  _getVisibleClickableComponentMeshes() {
    const meshes = [];
    const seen = new Set();
    for (const mesh of this.objectsInScene || []) {
      if (!mesh || seen.has(mesh.id)) continue;
      if (!mesh.parent?.isClickableInView?.()) continue;
      if (!this._isMeshOnScreen(mesh)) continue;
      seen.add(mesh.id);
      meshes.push(mesh);
    }
    return meshes;
  }

  _viewModeControls(self) {
    // OrbitControls uses setPointerCapture on pointerdown, which retargets pointerup to the
    // container. As a result, clicks on [data-css3d-interactive] elements (e.g. VRAI chair)
    // never reach them—the click fires on the container instead. Capture the pointerdown
    // target so we can forward the click when needed.
    let _pointerdownOnInteractive = null;
    let _pointerdownTarget = null;
    css3DContainer.addEventListener("pointerdown", (e) => {
      const el = this.getAllowedCss3dInteractiveTarget(e.target);
      _pointerdownOnInteractive = el || null;
      if (!el) {
        _pointerdownTarget = null;
        return;
      }
      // Icon/text inside <button> reports target as SPAN, not BUTTON — resolve for click synthesis.
      const control = e.target?.closest?.(
        "button, a, input, select, textarea, [contenteditable=\"true\"]"
      );
      _pointerdownTarget = control || e.target;
    }, true);
    const clearPointerdownTarget = () => { _pointerdownOnInteractive = null; _pointerdownTarget = null; };
    css3DContainer.addEventListener("pointerup", () => setTimeout(clearPointerdownTarget, 0), true);
    css3DContainer.addEventListener("pointercancel", clearPointerdownTarget, true);

    // CLICK EVENT
    css3DContainer.addEventListener("click", (event) => {
      const target = event.target;
      // OrbitControls uses setPointerCapture: `click` may report the container/canvas as target, not
      // the element that received pointerdown. Real <button> hits (e.g. .vrai-agent-chair-end-indicator)
      // never run their listeners unless we synthesize.
      if (
        _pointerdownTarget &&
        target !== _pointerdownTarget &&
        !_pointerdownTarget.contains(target) &&
        document.contains(_pointerdownTarget)
      ) {
        const pt = _pointerdownTarget;
        const tag = pt.tagName && pt.tagName.toUpperCase();
        if (
          (tag === 'BUTTON' || tag === 'A' || tag === 'INPUT' || tag === 'SELECT' || tag === 'TEXTAREA') &&
          this.getAllowedCss3dInteractiveTarget(pt)
        ) {
          pt.click();
          clearPointerdownTarget();
          event.preventDefault();
          event.stopPropagation();
          return;
        }
      }
      // Allow native interactions on form controls inside CSS3D (e.g., Post-it inputs/buttons)
      const targetInInteractive = this.getAllowedCss3dInteractiveTarget(target);
      const targetIsFormControl = target?.closest?.('input, textarea, select, button, [contenteditable="true"]');
      if (target && targetIsFormControl) {
        if (_pointerdownOnInteractive && !targetInInteractive && _pointerdownTarget) {
          _pointerdownTarget.click();
        }
        clearPointerdownTarget();
        return;
      }

      // Clicks on CSS3D components (chair, camera, transcription): meshes are zero-size so ray never hits.
      // Resolve the clicked DOM element to the scene object and run the same selection logic.
      const interactiveEl = targetInInteractive || _pointerdownOnInteractive;
      if (target && interactiveEl && this.controlsActive) {
        const css3dIntersect = this.getSceneObjectFromCss3dClick(interactiveEl);
        if (css3dIntersect) {
          const clickedChairControl = !!target?.closest?.(
            '.vrai-agent-chair-indicator-el, .vrai-agent-chair-end-indicator, .vrai-agent-btn-end, button, a, input, select, textarea, [contenteditable="true"]'
          );
          const shouldPreferRaycastTarget =
            css3dIntersect.object?.type === 'vraiAgent'
            && !clickedChairControl
            && this._ray_tracing(event, this.objectsInScene)
              .find(intersection => this._meshActuallyVisible(intersection.object))?.object?.type === 'webLink';

          if (shouldPreferRaycastTarget) {
            clearPointerdownTarget();
          } else {
            event.preventDefault();
            $(".cta-menu").removeClass("is-active");
            this.model.lastScreenShareIClicked !== null && this.model.lastScreenShareIClicked.removeBorderHighlight();
            this.model.lastPeerChairIClicked !== null && this.model.lastPeerChairIClicked.removeBorderHighlight();
            this.elementSelected = css3dIntersect.object;
            {
              const o = this.elementSelected;
              console.log('[scene element click]', {
                mode: 'view',
                source: 'css3d',
                type: o?.type,
                name: o?.name,
                id: o?.id ?? o?.getId?.(),
                action: describeViewCss3dClickAction(o?.type),
              });
            }
            $("#elementSelected").val(this.elementSelected.id || this.elementSelected.getId?.());
            switch (this.elementSelected.type) {
              case 'vraiAgent': /* VAPI agent chair – click on DOM starts call */ break;
              case 'vapiCamera2': /* camera component – extend as needed */ break;
              case 'vapiTranscription2': /* transcription component – extend as needed */ break;
              default: break;
            }
            clearPointerdownTarget();
            return;
          }
        }
      }

      event.preventDefault();

      if (this.controlsActive) {
        let intersect = this._ray_tracing(event, this.objectsInScene);
        $(".cta-menu").removeClass("is-active");
        this.model.lastScreenShareIClicked !== null && this.model.lastScreenShareIClicked.removeBorderHighlight();
        this.model.lastPeerChairIClicked !== null && this.model.lastPeerChairIClicked.removeBorderHighlight();

        if (intersect.length === 0) {
          this.model.resetPeerChairOptions();
        } else {
          // Find the first actually clickable/drawable object
          const visibleObject = intersect.find(intersection => this._meshActuallyVisible(intersection.object));

          if (visibleObject) {
            this.elementSelected = visibleObject.object;
            {
              const o = this.elementSelected;
              console.log('[scene element click]', {
                mode: 'view',
                source: 'raytrace',
                type: o?.type,
                name: o?.name,
                id: o?.id,
                parentName: o?.parent?.name,
                action: describeViewRaytraceClickAction(o?.type),
              });
            }

            $("#elementSelected").val(this.elementSelected.id);

            switch (this.elementSelected.type) {
              case 'guestSeat': this._chairClickEvent(); break;
              case 'vapiCamera2': /* camera component */ break;
              case 'vapiTranscription2': /* transcription component */ break;
              case 'screenStream':
                this.model.lastScreenShareIClicked = this.elementSelected.parent;
                this.sizes.width < this.mobileBreakpoint && this.elementSelected.parent.addBorderHighlight();
                // if (this.model.streamController.isInRoom()) {
                //   $("#screen-share-menu").addClass("is-active");
                // }
                break;
              case 'sceneChange': this._sceneChangeClickEvent(); break;
              case 'webLink': this._linkClickEvent(); break;
              case 'baglessRoom': this._linkClickEvent(true); break;
              case 'profile': this._profileClickEvent(); break;
              case 'userInfo': this._userInfoEvent(); break;
              case 'chessGame': this._chessGameClickEvent(); break;
              case 'chessAvatar': this._chessGameAvatarClickEvent(); break;
              case 'payPalDonation': this._payPalDonationClickEvent(); break;
              case 'shopLink': this._shopLinkClickEvent(); break;
              case 'infoElement': this._infoElementClickEvent(); break;
              case 'embeddedWebpage': this._embeddedWebpageClickEvent(); break;
              case 'tourScreenShare': this.onTourScreenShareSelectedElement(); break;
              case 'imageGallery': this.onImageGalleryClick(); break;
              case 'seatCamera': this.onSeatCameraClick(); break;
              case 'seatMic': this.onSeatMicrophoneClick(); break;
              case 'videoGallery': this.onVideoGalleryClick(); break;
              case 'videoPlayer':
              case 'videoPlayerWebGL': this.onVideoPlayerClick(); break;
              case 'vrMusicObject': this._vrMusicObjectClickEvent(); break;
              case 'vrInvisibleAction': this._vrInvisibleActionClickEvent(); break;
            }
          } else {
            this.model.resetPeerChairOptions();

            if (intersect[0].object.type === 'sceneChangeDummy') {
              this.elementSelected = intersect[0].object.parent;
              console.log('[scene element click]', {
                mode: 'view',
                source: 'sceneChangeDummy',
                type: this.elementSelected?.type,
                name: this.elementSelected?.name,
                id: this.elementSelected?.id,
                action: 'Run _sceneChangeClickEvent() – navigate to target scene (hit invisible dummy mesh)',
              });
              $("#elementSelected").val(this.elementSelected.id);
              this._sceneChangeClickEvent();
            }
          }
        }
      }
    });

    // MOUSE MOVE EVENT
    let currentHoveredMesh = null;

    $(document).on("mousemove wheel", (event) => {
      let intersect = this._ray_tracing(event, this.scene.children);
      this.mouseXY = { x: event.clientX, y: event.clientY };
      const normalizedX = event.clientX / window.innerWidth;
      const normalizedY = event.clientY / window.innerHeight;
      this.model.socket.mouseData = { x: normalizedX, y: normalizedY };

      if (this.model.guidedMode && !this.model.activeOneOnOneCall && this.model.socket.updateCameraData) {
        this.model.socket.updateCameraData({ x: normalizedX, y: normalizedY });
      }

      if (intersect.length) {
        const mesh = intersect[0].object;
        const cond = mesh.visible && mesh.type === 'baglessRoom';

        if (cond) {
          const parent = mesh.parent.type === 'baglessRoom' ? mesh.parent.parent : mesh.parent;
          const targetRoomName = `: ${parent.clickable ? parent.targetRoomName : $trans('restricted-access-text')}`;
          $("#tooltip-target-bagless-room").text(targetRoomName);
          $("#dynamic-floating-tooltip").css({ left: `${event.clientX}px`, top: `${event.clientY}px` });
        }

        // Handle imageGallery / videoGallery / 3D video player highlight
        if (mesh.type === 'imageGallery' || mesh.type === 'videoGallery' || (isVideoPlayerType(mesh.type) && mesh.parent?.placeAs3dElement)) {
          if (currentHoveredMesh !== mesh) {
            if (currentHoveredMesh && currentHoveredMesh.parent && currentHoveredMesh.parent.removeBorder) {
              currentHoveredMesh.parent.removeBorder();
            }
            currentHoveredMesh = mesh;
            if (mesh.parent && mesh.parent.animateBorder) {
              mesh.parent.animateBorder();
            }
          }
        } else if (currentHoveredMesh) {
          // Remove the border if the mouse is no longer over the "imageGallery"
          if (currentHoveredMesh.parent.removeBorder) {
            currentHoveredMesh.parent.removeBorder();
          }
          currentHoveredMesh = null;
        }

        $("#dynamic-floating-tooltip").toggleClass("visible", cond);
        $("#css3d").toggleClass("hide-cursor", cond);
      } else if (currentHoveredMesh) {
        // Remove the border if there is no intersection
        if (currentHoveredMesh.parent.removeBorder) {
          currentHoveredMesh.parent.removeBorder();
        }
        currentHoveredMesh = null;
      }

      if (this._isSphereTileStreamingLayout()) {
        this.sphereController.updateSphereSegments();
      }
    });

    // ENABLE / DISABLE AMBIENT SOUND
    $('#ambientMusic').on('change', (e) => {
      if ($(e.target).prop('checked')) {
        this.fadeInAmbientSound();
      } else {
        this.ambientSound.stop();
      }
      $('#ambientMusicHolder').toggleClass('active');
      this.saveAmbientAudioPreset();
    });

    // COMPASS CONTROLS
    $(".compass-show-north").on('click', () => {
      console.log('compass-show-north');
      this.rotateCameraToNorth();
    });

    // CHESS GAME
    $('#chess-leave-chair').on('click', (e) => {
      e.stopPropagation(e);
      if (!this.model.chessModeController.roomJoined) {
        this.model.confirm($trans('quit-game-text'), () => {
          this.elementSelected.parent.quitGame();
          this.model.chessModeController.leaveRoom();
          this.render3DWorld = true;
          this.customRenderMode = false;
          this.model.chessGameMode = false;
          this.model.dispatchEvent({ type: SCENE_EVENTS.HIDE_CHESS_MENU });
        }, {
          header: true, title: $trans('leave-game-text'), dimmerClose: false,
        }
        );
      } else {
        this.model.confirm($trans('leave-game-or-standup'), () => {
          this.leaveChessGameAndBackToViewMode();
        }, {
          header: true, title: $trans('confirmation-text'),
          cancelBtnTxt: $trans('standup-text'),
          confirmBtnTxt: $trans('leave-game-text'),
          dimmerClose: false,
        }, () => {
          const showChessMenu = () => {
            this.model.dispatchEvent({ type: SCENE_EVENTS.SHOW_CHESS_MENU });
            this.model.removeEventListener(GAME_EVENTS.CHESS_CONTROLLER_ROOM_LEFT, showChessMenu);
          }
          this.model.addEventListener(GAME_EVENTS.CHESS_CONTROLLER_ROOM_LEFT, showChessMenu);
          this.model.chessModeController.leaveRoom();
          this.elementSelected.parent.quitGameOnly();
          this.elementSelected.parent.quitGame();
        });
      }
    });

    $('.chess-quit-game').on('click', (e) => {
      e.stopPropagation(e);
      this.model.confirm($trans('confirm-leave-game'), () => {
        this.elementSelected.parent.quitGame();
        this.model.chessModeController.leaveRoom();
      }, { header: true, title: $trans('confirmation-text') });
    });

    $('.chess-minimize-game').on('click', () => {
      this.elementSelected.parent.minimizeGame();
    });

    $('.chess-flip-board').on('click', () => {
      this.elementSelected.parent.flipBoard();
    });

    $('#chess-restart').on('click', () => {
      this.elementSelected.parent.restartGame();
    });

    $('#chess-flip').on('click', () => {
      this.elementSelected.parent.flipBoard();
    });

    $(document).on('click', '.chess-player-info', (e) => {
      const player = $(e.target).data('chessPlayer');
      this.elementSelected.parent.showInfo(player);
    });

    $(document).on('click', '.chess-visitor-avatar', (e) => {
      const userId = $(e.target).data('id');
      this.elementSelected.parent.showInfo(userId);
    });

    $('.chess-visitors-stats').on('click', () => {
      this.elementSelected.parent.visitorsStats();
    });

    $(document).on('click', '.chess-player-select', function () {
      // self.elementSelected.parent.setPlayer($(this).attr('data-chess-player'), true);
    });

    $("#chess-info-chat").on("click", () => {
      const userId = $("#chess-info-id").val();
      this.elementSelected.parent.chat(userId);
    });

    $("#chess-info-video").on("click", () => {
      const userId = $("#chess-info-id").val();
      this.elementSelected.parent.videoCall(userId);
    });

    $(".chess-buttons-holder button").on("click", () => {
      this.elementSelected.parent.toggleChessButtons();
    });

    // CALL 1:1 peer avatar interaction
    $('#my-peer-video-wrapper-call').on("click tap", () => {
      $('#peer-radial-actions').trigger('click');
      if ($('#peer-radial-actions').prop('checked')) {
        const socket = this.model.socket;
        const socketMe = socket.getUsersObject()[socket.getUserData().userId];
        const peerId = $("#one-on-one-video-call-peer-id").val();
        const user = socket.getUsersObject()[peerId] || null;
        areInSameScene(user, socketMe, this.model.sceneData.scenes) ? $("#video-call-jump").hide() : $("#video-call-jump").show();
      }
    });

    $(".action").on("click", () => {
      $("#peer-radial-actions").prop("checked", false);
    });

    $("#video-call-chat").on("click", () => {
      const peerId = $("#one-on-one-video-call-peer-id").val();
      this.model.startOneOnOneChat(peerId);
    });

    $("#video-call-jump").on("click", () => {
      const peerId = $("#one-on-one-video-call-peer-id").val();
      this.model.jumpToUser(peerId);
    });

    $("#video-call-info").on("click", () => {
      const peerId = $("#one-on-one-video-call-peer-id").val();
      const socketItem = this.model.socket.getUsersObject()[peerId];
      if (socketItem && socketItem.isGuest) {
        this.model.showGuestModal(peerId);
      } else {
        this.model.showUserInfo({ userId: peerId, eventOrigin: '' });
      }
      $('#guest-user-modal-content button.primary').addClass("disabled");
    });

    // PAYPAL DONATION
    $(document).on('click', '#paypal_donation', () => {
      const url = $("#paypal_donation_url").val();
      window.open(url, "_blank");
    });

    // DEVICE ORIENTATION
    $(document).on('change', '#useDeviceOrientation', () => {
      const option = $("#useDeviceOrientation").prop('checked');
      localStorage.setItem('useDeviceOrientation', option ? 'true' : 'false');
      console.log('changed');
      this.deviceOrientationHandler();
    });
  }


  rotateCameraToNorth = () => {
    const pivotRotY = this.controls.getAzimuthalAngle() * -1;
    gsap.to(this.pivot.rotation, {
      y: pivotRotY,
      duration: .5
    });
  }

  loadAmbientAudioPreset = () => {
    if (localStorage.getItem('saveAmbientAudioPreset')) {
      const preset = JSON.parse(localStorage.getItem('saveAmbientAudioPreset'));
      $('#ambientMusicHolder').toggleClass('active', preset.sound);
      $('#ambientMusic').prop('checked', preset.sound);
    }
  }

  saveAmbientAudioPreset = () => {
    const withSound = $('#ambientMusic').prop('checked');
    localStorage.setItem('saveAmbientAudioPreset', JSON.stringify({ sound: withSound }));
  }

  async _chairClickEvent(force) {
    if (this.isBlockedByAgentCall()) {
      this.showAgentCallBlockedError();
      return;
    }
    if (this.model.iAmInTour()) {
      this.model.alert('error', $trans('error-not-available-intour-mode'));
      return;
    }

    if (!force && this.model.sceneData.space_type !== 'premium') {
      if (!(await this.model.validatePlanFeature(FEATURE_NAMES.TAKE_SEAT))) {
        window.openLoginModal && window.openLoginModal($trans('you-need-to-login-to-take-a-seat'));
        return;
      }
    }

    const actions = this.model.socket.getGlobalActions();
    const parent = this.elementSelected.parent;
    if (parent.isMine()) {
      force = true;
    }
    if (!actions.takeSeat && !force) {
      this.model.alert('error', $trans('error-please-login'));
      return;
    }

    if (!(await requestMediaPermissions('all', this.model))) {
      return;
    }

    if (parent.isEmpty()) {
      this.setWebRTCRoomID();

      const takeEmptySeat = () => {
        if (!this.model.streamController.cameraController.webRTCAdaptor) {
          if (localStorage.getItem('takeSeatPresets')) {
            const preset = JSON.parse(localStorage.getItem('takeSeatPresets'));
            $('#startStreamWithAudio').prop('checked', preset.withAudio);
            $('#startStreamWithVideo').prop('checked', preset.withCamera);
            $('#startStreamWithAudioPuppet').prop('checked', preset.withAudio);
            $('#startStreamWithVideoPuppet').prop('checked', preset.withCamera);
            this.model.userWantsAudio = true;
            this.model.userWantsCamera = true;
          }
          this.updateDeviceSelect();
          $("#submit_take_seat").trigger('click');
        } else if (force) {
          this.takeSeatNoPrompt(parent);
        } else {
          this.changeSeatOrInvite(parent);
        }
      };

      if (this.model.activeOneOnOneCall) {
        this.confirmEndOneOnOneThen(takeEmptySeat);
        return;
      }

      takeEmptySeat();
    } else {
      parent.showUserOptions();
      this.model.lastPeerChairIClicked = parent;
      this.sizes.width < this.mobileBreakpoint && parent.addBorderHighlight();
    }
  }

  takeSeatNoPrompt = async (parent, rotate) => {
    if (this.model.sceneData.space_type !== 'premium') {
      if (!await this.model.validatePlanFeature(FEATURE_NAMES.TAKE_SEAT)) {
        if (window.openLoginModal) {
          window.openLoginModal($trans('you-need-to-login-to-take-a-seat'));
        }
        return;
      }
    }

    this.checkSeatAvailableTimer && clearInterval(this.checkSeatAvailableTimer);
    this.checkSeatAvailableTimer = null;
    if (parent.isEmpty()) {
      this.removeMeFromOtherChairs();
      this.model.iSitOnThisVRChair = parent;
      parent.takeSeat(this.model.iStream.video, this.model.userAvatarTexture); // USER AVATAR TEXTURE HERE
      this.iSit = true;
      this.model.playAudioNotification('enterSeat');
      this.model.streamController.cameraJoinRoom();
      this.model.onTakeSeat(parent.dbConfig);
      this.animateCameraLookAt(parent);
    } else {
      this.model.alert('error', `${$trans('error-take-seat')} ${parent.getUserInfo().userName}!`, { dataLang: 'error-take-seat' });
    }
  }

  takeSitWithSimplePrompt = (parent) => {
    this.model.confirm($trans('confirm-take-seat'), () => {
      if (parent.isEmpty()) {
        this.handleAudioOn();
        this.removeMeFromOtherChairs();
        this.model.iSitOnThisVRChair = parent;
        parent.takeSeat(this.model.iStream.video, this.model.userAvatarTexture); // USER AVATAR TEXTURE HERE
        this.iSit = true;
        this.model.playAudioNotification('enterSeat');
        this.model.streamController.cameraJoinRoom();
        this.model.onTakeSeat(parent.dbConfig);
        this.animateCameraLookAt(parent)
      } else {
        this.model.alert('error', `${$trans('error-take-seat')} ${parent.getUserInfo().userName}!`, { dataLang: 'error-take-seat' });
      }
    }, { confirmBtnTxt: $trans('yes-text'), cancelBtnTxt: $trans('cancel-text') });
  }
  changeSeatOrInvite = async (parent) => {
    if (this.model.sceneData.space_type !== 'premium') {
      if (!await this.model.validatePlanFeature(FEATURE_NAMES.TAKE_SEAT)) {
        if (window.openLoginModal) {
          window.openLoginModal($trans('you-need-to-login-to-take-a-seat'));
        }
        return;
      }
    }

    this.model.confirm(
      $trans('would-you-like-to-take-a-seat-or-invite-guest'),
      () => {
        setTimeout(() => {
          if (parent.isEmpty()) {
            // this.takeSitWithSimplePrompt(parent);
            this.removeMeFromOtherChairs();
            this.model.iSitOnThisVRChair = parent;
            parent.takeSeat(this.model.iStream.video, this.model.userAvatarTexture); // USER AVATAR TEXTURE HERE
            this.iSit = true;
            this.model.playAudioNotification("enterSeat");
            this.model.streamController.cameraJoinRoom();
            this.model.onTakeSeat(parent.dbConfig);
            this.animateCameraLookAt(parent);
          } else {
            this.model.alert("error", `${$trans('error-take-seat')} ${parent.getUserInfo().userName}!`, { dataLang: "error-take-seat" });
          }
        }, 100);
      },
      {
        header: true,
        logo: false,
        title: "Take a Seat",
        confirmBtnTxt: "Take a seat",
        cancelBtnTxt: "Invite a guest",
        modalTheme: CONFIRM_NOTIFICATION_THEME.DARK,
        modalType: CONFIRM_NOTIFICATION_TYPE.CONFIRM,
        modalSize: CONFIRM_NOTIFICATION_SIZE.SM,
        buttonSize: CONFIRM_BUTTON_SIZE.FULL,
      },
      async (e) => {
        if (!await this.model.validatePlanFeature(FEATURE_NAMES.INVITE_TO_CHAIR)) {
          return;
        }
        this.chairInviteModal.parent = parent;
        setTimeout(() => {
          this.chairInviteModal.show();
        }, 100);
      }
    );
  }
  inviteToSeat = (parent) => {
    if (window.baglessTrack) {
      window.baglessTrack(this.model.config, "User invited to a seat", { data: parent.dbConfig })
    }
    this.model.confirm($trans('invite-take-seat'), () => {
      if (parent.isEmpty()) {
        this.chairInviteModal.parent = parent;
        this.chairInviteModal.show();
      } else {
        this.model.alert('error', `${$trans('error-take-seat')} ${parent.getUserInfo().userName}!`, { dataLang: 'error-take-seat' });
      }
    }, { confirmBtnTxt: $trans('yes-text'), cancelBtnTxt: $trans('cancel-text') });
  }

  removeMeFromOtherChairs = (texture) => {
    for (let x = 0; x < this.objectsInScene.length; x++) {
      const el = this.objectsInScene[x];
      if (el.type === 'guestSeat') {
        if (el.parent.isMine()) {
          el.parent.standUp();
          this.model.iSitOnThisVRChair = null;
        }
      }
    }
  }

  leaveSeat = () => {
    const parent = this.iSitOnChair();
    if (!parent) {
      this.model.alert('error', $trans('error-please-take-seat'));
      return;
    }
    this.model.confirm(
      $trans('confirm-leave-seat'),
      () => {
        parent.standUp();
        if (!this.model.socket.initialised) {
          this.model.socket.reset();
          parent && parent.getState();
          this.model.streamController.cameraController.leaveRoom();
          this.model.streamController.cameraController.closeStream();
        }
        this.model._localStream?.getTracks().forEach((track) => {
          track.stop()
        })
        this.model.onStandUp(parent.dbConfig);
        this.model.playAudioNotification("leaveSeat");
        this.iSit = false;
        this.model.iSitOnThisVRChair = null;
        this.model.dispatchEvent({ type: SCENE_EVENTS.GRID_MODE, data: { showGrid: false, leaveSeat: true } });
        if (!this.model.activeOneOnOneCall) {
          this.endStream();
        }
        const isScreenStream = this.iSitOnScreenStream();
        if (isScreenStream) {
          this.forceStopScreenShare(isScreenStream);
        }
        this.customRenderMode = true;
        this.handleGridToggle();
      },
      {
        header: true,
        logo: false,
        title: $trans('confirm-title-leave-seat'),
        confirmBtnTxt: $trans('yes-text'),
        cancelBtnTxt: $trans('cancel-text'),
        modalTheme: CONFIRM_NOTIFICATION_THEME.DARK,
        modalType: CONFIRM_NOTIFICATION_TYPE.CONFIRM,
        modalSize: CONFIRM_NOTIFICATION_SIZE.SM,
        buttonSize: CONFIRM_BUTTON_SIZE.FULL,
      }
    );
  }
  leaveSeatNoPrompt() {
    const parent = this.iSitOnChair();
    if (parent.isMine()) {
      parent.standUp();
      this.model.onStandUp(parent.dbConfig);
      this.model.onStandUpFromScreenShare(parent.dbConfig);
      this.model.playAudioNotification('leaveSeat');
      this.iSit = false;
      this.model.iSitOnThisVRChair = null;
      if (!this.model.activeOneOnOneCall) {
        this.endStream();
      }
    }
  }

  isMeSharing() {
    return this.elementSelected?.parent?.state?.me && this.model.iShareOnThisObj
  }

  _stopScreenShare() {
    let parent = this.model.iShareOnThisObj;
    if (this.elementSelected && this.elementSelected.parent.state && !this.elementSelected.parent.state.me) {
      return;
    }
    if (parent) {
      this.model.onStandUpFromScreenShare(parent.dbConfig);
      parent.standUp && parent.standUp();
      this.model.iShareOnThisObj = null;
    }
    if (this.model.screenShareStream) {
      this.model.screenShareStream = null;
    }
    this.closeScreenShareMenu();
  }

  forceStopScreenShare(element) {
    this.model.onStandUpFromScreenShare(element.dbConfig);
    element.standUp && element.standUp();
    this.model.iShareOnThisObj = null;
    if (this.model.screenShareStream) {
      this.model.screenShareStream = null;
    }
    this.closeScreenShareMenu();
  }

  _fullScreen() {
    const element = this.elementSelected.parent.videoElement;
    if (element !== null) {
      const fullscreenElement =
        document.fullscreenElement ||
        document.mozFullScreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement;
      if (fullscreenElement) {
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen({ navigationUI: "show" });
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen({ navigationUI: "show" });
        } else if (element.webkitRequestFullscreen) {
          element.webkitRequestFullscreen({ navigationUI: "show" });
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen({ navigationUI: "show" });
        } else {
          element.classList.toggle('fullscreen');
        }
      }
      $("#screen-share-menu").removeClass("is-active");
    }
  }

  closeScreenShareMenu() {
    $("#screen-share-menu").removeClass("is-active");
  }
  _gridFocus() {
    const element = this.elementSelected.parent.screenShareElement;
    if (element !== null) {
      $('#gridToggle').trigger('click');
      $(element).trigger("click"); // $(element).parent().trigger('click');
      $("#screen-share-menu").removeClass("is-active");
    }
  }

  _shopLinkClickEvent() {
    let products = this.elementSelected.parent.dbConfig.products;
    initShopSlider(products);
    $('.product_display_holder').addClass('is-active');
  }

  onTourScreenShare(mesh, type) {
    const data = { meshId: mesh.parent.getId() };
    this.model.onTourScreenShareType(SCREEN_SHARE_SEAT_TYPE.SEAT); ///FIX
    this.model.tourOnTakeScreenShareSeat(data);
  }
  _screenStreamClickEvent() {
    this.takeScreenCallback = null;
    // if (this.model.config.isGuest) {
    //   this.model.alert('error', $trans('error-please-login'));
    //   return;
    // }
    const parent = this.elementSelected.parent;
    let iStream = false;
    this.filtered3DObjects["screenStream"] && this.filtered3DObjects["screenStream"].forEach((item) => {
      if (item.state && item.state.me) {
        iStream = true;
      }
    });
    if (iStream) {
      this.model.alert('error', $trans('error-already-sharing'));
      return;
    }
    this.setWebRTCRoomID();

    const { id: objID, whoCanStream } = parent.dbConfig;
    const { creatorUserIdOfWorld: ownerId } = this.model.config;

    if (this.model.isThisOccupiedScreen(objID)) {
      this.model.alert('error', $trans('error-screen-occupied'));
      return;
    }

    switch (whoCanStream) {
      case 'everyone':
        this.takeScreenCallback = () => {
          if (this.model.isThisOccupiedScreen(objID)) {
            this.model.alert('error', $trans('error-take-screen'));
            return;
          }
          parent.takeScreen(true, 'initial-screen-share-video', objID);
          this.model.dispatchEvent({ type: WEBRTC_EVENTS.WEBRTC_START_SCOPE, data: { 'scopeType': 'screenShare', 'scopeId': this.currentScene.id, 'scopeName': this.currentScene.publicName, 'withCamera': false, 'withAudio': false, 'constraints': {}, 'removeElement': null, 'unique_id': objID } });
          this.model.iShareOnThisObj = parent;
        }
        this.openChooseStreamSourceModal();
        break;
      case 'onRequest':
        this.takeScreenCallback = () => {
          if (this.model.isThisOccupiedScreen(objID)) {
            this.model.alert('error', $trans('error-take-screen'));
            return;
          }
          if (this.model.userIsOwner || this.model.userIsContributor) {
            parent.takeScreen(true, 'initial-screen-share-video', objID);
            this.model.dispatchEvent({ type: WEBRTC_EVENTS.WEBRTC_START_SCOPE, data: { 'scopeType': 'screenShare', 'scopeId': this.currentScene.id, 'scopeName': this.currentScene.publicName, 'withCamera': false, 'withAudio': false, 'constraints': {}, 'removeElement': null, 'unique_id': objID } });
            this.model.iShareOnThisObj = parent;
          } else {
            let scopeId = this.currentScene.id;
            let scopeName = this.currentScene.publicName;
            parent.requestOwnerToShareScreen(ownerId, objID, scopeId, scopeName);
          }
        }
        this.openChooseStreamSourceModal();
        break;
      case 'owner':
        //console.log('owner');
        if (!this.model.userIsOwner && !this.model.userIsContributor) {
          this.model.alert('error', $trans('error-screen-share-not-allowed'));
          return;
        }

        this.takeScreenCallback = () => {
          if (this.model.isThisOccupiedScreen(objID)) {
            this.model.alert('error', $trans('error-take-screen'));
            return;
          }
          parent.takeScreen(true, 'initial-screen-share-video', objID);
          this.model.dispatchEvent({ type: WEBRTC_EVENTS.WEBRTC_START_SCOPE, data: { 'scopeType': 'screenShare', 'scopeId': this.currentScene.id, 'scopeName': this.currentScene.publicName, 'withCamera': false, 'withAudio': false, 'constraints': {}, 'removeElement': null, 'unique_id': objID } });
          this.model.iShareOnThisObj = parent;
        }

        this.openChooseStreamSourceModal();
        break;
    }
  }

  _profileClickEvent() {
    const parent = this.elementSelected.parent;
    // TOGGLE USER OPTIONS
    if (this.model.lastPeerChairIClicked !== null) {
      if (this.model.lastPeerChairIClicked.mesh.uuid !== this.elementSelected.uuid) {
        this.model.resetPeerChairOptions();
      }
    }
    parent.showUserOptions();
    this.model.lastPeerChairIClicked = parent;
    this.sizes.width < this.mobileBreakpoint && parent.addBorderHighlight();
  }

  _linkClickEvent(baglessRoomEvent = false, fromIndicator = false) {
    if (!this.elementSelected?.parent) return;
    const parent = this.elementSelected.parent.type === 'baglessRoom' ? this.elementSelected.parent.parent : this.elementSelected.parent;
    if (baglessRoomEvent) {
      if (!parent.clickable) {
        this.model.alert('error', $trans('error-bagless-room-access'), { dataLang: 'error-bagless-room-access' });
        return;
      }
    }

    // For `webLink` (VRLinkObject) clicks: if the mesh is not actually visible (mesh.visible=false
    // or material opacity is ~0), do not execute the configured click actions.
    // This prevents hidden/transparent links from firing show/hide chains when the raycaster
    // hits non-visual sub-geometry.
    if (!fromIndicator && !baglessRoomEvent && this.elementSelected?.type === 'webLink') {
      const mesh = this.elementSelected;
      const mat = mesh?.material;
      const opacityOk = (m) => {
        if (!m) return true;
        if (typeof m.opacity !== 'number') return true;
        return m.opacity > 0.01;
      };
      let visibleOk = mesh?.visible !== false;
      if (!visibleOk) return;
      if (Array.isArray(mat) && !mat.some(opacityOk)) return;
      if (!Array.isArray(mat) && mat && !opacityOk(mat)) return;
    }

    const sourceId = parent.dbConfig?.id ?? parent.getId?.() ?? parent.id ?? parent.unique_id;
    const events = this._getClickEventsForSource(sourceId);
    if (events?.length && !this.editMode) {
      events.forEach((ev) => this._executeAction(ev));
      return;
    }

    const link = parent.getLink();
    if (link) {
      if (parent.dbConfig.hasOwnProperty('openNewWindow')) {
        if (parent.dbConfig.openNewWindow) {
          window.open(link);
          return;
        }
      }
      window.open(link, "_top");
    }
  }

  _vrInvisibleActionClickEvent() {
    const parent = this.elementSelected?.parent;
    if (!parent) return;
    if (parent.userData?.hiddenBySceneAction) return;
    const sourceId = parent.dbConfig?.id ?? parent.getId?.() ?? parent.id ?? parent.unique_id;
    const events = this._getClickEventsForSource(sourceId);
    if (events?.length && !this.editMode) {
      events.forEach((ev) => this._executeAction(ev));
    }
  }

  _vrMusicObjectClickEvent() {
    const parent = this.elementSelected?.parent;
    if (!parent) return;
    const sourceId = parent.dbConfig?.id ?? parent.getId?.() ?? parent.id ?? parent.unique_id;
    const events = this._getClickEventsForSource(sourceId);
    if (events?.length && !this.editMode) {
      events.forEach((ev) => this._executeAction(ev));
    }
  }

  _getEventsForSourceByType(sourceId, eventType = 'click') {
    const sceneId = this.currentScene?.id || '';
    const eventTypes = eventType === 'stoppedPlaying'
      ? ['stoppedPlaying', 'stopPlaying']
      : [eventType];
    const events = (this.model.worldEvents || []).filter(
      (e) => String(e.source_object_id) === String(sourceId)
        && String(e.scene_id) === String(sceneId)
        && eventTypes.includes(e.event_type)
    );
    return events.sort((a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0));
  }

  _getClickEventsForSource(sourceId) {
    return this._getEventsForSourceByType(sourceId, 'click');
  }

  _executeEventActions(sourceId, eventType) {
    if (sourceId == null || !eventType || this.editMode) return;
    const events = this._getEventsForSourceByType(sourceId, eventType);
    if (!events?.length) return;
    events.forEach((ev) => this._executeAction(ev));
  }

  /** True if the mesh is drawable for camera-center raycast / click hit tests. */
  _meshActuallyVisible(mesh) {
    if (!mesh || mesh.visible === false) return false;
    if (mesh.type === 'vrInvisibleAction') {
      if (mesh.parent?.userData?.hiddenBySceneAction) return false;
      return true;
    }
    const mat = mesh.material;
    const opacityOk = (m) => {
      if (!m) return true;
      if (typeof m.opacity !== 'number') return true;
      return m.opacity > 0.01;
    };
    if (Array.isArray(mat)) return mat.some(opacityOk);
    return opacityOk(mat);
  }

  _getCameraRaycastViewportCenter() {
    const el = this.webglRenderer?.domElement || document.querySelector('#webgl');
    const rect = el?.getBoundingClientRect?.();
    if (!rect || rect.width < 1 || rect.height < 1) {
      return { x: window.innerWidth * 0.5, y: window.innerHeight * 0.5 };
    }
    return { x: rect.left + rect.width * 0.5, y: rect.top + rect.height * 0.5 };
  }

  /**
   * Per-frame camera-center raycast for raycastEnter / raycastLeave events.
   * Uses viewport center (NDC 0,0), so orbit / keyboard camera moves update hover
   * without requiring mouse movement.
   */
  _updateCameraRaycastHover() {
    if (this.editMode || !this.render3DWorld || this.customRenderMode) return;

    this._updateClickHintTracking();

    // CSS3D VAPI chairs have no real 3D hit box — prefer the on-screen poster.
    const chairSourceId = this._findRaycastHoverChairSourceIdAtViewportCenter();
    if (chairSourceId != null) {
      this._updateRaycastHover(chairSourceId, null);
      return;
    }

    const intersect = this._raycastFromCameraCenter(this.objectsInScene || []);
    const raycastVisibleHit = intersect.find((hit) => this._meshActuallyVisible(hit.object));
    const raycastHoverSourceId = raycastVisibleHit
      ? this._resolveRaycastEventSourceId(raycastVisibleHit.object)
      : null;
    this._updateRaycastHover(raycastHoverSourceId, raycastVisibleHit?.object);
  }

  /**
   * Resolve the interactive scene component that owns a raycast-hit mesh.
   * Handles CSS3D vraiAgent chairs (exposed via userData) and standard
   * VRObject3D-based meshes (component is the mesh parent).
   */
  _resolveRaycastComponent(object) {
    if (!object) return null;
    if (object.userData?.vraiAgentChair) return object.userData.vraiAgentChair;
    const isComponent = (o) => !!o && (o.dbConfig || typeof o.getId === 'function' || o.unique_id != null);
    if (isComponent(object.parent)) return object.parent;
    if (isComponent(object)) return object;
    return null;
  }

  /** Source id (matches worldEvents.source_object_id) for a raycast-hit mesh, or null. */
  _resolveRaycastEventSourceId(object) {
    const comp = this._resolveRaycastComponent(object);
    if (!comp) return null;
    const sourceId = comp.dbConfig?.id ?? comp.getId?.() ?? comp.id ?? comp.unique_id;
    return sourceId != null ? String(sourceId) : null;
  }

  /**
   * CSS3D chairs have no real geometry to raycast (invisible 0.1 anchor box), so hit-test
   * the camera viewport center against the chair's projected viewport rect instead.
   */
  _findRaycastHoverChairSourceIdAtViewportCenter() {
    const { x, y } = this._getCameraRaycastViewportCenter();
    const chairs = this.vraiAgentChairs || [];
    for (const chair of chairs) {
      if (!chair || chair.anchor?.visible === false) continue;
      const rect = chair._getVisibleChairViewportRect?.();
      if (!rect) continue;
      if (x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom) {
        const sourceId = chair._getAgentId?.() ?? chair.dbConfig?.id ?? chair.id;
        if (sourceId != null) return String(sourceId);
      }
    }
    return null;
  }

  /**
   * Track the element currently under the camera-center ray and fire raycastEnter / raycastLeave
   * world events as the hovered element changes.
   */
  _updateRaycastHover(sourceId, hitObject) {
    const prev = this._raycastHoverSourceId ?? null;
    const next = sourceId != null ? String(sourceId) : null;
    if (prev === next) return;
    // Update state before dispatching so chained actions can't cause re-entrant double-fires.
    this._raycastHoverSourceId = next;
    if (prev != null) {
      console.log('[scene camera raycast]', { event: 'raycastLeave', sourceId: prev });
      this.tracking?.trackCameraLeftObject(prev);
      this._executeEventActions(prev, 'raycastLeave');
    }
    if (next != null) {
      console.log('[scene camera raycast]', { event: 'raycastEnter', sourceId: next, type: hitObject?.type });
      this.tracking?.trackCameraOverObject(next, hitObject);
      this._executeEventActions(next, 'raycastEnter');
    }
  }

  _areEntryGateModalsVisible() {
    const welcome = document.getElementById('welcomeScreen');
    if (welcome?.classList.contains('is-active')) return true;
    const consent = document.getElementById('space-consent-modal');
    if (consent?.classList.contains('is-active')) return true;
    return false;
  }

  _stopEntryGateModalWait() {
    if (!this._entryGateModalObserver) return;
    this._entryGateModalObserver.disconnect();
    this._entryGateModalObserver = null;
  }

  _watchEntryGateModals() {
    if (this._entryGateModalObserver) return;
    const nodes = [
      document.getElementById('welcomeScreen'),
      document.getElementById('space-consent-modal'),
    ].filter(Boolean);
    if (!nodes.length) return;
    this._entryGateModalObserver = new MutationObserver(() => {
      this._executeRoomEnteredWhenReady();
    });
    nodes.forEach((el) => {
      this._entryGateModalObserver.observe(el, { attributes: true, attributeFilter: ['class'] });
    });
  }

  _executeRoomEnteredWhenReady() {
    if (this.editMode || !this._pendingRoomEntered) {
      this._stopEntryGateModalWait();
      return;
    }
    if (this._areEntryGateModalsVisible()) {
      this._watchEntryGateModals();
      return;
    }
    this._pendingRoomEntered = false;
    this._stopEntryGateModalWait();
    this._executeSceneEventActions('roomEntered');
  }

  _scheduleDirectEntryRoomEntered() {
    if (this.editMode || this._roomEnteredViaSceneChange || this._directEntryRoomEnteredScheduled) return;
    this._directEntryRoomEnteredScheduled = true;
    setTimeout(() => {
      if (this._roomEnteredViaSceneChange) return;
      this._pendingRoomEntered = true;
      this._executeRoomEnteredWhenReady();
    }, 300);
  }

  _executeSceneEventActions(eventType) {
    if (this.editMode || !eventType) return;
    const sceneId = this.currentScene?.id || '';
    if (!sceneId) return;
    this._executeEventActions(sceneId, eventType);
    if (eventType === 'roomEntered') {
      roomGuide484.onRoomEntered(this);
      this.tracking?.onRoomEntered({ viaSceneChange: this._roomEnteredViaSceneChange });
    }
    if (eventType === 'introAnimationStarted' || eventType === 'introAnimationEnded') {
      this.tracking?.trackIntro(eventType);
    }
  }

  _getActiveInputFieldGuess() {
    if (this._activeInputFieldGuess) {
      return this._activeInputFieldGuess;
    }
    const id = $("#elementSelected").val();
    if (id) {
      const byId = this.inputFieldGuessElementsInScene?.find(
        (item) => String(item.getId?.() ?? item.id) === String(id)
      );
      if (byId) return byId;
    }
    if (this.elementSelected?.type === 'inputFieldGuess') {
      return this.elementSelected;
    }
    return this.inputFieldGuessElementsInScene?.find((item) => item._isModalOpen) ?? null;
  }

  _getActiveInputField() {
    if (this._activeInputField) {
      return this._activeInputField;
    }
    const id = $("#elementSelected").val();
    if (id) {
      const byId = this.inputFieldElementsInScene?.find(
        (item) => String(item.getId?.() ?? item.id) === String(id)
      );
      if (byId) return byId;
    }
    if (this.elementSelected?.type === 'inputField') {
      return this.elementSelected;
    }
    return this.inputFieldElementsInScene?.find((item) => item._isModalOpen) ?? null;
  }

  _findInputField({ fieldKey, inputFieldId } = {}) {
    const fields = this.inputFieldElementsInScene || [];
    if (inputFieldId != null && String(inputFieldId).trim() !== '') {
      const byId = fields.find((item) => String(item.id || item.getId?.()) === String(inputFieldId));
      if (byId) return byId;
    }
    const key = slugifyFieldKey(fieldKey || '');
    if (key) {
      const byKey = fields.find((item) => slugifyFieldKey(item._getFieldKey?.() || item.dbConfig?.fieldKey || '') === key);
      if (byKey) return byKey;
    }
    return fields[0] || null;
  }

  openInputField(opts = {}) {
    const field = this._findInputField(opts);
    field?.openModal?.();
    return !!field;
  }

  _findTargetComponent(targetId, targetType) {
    if (targetType === 'vraiAgent') {
      return this.vraiAgentChairs?.find((c) => String(c.id) === String(targetId)) || null;
    }
    if (targetType === 'vapiUserCamera') {
      return this.vraiAgentCameras?.find((c) => String(c.id || c.getId?.()) === String(targetId)) || null;
    }
    if (targetType === 'vapiTranscription') {
      return this.vraiAgentTranscriptions?.find((t) => String(t.id || t.getId?.()) === String(targetId)) || null;
    }
    if (targetType === 'vapiButton') {
      return this.vraiAgentButtons?.find((b) => String(b.id || b.getId?.()) === String(targetId)) || null;
    }
    if (targetType === 'iframeElement') {
      return this.iframeElementsInScene?.find((item) => String(item.id || item.getId?.()) === String(targetId)) || null;
    }
    if (targetType === 'timerElement') {
      return this.timerElementsInScene?.find((item) => String(item.id || item.getId?.()) === String(targetId)) || null;
    }
    if (targetType === 'inputFieldGuess') {
      return this.inputFieldGuessElementsInScene?.find((item) => String(item.id || item.getId?.()) === String(targetId)) || null;
    }
    if (targetType === 'inputField') {
      return this.inputFieldElementsInScene?.find((item) => String(item.id || item.getId?.()) === String(targetId)) || null;
    }
    const mesh = this.find3dObject?.(targetId);
    return mesh?.parent || null;
  }

  _getOrCreateWelcomeScreen() {
    if (!this.model.welcomeScreen) {
      this.model.welcomeScreen = new WelcomeScreen(this.model);
    }
    return this.model.welcomeScreen;
  }

  _pauseModalVideo(selector) {
    const videoDom = $(selector);
    if (!videoDom.length) return;
    const video = videoDom.get(0);
    if (!video) return;
    video.pause?.();
    try { video.currentTime = 0; } catch (_) { }
  }

  _closeInfoElementModal() {
    const $modal = $("#infoElementModal");
    if (!$modal.hasClass("is-active")) return;
    $modal.removeClass("is-active");
    this._pauseModalVideo("#infoElementVideo");
    this.model?.dispatchEvent?.({ type: SCENE_INTERACTION.STOP_VIDEO_ON_CLICK });
  }

  _closeVideoGalleryModal() {
    const $modal = $("#videoGalleryModal");
    if ($modal.hasClass("is-active")) {
      $modal.removeClass("is-active");
    }
    this._pauseModalVideo("#videoGalleryVideo");
    const video = document.getElementById("videoGalleryVideo");
    if (video) video.src = "";
    this.model?.dispatchEvent?.({ type: SCENE_INTERACTION.STOP_VIDEO_ON_CLICK });
  }

  _closeProfileInfoModal() {
    $(".peer_info_modal").removeClass("is-active");
    this.model?.resetPeerChairOptions?.();
  }

  _forEachSceneObjectsOfType(type, fn) {
    const list = this.filtered3DObjects?.[type]
      || (type === "videoPlayer" ? this.filtered3DObjects?.videoPlayer : null)
      || [];
    if (!Array.isArray(list) || !list.length) return;
    list.forEach((item) => fn(item));
  }

  _closeElementOverlay(comp, type) {
    const resolvedType = type
      || comp?.type
      || comp?.name
      || comp?.dbConfig?.type
      || "";
    if (resolvedType === "infoElement") {
      this._closeInfoElementModal();
      return;
    }
    if (resolvedType === "imageGallery") {
      if (typeof comp?.runGalleryAction === "function") comp.runGalleryAction("closeGallery");
      else comp?.closeModal?.();
      return;
    }
    if (resolvedType === "videoGallery") {
      if (typeof comp?.closeVideo === "function") comp.closeVideo();
      else this._closeVideoGalleryModal();
      return;
    }
    if (isVideoPlayerType(resolvedType)) {
      if (typeof comp?.closeVideo === "function") comp.closeVideo();
      else comp?.closeModal?.();
      return;
    }
    if (resolvedType === "embeddedWebpage") {
      comp?.closeModal?.();
      this.render3DWorld = true;
      return;
    }
    if (resolvedType === "inputField" || resolvedType === "inputFieldGuess") {
      comp?.closeModal?.();
      return;
    }
    if (resolvedType === "profile") {
      this._closeProfileInfoModal();
      return;
    }
    if (resolvedType === WELCOME_SOURCE_TYPE || resolvedType === "welcome") {
      this._getOrCreateWelcomeScreen()?.closeWelcome?.();
      return;
    }
    if (typeof comp?.closeModal === "function") {
      comp.closeModal();
      return;
    }
    if (typeof comp?.closeVideo === "function") {
      comp.closeVideo();
      return;
    }
    if (typeof comp?.closeWelcome === "function") {
      comp.closeWelcome();
    }
  }

  _closeOpenContentElements() {
    this._closeInfoElementModal();
    this._closeVideoGalleryModal();
    this._closeProfileInfoModal();
    this._getOrCreateWelcomeScreen()?.closeWelcome?.();
    ["imageGallery", "videoGallery", "videoPlayer", "videoPlayerWebGL", "embeddedWebpage"].forEach((type) => {
      this._forEachSceneObjectsOfType(type, (item) => this._closeElementOverlay(item, type));
    });
    (this.inputFieldElementsInScene || []).forEach((item) => item?.closeModal?.());
    (this.inputFieldGuessElementsInScene || []).forEach((item) => item?.closeModal?.());
  }

  _executeCloseElementCommand(args = {}) {
    const objectId = args?.object_id || args?.objectId || args?.target_object_id;
    const objectType = args?.object_type || args?.objectType || args?.target_object_type;
    if (objectId) {
      this._executeAction({
        target_object_id: objectId,
        target_object_type: objectType,
        action: "closeElement",
      });
      return;
    }
    this._closeOpenContentElements();
  }

  _executeAction(ev) {
    if (isWelcomeEventTarget(ev.target_object_id, ev.target_object_type)) {
      const welcome = this._getOrCreateWelcomeScreen();
      if (ev.action === "openWelcome") welcome?.openWelcome?.({ force: true });
      else if (ev.action === "closeWelcome" || ev.action === "closeElement") welcome?.closeWelcome?.();
      return;
    }
    if (ev.action === "closeElement") {
      const sceneId = this.currentScene?.id;
      if (
        ev.target_object_type === SCENE_SOURCE_TYPE
        || isSceneLevelSource(ev.target_object_id, sceneId)
      ) {
        this._closeOpenContentElements();
        return;
      }
      const target = this._findTargetComponent(ev.target_object_id, ev.target_object_type);
      if (target) this._closeElementOverlay(target, ev.target_object_type);
      return;
    }
    const comp = this._findTargetComponent(ev.target_object_id, ev.target_object_type);
    if (!comp) return;
    const { action } = ev;
    if (action === 'show' || action === 'hide') {
      const visible = action === 'show';
      const isMusicObject = comp.name === 'vrMusicObject' || comp.dbConfig?.type === 'vrMusicObject';
      const isTimerElement = comp.name === 'timerElement'
        || comp.type === 'timerElement'
        || comp.dbConfig?.type === 'timerElement';
      const isInputField = comp.name === 'inputField'
        || comp.type === 'inputField'
        || comp.dbConfig?.type === 'inputField';
      const isInputFieldGuess = comp.name === 'inputFieldGuess'
        || comp.type === 'inputFieldGuess'
        || comp.dbConfig?.type === 'inputFieldGuess';
      const isWebLink = comp.name === 'webLink' || comp.dbConfig?.type === 'webLink';
      const isSceneChange = comp.name === 'sceneChange' || comp.dbConfig?.type === 'sceneChange';
      const isEmbeddedWebpage = comp.name === 'embeddedWebpage' || comp.dbConfig?.type === 'embeddedWebpage';
      const isInfoElement = comp.name === 'infoElement' || comp.dbConfig?.type === 'infoElement';
      const isVideoPlayer = isVideoPlayerType(comp.name) || isVideoPlayerType(comp.dbConfig?.type);
      const videoPlayerUsesIndicator = isVideoPlayer && comp.useIcon !== false && !comp.placeAs3dElement;
      const videoPlayerUsesMesh = isVideoPlayer && (comp.placeAs3dElement || !videoPlayerUsesIndicator);
      const webLinkUsesIndicator = isWebLink && (comp.useIcon || !comp.customIcon);
      const sceneChangeUsesIndicator = isSceneChange && (comp.useIcon || !comp.customIcon);
      const embeddedWebpageUsesIndicator = isEmbeddedWebpage && (comp.useIcon || !comp.customIcon);
      const infoElementUsesIndicator = isInfoElement && (comp.useIcon || !comp.customIcon);
      const mesh = comp.mesh || comp.anchor;
      if (isMusicObject) {
        if (mesh) {
          mesh.visible = false;
          if (mesh.material && !Array.isArray(mesh.material)) {
            mesh.material.opacity = 0;
            mesh.material.needsUpdate = true;
          }
        }
        return;
      }
      // Timer UI is edit-only; never reveal it via show/hide in view mode.
      if (isTimerElement) {
        if (mesh) mesh.visible = false;
        if (comp.anchor && comp.anchor !== mesh) comp.anchor.visible = false;
        if (comp.css3dObject) comp.css3dObject.visible = false;
        if (typeof comp._syncDomVisibilityToAnchor === 'function') {
          comp._syncDomVisibilityToAnchor();
        }
        return;
      }
      if ((isInputField || isInputFieldGuess) && !this.editMode) {
        comp._detachViewVisuals?.();
        return;
      }
      // webLink / videoPlayer / sceneChange / embeddedWebpage / infoElement: Use Icon → 2D indicator. Custom image → 3D mesh.
      if (!isWebLink && !isVideoPlayer && !isSceneChange && !isEmbeddedWebpage && !isInfoElement) {
        // For VAPI vrai-agent components with hideOnStart: they may not have been added to the scene yet.
        // Ensure they are added back on explicit "show".
        if (visible && !this.editMode && comp?.anchor && !comp.anchor.parent) {
          this.roomGroup.add(comp.anchor);
        }
        // When showing/hiding a vraiAgent chair, explicitly add/remove the chair (CSS3D) from
        // the scene graph and force DOM visibility. This avoids CSS3DRenderer edge cases where
        // toggling only Object3D.visible can still leave stale DOM visible for a frame.
        const isChair = comp?.type === 'vraiAgent' || comp?.name === 'vraiAgent';
        if (isChair && !this.editMode) {
          const chairId = comp.getId?.() ?? comp.id ?? comp.dbConfig?.id ?? null;
          const chairCfg = comp.getDbConfig?.() ?? comp.dbConfig ?? {};
          const cameraActive = chairCfg?.components?.camera?.active !== false;
          const targetCameras = this.vraiAgentCameras?.filter(c => String(c.dbConfig?.vapiAgentId) === String(chairId)) || [];
          const targetTranscriptions = this.vraiAgentTranscriptions?.filter(t => String(t.dbConfig?.vapiAgentId) === String(chairId)) || [];

          const setCompVisible = (c, next) => {
            if (!c) return;
            // Update both 3D and CSS3D DOM visibility paths.
            if (c.anchor) c.anchor.visible = next;
            if (c.css3dObject) c.css3dObject.visible = next;
            if (c.dom?.style) c.dom.style.display = next ? '' : 'none';
            if (typeof c._syncDomVisibilityToAnchor === 'function') c._syncDomVisibilityToAnchor();
          };

          if (visible) {
            // Add chair back if it wasn't in the scene (e.g. hideOnStart or previous hide action removed it).
            if (comp?.anchor && !comp.anchor.parent) this.roomGroup.add(comp.anchor);
            setCompVisible(comp, true);

            if (cameraActive) targetCameras.forEach(c => {
              if (c?.anchor && !c.anchor.parent) this.roomGroup.add(c.anchor);
              setCompVisible(c, true);
              // Match chair video-off preference; default to visible if unknown.
              const camOff = comp?._isCameraHidden;
              c.setCallCameraVisible?.(camOff === true ? false : true);
            });
            targetTranscriptions.forEach(t => {
              if (t?.anchor && !t.anchor.parent) this.roomGroup.add(t.anchor);
              setCompVisible(t, true);
            });
          } else {
            // Remove from scene graph so CSS3DRenderer doesn't keep rendering transforms.
            if (comp?.anchor?.parent === this.roomGroup) this.roomGroup.remove(comp.anchor);
            setCompVisible(comp, false);

            targetCameras.forEach(c => {
              if (c?.anchor?.parent === this.roomGroup) this.roomGroup.remove(c.anchor);
              setCompVisible(c, false);
            });
            targetTranscriptions.forEach(t => {
              if (t?.anchor?.parent === this.roomGroup) this.roomGroup.remove(t.anchor);
              setCompVisible(t, false);
            });
          }
        }
        if (mesh) mesh.visible = visible;
        if (comp.anchor && comp.anchor !== mesh) comp.anchor.visible = visible;
        const isVrInvisibleAction = comp?.type === 'vrInvisibleAction'
          || comp?.name === 'vrInvisibleAction'
          || comp?.dbConfig?.type === 'vrInvisibleAction';
        if (isVrInvisibleAction) {
          if (!comp.userData) comp.userData = {};
          comp.userData.hiddenBySceneAction = !visible;
        }
      } else if (videoPlayerUsesMesh && mesh) {
        mesh.visible = visible;
        if (mesh.material && !Array.isArray(mesh.material)) {
          mesh.material.opacity = visible ? 1 : 0;
          mesh.material.needsUpdate = true;
        }
      } else if ((videoPlayerUsesIndicator || webLinkUsesIndicator || sceneChangeUsesIndicator || embeddedWebpageUsesIndicator || infoElementUsesIndicator) && mesh) {
        mesh.visible = false;
        if (mesh.material && !Array.isArray(mesh.material)) {
          mesh.material.opacity = 0;
          mesh.material.needsUpdate = true;
        }
      } else if (mesh) {
        // Custom image: 3D mesh. Icon mode is handled above.
        const nextMeshVisible = visible && !webLinkUsesIndicator && !sceneChangeUsesIndicator && !embeddedWebpageUsesIndicator && !infoElementUsesIndicator;
        mesh.visible = nextMeshVisible;
        // Some scene-level hide animations fade materials (opacity=0) without toggling visibility.
        // Restore opacity explicitly so "show" reliably makes the mesh visible.
        if (mesh.material && !Array.isArray(mesh.material)) {
          mesh.material.opacity = nextMeshVisible ? 1 : 0;
          mesh.material.needsUpdate = true;
        }
      }
      let indicator = this.indicatorsArray?.find((i) => i.mesh === mesh);
      if (!indicator && (isWebLink || isSceneChange || isEmbeddedWebpage || isInfoElement || videoPlayerUsesIndicator)) {
        indicator = this.indicatorsArray?.find(
          (i) => i.mesh?.parent?.dbConfig && String(i.mesh.parent.dbConfig.id) === String(ev.target_object_id)
        );
      }
      if (indicator?.element) {
        const sel = indicator.element.startsWith('vrai-agent-2d-') || indicator.element.startsWith('vapi-')
          ? `.${indicator.element}` : `.indicator.${indicator.element}`;
        if (visible) {
          // Custom texture/image: prefer the 3D mesh and keep the 2D indicator hidden.
          if ((isWebLink && !webLinkUsesIndicator) || (isSceneChange && !sceneChangeUsesIndicator) || (isEmbeddedWebpage && !embeddedWebpageUsesIndicator) || (isInfoElement && !infoElementUsesIndicator) || videoPlayerUsesMesh) {
            $(sel).removeClass('visible shown-by-action hide-on-start').addClass('hidden-by-action');
          } else {
            $(sel).removeClass('hide-on-start').removeClass('hidden-by-action').addClass('visible').addClass('shown-by-action');
          }
        } else {
          $(sel).removeClass('visible').removeClass('shown-by-action').addClass('hidden-by-action');
          if (comp.dbConfig?.hideOnStart) $(sel).addClass('hide-on-start');
        }
      } else if ((isWebLink || isSceneChange || isEmbeddedWebpage || isInfoElement || videoPlayerUsesIndicator) && mesh?.id) {
        // Fallback: indicator lookup might fail after async texture updates.
        const sel = `.indicator.indicator-${mesh.id}`;
        if (visible) {
          if ((isWebLink && !webLinkUsesIndicator) || (isSceneChange && !sceneChangeUsesIndicator) || (isEmbeddedWebpage && !embeddedWebpageUsesIndicator) || (isInfoElement && !infoElementUsesIndicator)) {
            $(sel).removeClass('visible shown-by-action hide-on-start').addClass('hidden-by-action');
          } else {
            $(sel).removeClass('hide-on-start hidden-by-action').addClass('visible shown-by-action');
          }
        } else {
          $(sel).removeClass('visible shown-by-action').addClass('hidden-by-action');
          if (comp.dbConfig?.hideOnStart) $(sel).addClass('hide-on-start');
        }
      }
      if (typeof comp._syncDomVisibilityToAnchor === 'function') {
        comp._syncDomVisibilityToAnchor();
      }
      return;
    }
    if (action === 'animateCameraLookAt') {
      let duration = 1;
      if (ev.action_params) {
        try {
          const params = typeof ev.action_params === 'string' ? JSON.parse(ev.action_params) : ev.action_params;
          const d = Number(params?.duration);
          if (Number.isFinite(d) && d > 0) duration = d;
        } catch (_) { }
      }
      this.animateCameraLookAt(comp, duration);
      return;
    }
    switch (ev.target_object_type) {
      case 'sceneChange':
        if (action === 'goToScene') {
          this.elementSelected = comp.mesh || comp.dummySceneChangeMesh;
          this._sceneChangeClickEvent();
        }
        break;
      case 'vraiAgent':
        if (action === 'startCall') comp._initVapiCall?.();
        else if (action === 'endCall') {
          // Use _endCall so event/action triggers get the same confirm modal as UI controls.
          if (comp?._vapiConnecting || comp?._vapiCallActive) {
            comp._endCall?.();
          }
        }
        else if (action === 'switchAgent' && ev.action_params) {
          try {
            const config = typeof ev.action_params === 'string' ? JSON.parse(ev.action_params) : ev.action_params;
            if (!config?.VAPI_ASSISTANT_ID) break;
            const chairId = ev.target_object_id;
            const libraryId = config.libraryId ?? config.vapiLibraryId;
            const agentId = comp?._getAgentId?.() ?? comp?.id ?? chairId;

            const applySwitch = (sourceConfig) => {
              const prevCfg = comp?.dbConfig || {};
              const prevComponents = prevCfg.components || {};
              const nextComponents = { ...(sourceConfig.components || {}) };
              if (prevComponents?.camera?.active !== undefined && nextComponents?.camera?.active === undefined) {
                nextComponents.camera = { ...(nextComponents.camera || {}), active: prevComponents.camera.active };
              }
              if (prevComponents?.transcription?.active !== undefined && nextComponents?.transcription?.active === undefined) {
                nextComponents.transcription = { ...(nextComponents.transcription || {}), active: prevComponents.transcription.active };
              }
              if (prevComponents?.chair?.active !== undefined && nextComponents?.chair?.active === undefined) {
                nextComponents.chair = { ...(nextComponents.chair || {}), active: prevComponents.chair.active };
              }
              const scenario = (sourceConfig.chairScenario || sourceConfig.name || '').trim();
              const merged = {
                ...sourceConfig,
                chairScenario: scenario || prevCfg.chairScenario || '',
                chairName: sourceConfig.chairName || sourceConfig.name || prevCfg.chairName,
                vapiLibraryId: libraryId ?? sourceConfig.vapiLibraryId ?? prevCfg.vapiLibraryId,
                components: nextComponents,
                perspectiveOffsets: prevCfg.perspectiveOffsets ?? sourceConfig.perspectiveOffsets,
                width: prevCfg.width ?? sourceConfig.width,
                height: prevCfg.height ?? sourceConfig.height,
                size: prevCfg.size ?? sourceConfig.size,
                scale: prevCfg.scale ?? sourceConfig.scale,
              };

              comp._preservePerspectiveOnNextImageUpdate = true;
              comp.setDbConfig?.(merged);
              const sceneObj = this.currentScene?.objects?.find((o) => o.id === chairId && o.type === 'vraiAgent');
              if (sceneObj) {
                const { overrideLibraryId: _o, ...rest } = merged;
                Object.assign(sceneObj, rest);
              }
              const camObj = this.currentScene?.objects?.find((o) => o.type === 'vapiUserCamera' && String(o.vapiAgentId) === String(chairId));
              const trObj = this.currentScene?.objects?.find((o) => o.type === 'vapiTranscription' && String(o.vapiAgentId) === String(chairId));
              if (merged.components?.camera && camObj) {
                const newCamPO = merged.components.camera.perspectiveOffsets;
                if (newCamPO !== undefined) {
                  Object.assign(camObj, { perspectiveOffsets: newCamPO });
                  const camComp = this.vraiAgentCameras?.find((c) => String(c.id || c.getId?.()) === String(camObj.id));
                  camComp?.setDbConfig?.({ perspectiveOffsets: newCamPO });
                }
              }
              if (merged.components?.transcription && trObj) {
                const newTrPO = merged.components.transcription.perspectiveOffsets;
                if (newTrPO !== undefined) {
                  Object.assign(trObj, { perspectiveOffsets: newTrPO });
                  const trComp = this.vraiAgentTranscriptions?.find((t) => String(t.id || t.getId?.()) === String(trObj.id));
                  trComp?.setDbConfig?.({ perspectiveOffsets: newTrPO });
                }
              }
              if (this.model?.dispatchEvent) {
                this.model.dispatchEvent({ type: 'vapi-agent-changed', data: { vapiAgentId: chairId } });
              }
              this._executeEventActions(chairId, 'agentChanged');
            };

            const runSwitch = () => {
              if (!libraryId || !this.model?.worldFetcher?.switchAgentConfig) {
                applySwitch(config);
                return;
              }
              this.model.worldFetcher.switchAgentConfig(
                this.worldID,
                agentId,
                libraryId,
                () => {
                  const listFn = this.model?.worldFetcher?.listVapiAgents;
                  if (listFn) {
                    listFn(
                      this.worldID,
                      (res) => {
                        const selected = (res?.agents || []).find((a) => String(a.id) === String(libraryId));
                        if (selected) {
                          applySwitch(mergeLibraryAgentIntoChairConfig(comp?.dbConfig || {}, selected, libraryId));
                        } else {
                          applySwitch(config);
                        }
                      },
                      () => applySwitch(config)
                    );
                  } else {
                    applySwitch(config);
                  }
                },
                () => applySwitch(config)
              );
            };

            const doSwitch = () => runSwitch();

            const stopActiveSessionForSwitch = () => {
              comp?._forceStopVapiSession?.({
                callEndData: { cancelled: true, switchedAgent: true }
              });
            };

            if ((comp?._vapiCallActive || comp?._vapiConnecting) && this.model?.confirm) {
              const msg = (typeof $trans !== 'undefined' && $trans('vrai-agent-switch-stop-process-confirm')) ||
                'Switching the AI agent will end the current call/process. Continue?';
              this.model.confirm(msg, () => {
                stopActiveSessionForSwitch();
                doSwitch();
              });
            } else {
              if (comp?._vapiCallActive || comp?._vapiConnecting) {
                stopActiveSessionForSwitch();
              }
              doSwitch();
            }
          } catch (_) { }
        }
        else if (action === 'sendCommand') {
          let text = '';
          let commandButtonId = null;
          if (ev.action_params) {
            try {
              const params = typeof ev.action_params === 'string' ? JSON.parse(ev.action_params) : ev.action_params;
              text = String(params?.commandText || '').trim();
              commandButtonId = params?.commandButtonId ?? null;
            } catch (_) { }
          }
          const agentId = comp?._getAgentId?.() ?? comp?.id ?? ev.target_object_id;
          if (commandButtonId != null) {
            const btnComp = this.vraiAgentButtons?.find((b) => String(b?.id ?? b?.getId?.()) === String(commandButtonId));
            if (btnComp?.dispatchCommand) {
              btnComp.dispatchCommand(text || null);
              break;
            }
          }
          comp.dispatchCommand?.(text || null);
        }
        else if (action === 'openInputField') {
          let params = {};
          if (ev.action_params) {
            try {
              params = typeof ev.action_params === 'string' ? JSON.parse(ev.action_params) : ev.action_params;
            } catch (_) { }
          }
          this.openInputField({
            fieldKey: params.fieldKey || params.field_key,
            inputFieldId: params.inputFieldId || params.input_field_id,
          });
        }
        break;
      case 'vapiUserCamera':
        if (action === 'sendCommand') {
          let text = '';
          if (ev.action_params) {
            try {
              const params = typeof ev.action_params === 'string' ? JSON.parse(ev.action_params) : ev.action_params;
              text = String(params?.commandText || '').trim();
            } catch (_) { }
          }
          comp.dispatchCommand?.(text || null);
        }
        break;
      case 'vapiButton':
        if (action === 'sendCommand') {
          let text = '';
          if (ev.action_params) {
            try {
              const params = typeof ev.action_params === 'string' ? JSON.parse(ev.action_params) : ev.action_params;
              text = String(params?.commandText || '').trim();
            } catch (_) { }
          }
          comp.dispatchCommand?.(text || null);
        }
        break;
      case 'webLink':
        if (action === 'openLink') {
          const link = comp.getLink?.();
          if (link) window.open(link, comp.dbConfig?.openNewWindow ? '_blank' : '_top');
        }
        break;
      case 'baglessRoom':
        if (action === 'goToRoom') {
          const link = comp.getLink?.();
          if (link && comp.clickable) window.open(link, '_top');
        }
        break;
      case 'youtube':
        if (action === 'play') comp.play?.();
        else if (action === 'pause') comp.pause?.();
        break;
      case 'videoPlayer':
      case 'videoPlayerWebGL':
        if (action === 'playOnce') comp.playOnce?.();
        else if (action === 'playLoop') comp.playLoop?.();
        else if (action === 'stopPlaying') comp.stopPlaying?.();
        else if (action === 'closeVideo') {
          if (typeof comp.closeVideo === 'function') comp.closeVideo();
          else comp.closeModal?.();
        }
        else if (action === 'play') {
          if (comp.placeAs3dElement) {
            comp.playOnClick?.();
          } else if (typeof comp.openModal === 'function') {
            comp.openModal();
          } else {
            comp.videoPlayer?.play?.();
          }
        }
        else if (action === 'pause') {
          if (comp.placeAs3dElement) comp.stopPlaying?.();
          else comp.videoPlayer?.pause?.();
        }
        break;
      case 'vrMusicObject':
        if (action === 'playOnce') comp.playOnce?.();
        else if (action === 'playLoop') comp.playLoop?.();
        else if (action === 'stopPlaying') comp.stopPlaying?.();
        break;
      case 'iframeAgent':
        if (action === 'open') comp.openModal?.();
        break;
      case 'timerElement':
        if (action === 'startTimer') comp.startTimer?.();
        else if (action === 'stopTimer') comp.stopTimer?.();
        else if (action === 'resetTimer') comp.resetTimer?.();
        break;
      case 'profile':
        if (action === 'showProfile') {
          this.elementSelected = comp.mesh;
          this._profileClickEvent();
        }
        break;
      case 'infoElement':
        if (action === 'showInfo') comp.openModal?.();
        break;
      case 'embeddedWebpage':
        if (action === 'openEmbeddedWebpage') {
          this.render3DWorld = false;
          comp.openModal?.();
        }
        break;
      case 'inputFieldGuess':
        if (action === 'open') comp.openModal?.();
        else if (action === 'close') comp.closeModal?.();
        break;
      case 'inputField':
        if (action === 'open' || action === 'openInputField') comp.openModal?.();
        else if (action === 'close') comp.closeModal?.();
        break;
      case 'imageGallery':
        if (typeof comp.runGalleryAction === 'function') {
          let params = {};
          if (ev.action_params) {
            try {
              params = typeof ev.action_params === 'string' ? JSON.parse(ev.action_params) : ev.action_params;
            } catch (_) { }
          }
          comp.runGalleryAction(action, params || {});
        }
        break;
      case 'videoGallery':
        if (action === 'playOnce') comp.playOnce?.();
        else if (action === 'playLoop') comp.playLoop?.();
        else if (action === 'stopPlaying') comp.stopPlaying?.();
        else if (action === 'openGallery') comp.openModal?.();
        break;
      default:
        break;
    }
  }

  _toggleAudioEvent() {
    this.model.iStream.audio = !this.model.iStream.audio;
    this.model.iStream.audio ? this.handleAudioOn() : this.handleAudioOff();
  }

  _toggleScreenAudioEvent() {
    const state = !this.model.screenShareMuted;
    $("#toggleScreenShareAudio p").text(state ? $trans('unmute-text') : $trans('mute-text'));
    $("#toggleScreenShareAudio p").attr("data-lang", state ? "unmute-text" : "mute-text");
    $("#toggleScreenShareAudio span").html(state ? "volume_off" : "volume_up");
    this.elementSelected.parent.toggleAudio();
  }

  _toggleGrid() {
    $("#gridToggle").trigger("click");
  }

  _toggleTextureClickEvent() {

    if (this.readyForClick) {
      this.model.iStream.video = !this.model.iStream.video;
      this.readyForClick = false;
      this.model.iStream.video ? this.handleVideoStreamOn() : this.handleVideoStreamOff();
    } else {
      this.model.alert('error', $trans('error-video-stream-not-ready'));
    }

  }

  _userInfoEvent() {
    this.model.onNavbarOpen();
    this.elementSelected.parent.showInfo();
    if (this.model.tourIsRunning() && this.model.iAmGuide()) {
      this.model.socket.socketTour.onTourClicked(this.elementSelected.parent.dbConfig)
    }
  }

  _userAddAsFriend() {
    this.model.onNavbarOpen();
    this.elementSelected.parent.addAsFriend();
  }

  _chatEvent() {
    this.model.onNavbarOpen();
    this.elementSelected.parent.initiateChat();
  }

  _videoCallEvent() {
    //TODO check if user is screensharing and add info element do you want to stop it?
    this.model.onNavbarOpen();
    this.elementSelected.parent.initiateVideoCall();
  }

  isBlockedByAgentCall() {
    return this.model.isTalkingWithAgent?.() === true;
  }

  showAgentCallBlockedError() {
    this.model.showTalkingWithAgentError?.();
  }

  async endActiveOneOnOneCall() {
    const controller = window.oneOnOneController;
    if (!controller || !this.model.activeOneOnOneCall) {
      return;
    }

    const classToBeRemoved = `video_notification_from_${controller.myInfo?.userId}`;
    await controller.hangUpCall(true, true);
    this.model.dispatchEvent({ type: WEBRTC_EVENTS.WEBRTC_CALL_CANCELED, data: { classToBeRemoved } });
  }

  confirmEndOneOnOneThen(continueAction) {
    this.model.confirm(
      $trans('confirm-end-one-on-one-to-continue'),
      async () => {
        await this.endActiveOneOnOneCall();
        continueAction();
      },
      {
        header: true,
        logo: false,
        title: $trans('action-end-call'),
        confirmBtnTxt: $trans('end-call-and-continue'),
        cancelBtnTxt: $trans('cancel-text'),
        modalTheme: CONFIRM_NOTIFICATION_THEME.DARK,
        modalType: CONFIRM_NOTIFICATION_TYPE.CONFIRM,
        modalSize: CONFIRM_NOTIFICATION_SIZE.SM,
        buttonSize: CONFIRM_BUTTON_SIZE.FULL,
      }
    );
  }

  isTourModeAvailable() {
    const tourModeAvailable = this.model?.sceneData?.tourModeAvailable;
    return tourModeAvailable === 1 || tourModeAvailable === true || String(tourModeAvailable) === '1';
  }

  updateGuideButtonVisibility() {
    if (!this.guideButton || this.guideButton.length === 0) return;
    const available = this.isTourModeAvailable();
    // Keep the button visible but disable it when tour mode is unavailable/undefined.
    this.guideButton.toggle(true);
    this.guideButton.toggleClass('disabled', !available);
  }

  stopAllActiveVapiCallsForSceneChange() {
    roomGuide484.onSceneLeaving(this);
    const chairs = this.vraiAgentChairs || [];
    chairs.forEach((chair) => {
      if (!chair) return;
      try {
        if (typeof chair.stopForSceneChange === 'function') {
          chair.stopForSceneChange();
          return;
        }
        if (chair._vapi) {
          chair._vapi.stop();
        }
        chair._vapi = null;
        chair._vapiCallActive = false;
        chair._vapiConnecting = false;
        chair._stopMedia?.();
        chair._updateCallRunningClass?.();
      } catch (err) {
        console.warn('[scene-change] failed to stop VAPI call', err);
      }
    });
    if (this.model) this.model._vapiAgentSceneChangeHandoff = false;
  }

  _chessGameClickEvent() {
    if (this.isBlockedByAgentCall()) {
      this.showAgentCallBlockedError();
      return;
    }
    if (this.model.notAvailableInTourMode() || (this.model.iAmGuide() || this.model.guide)) {
      this.model.alert('error', $trans('error-not-available-intour-mode'));
      return;
    }
    if (this.model.activeOneOnOneCall) {
      this.confirmEndOneOnOneThen(() => this._chessGameClickEvent());
      return;
    }
    const isScreenStream = this.iSitOnScreenStream();
    if (this.iSitOnChair() || isScreenStream) {
      this.model.confirm($trans('enter-chess-but-you-are-sitting'), () => {
        if (!this.elementSelected?.parent?.gameData?.isLocked) {
          this.leaveSeatNoPrompt();
          if (isScreenStream) {
            this.forceStopScreenShare(isScreenStream);
          }
          this.render3DWorld = false;
          this.customRenderMode = false;
          this.model.chessGameMode = true;
          this.model.hideLoading();
          $('#world-button-nav__default').hide();
        }
        this.elementSelected.parent.joinMultiplayerLobby();
      }, { header: false, });
      return;
    }
    else {
      if (!this.elementSelected?.parent?.gameData?.isLocked) {
        this.render3DWorld = true;
        this.customRenderMode = false;
        this.model.chessGameMode = true;
        this.model.hideLoading();
        $('#world-button-nav__default').hide();
      }
      this.elementSelected.parent.joinMultiplayerLobby();
    }
  }

  _chessGameAvatarClickEvent() {
    this.elementSelected = this.elementSelected.parent;
    this.elementSelected.parent.joinMultiplayerLobby();
  }

  _payPalDonationClickEvent() {
    this.elementSelected.parent.showDonationModal();
  }

  // Legacy sphere tile-streaming helpers. Keep them as safe fallbacks even when
  // no explicit tile-streaming layout is configured for the current scene.
  _isSphereTileStreamingLayout() {
    const bg = this.currentScene?.background || {};
    const layout = this.currentScene?.layout || this.currentScene?.backgroundLayout;
    return Boolean(
      bg.tileStreaming === true ||
      bg.isTileStreaming === true ||
      layout === 'sphereTileStreaming'
    );
  }

  _exitSphereTileStreamingMode() {
    if (!this._isSphereTileStreamingLayout()) return;
    if (this.sphereMesh) this.sphereMesh.visible = true;
    if (this.sphereMeshLowTexture) this.sphereMeshLowTexture.visible = false;
  }

  _applySphereTileStreamingMeshVisibility() {
    if (!this._isSphereTileStreamingLayout()) return;
    if (this.sphereMesh) this.sphereMesh.visible = false;
    if (this.sphereMeshLowTexture) this.sphereMeshLowTexture.visible = true;
  }

  handleVideoStreamOn = () => {
    this.model.dispatchEvent({ type: SCENE_EVENTS.USER_SEAT_TURN_CAMERA_ON })
    this.readyForClick = true;
    this.turnOnVideoIconFromUserMenu();
    this.model.userWantsCamera = true;
    this.model.onUserTogglesCameraOnCta();
  }

  turnOnVideoIconFromUserMenu = () => {
    $(".local-video").addClass('visible');
    $("#toggleVideoTrack p").text($trans('turn-cam-off-text'));
    $("#toggleVideoTrack p").attr('data-lang', 'turn-cam-off-text');
    $("#toggleVideoTrack span").html("videocam");
  }

  handleVideoStreamOff = () => {
    this.model.dispatchEvent({ type: SCENE_EVENTS.USER_SEAT_TURN_CAMERA_OFF })
    this.readyForClick = true;
    this.turnOffVideoIconFromUserMenu();
    this.model.userWantsCamera = false;
    this.model.onUserTogglesCameraOnCta();
  }
  turnOffVideoIconFromUserMenu = () => {
    $(".local-video").removeClass('visible');
    $("#toggleVideoTrack p").text($trans('turn-cam-on-text'));
    $("#toggleVideoTrack p").attr('data-lang', 'turn-cam-on-text');
    $("#toggleVideoTrack span").html("videocam_off");
  }

  handleAudioOn = () => {
    this.model.iStream.audio = true;
    this.model.userWantsAudio = true;
    this.model.dispatchEvent({ type: SCENE_EVENTS.USER_SEAT_TURN_MIC_ON })
    this.turnOnAudioIcons();
    this.model.onUserTogglesMicrophoneOnCta();
  }
  turnOnAudioIcons = () => {
    $("#toggleAudioTrack p").text($trans('turn-mic-off-text'));
    $("#toggleAudioTrack p").attr("data-lang", "turn-mic-off-text");
    $("#toggleAudioTrack span").html("mic");
  }

  handleAudioOff = () => {
    this.model.iStream.audio = false;
    this.model.userWantsAudio = false;
    this.model.dispatchEvent({ type: SCENE_EVENTS.USER_SEAT_TURN_MIC_OFF })
    this.readyForClick = true;
    this.turnOffAudioIcons();
    this.model.onUserTogglesMicrophoneOnCta();
  }
  turnOffAudioIcons = () => {
    $("#toggleAudioTrack p").text($trans('turn-mic-on-text'));
    $("#toggleAudioTrack p").attr("data-lang", "turn-mic-on-text");
    $("#toggleAudioTrack span").html("mic_off");
  }

  nextScene(id) {
    const scene = this.model.scenes[id];
    if (!scene?.background?.mediumPath) {
      this._notifyMissingScene(id);
      return;
    }
    this.removeMeFromOtherChairs();
    this._stopSceneLoopedSounds();
    this.currentScene = scene;
    this.model.currentScene = this.currentScene;
    let t = this.textureLoaderSilent.load(this.currentScene.background.mediumPath, (texture) => {
      t = texture;
    });
    this._buildWorld(t)
  }

  _sceneChangeClickEvent(el, onComplete, force = false) {
    this.stopAllActiveVapiCallsForSceneChange();
    this._stopSceneLoopedSounds();
    const element = el || this.elementSelected;
    if (!element) {
      console.log('[sceneChange] Clicked object does not exist');
      console.warn('[sceneChange] Clicked object does not exist');
      this.model?.alert?.(
        'error',
        $trans('error-clicked-object-does-not-exist', {}, 'This object does not exist and could not be opened.')
      );
      return;
    }
    const { parent } = element;

    const goToSceneId = parent?.dbConfig?.goToSceneId || this.model.nextSceneId;
    if (goToSceneId === 'EDITOR') {
      return;
    }

    const targetID = parent?.targetRoomId || element.parent?.targetRoomId || this.model.nextSceneId || goToSceneId;
    const targetScene = targetID ? this.model.scenes[targetID] : null;
    if (targetID && !targetScene?.background) {
      this._notifyMissingScene(targetID);
      return;
    }

    this.sphereMesh.visible = true;
    this.sphereMeshLowTexture.visible = false;

    const targetPosition = new Vector3();
    const targetOrientation = new Quaternion();
    const targetScale = new Vector3();

    let rotateToTargetAnimationDuration = 0.8;

    this.controlsActive = false;
    this.controls.enabled = false;
    this.setControlsUpdate(false);

    // Intro tweens `from` extra roomGroup rotation/position. If they are still running,
    // they overwrite the destination scene's north after _buildWorld.
    if (this.roomGroup) {
      gsap.killTweensOf(this.roomGroup.rotation);
      gsap.killTweensOf(this.roomGroup.position);
      this.roomGroup.position.set(0, 0, 0);
      this.roomGroup.rotation.y = this.editMode ? 0 : this._getEffectiveSceneRotationY(this.currentScene);
    }

    if (this.model.iAmInTour()) {
      this.model.socket.disableGuidedCamera();
      if (this.model.iAmGuide()) {
        const goToSceneId = parent?.dbConfig?.goToSceneId || this.model.nextSceneId;
        this.model.socket.socketTour.onTourClicked({ type: "sceneChange", goToSceneId });
        this.model.socket.socketTour.onTourClicked({ type: "closeModal" })
      }
    }

    if (element.type === 'cameraPointingMesh') {
      element.matrixWorld.decompose(targetPosition, targetOrientation, targetScale);
      rotateToTargetAnimationDuration = 0;
    } else {
      const animationTarget = parent?.dummySceneChangeMesh || element;
      if (!animationTarget?.matrixWorld) {
        this.setControlsUpdate(true);
        this.controls.enabled = true;
        this.controlsActive = true;
        return;
      }
      animationTarget.matrixWorld.decompose(targetPosition, targetOrientation, targetScale);
    }

    !el && parent?.onClick?.();
    if (parent?.locked && !force) {
      let promptMessage = $trans('confirm-want-to-knock');
      if (parent.currentUser) {
        this.model.sendRequestToUser = parent.currentUser;
        this.model.selectedElement = el;
        promptMessage = `${$trans('confirm-locked-by')} ${parent.currentUser.userName}. ${promptMessage}`;
      }
      this.model.confirm(promptMessage, () => {
        this.model.askForLockedRoomEnter(parent.targetRoomId);
      }, { header: true, title: 'Locked room' });
      return;
    }

    this.model.isAnimating = true;

    this.camera.rotateOnWorldAxis(new Vector3(0, 1, 0), this.pivot.rotation.y);
    this.pivot.rotation.y = 0;
    this.pivotX.rotation.x = 0;
    let startOrientation = this.camera.quaternion.clone();

    $("#peer-radial-actions").prop("checked", false);

    const cam = this.camera;

    targetID && this.model.onUserSceneChange(targetID);

    const isPaidLocation = this.isPaidLocation(targetScene);


    const sceneChange = () => {
      this.checkSeatAvailableTimer && clearInterval(this.checkSeatAvailableTimer);
      this.checkSeatAvailableTimer = null;
      this.historyLastLocation = this.currentScene.id;

      for (let x = 0; x < this.scenes.length; x++) {
        if (this.scenes[x].id === targetID) {
          this.currentSceneIndex = x;
          this.currentScene = this.scenes[x];
          sessionStorage.setItem('current_scene', x);
          this.model.dispatchEvent({ type: SCENE_EVENTS.START_SCENE_CHANGE, ...this.currentScene })
          break;
        }
      }

      const alreadyLoadedTexture = this._getCachedTexture(targetScene.background.mediumPath);

      const animate = (texture) => {

        let cameraDirection = new Vector3();

        gsap.to({}, {
          duration: .4,
          ease: Expo.easeOut,
          onStart: () => {
            this.model.nextSceneId = null;
            this.sphereMesh.visible = true;
            this.sphereMeshLowTexture.visible = false;
            this.camera.getWorldDirection(cameraDirection);
          },
          onUpdate: function () {
            cam.position.lerp(targetPosition, this.ratio * 0.15);
            if (this.ratio > 0.5) {
              element.material.opacity = 1.3 - this.ratio;
            }
          },
          onComplete: () => {
            this._buildWorld(texture);
            this.loadAndPlayAmbientSound(this.currentScene.ambientAudio);

            // !alreadyLoadedTexture && this.textureLoaderSilent.load(targetScene.background.mediumPath, (hiResTexture) => {
            //   this._updateSphereTexture(hiResTexture);
            //   this.visitedRoomsTextures.push({ id: targetScene.background.mediumPath.mediumPath, texture: texture });
            // });
            this.setControlsUpdate(true);
            this.controls.enabled = true;
            this.controlsActive = true;
            // if(!this.enableDeviceOrientationControl){
            cameraDirection.x *= -1;
            cameraDirection.y *= -1;
            cameraDirection.z *= -1;
            // }

            this.camera.position.copy(cameraDirection);

            $("#location_name").text(this.currentScene.publicName);
            $("#location_name").attr('data-id', this.currentScene.id);

            const fov = this.camera.fov;

            gsap.fromTo(this.camera,
              { fov: fov + 30 },
              {
                fov: fov, duration: .8, onUpdate: () => { this.camera.updateProjectionMatrix(); }, onComplete: () => {
                  this.model.isAnimating = false;
                  this.sphereMesh.visible = false;
                  this.sphereMeshLowTexture.visible = true;
                  this.model.dispatchEvent({ type: SCENE_EVENTS.STOP_SCENE_CHANGE });
                }
              }
            );
            onComplete && onComplete();


            if (this.model.iAmInTour()) {
              this.model.socket.enableGuidedCamera();
              this.controls.enabled = false;
            }
            if (this.model.iAmGuide()) {
              this.controls.enabled = true;
            }
            this.controls.update();

            setTimeout(() => {
              $(".indicator").removeClass("opacity");
              $(".indicator").toggleClass('hideElements', !this.model.showElements); // indicators
              this.model.showElements ? this.showAllElements(false) : this.hideAllElements(false); // 3d elements without indicators or with custom texture
              this._roomEnteredViaSceneChange = true;
              this._pendingRoomEntered = true;
              this._executeRoomEnteredWhenReady();
            }, 300);
          }
        });
      }

      gsap.to({}, {
        duration: rotateToTargetAnimationDuration,
        ease: Expo.easeOut,
        onUpdate: function () {
          cam.quaternion.copy(startOrientation).slerp(targetOrientation, this.ratio);
        },
        onComplete: () => {

          this.model.dispatchEvent({ type: SCENE_EVENTS.SCENE_CHANGED, data: { scene: this.currentScene } });
          if (this.webRTCScopeType === 'scene') {
            this.endStream();
          }

          this.iSit = false;

          if (this.model.iSitOnThisVRChair !== null) {
            this.model.iSitOnThisVRChair.standUp();
            this.model.onStandUp(this.model.iSitOnThisVRChair.dbConfig);
            this.model.iSitOnThisVRChair = null;
          }

          this.removeMeFromOtherChairs();
          this._stopScreenShare();

          if (this.model.iShareScreen) {
            console.log('sceneChange iShareScreen: ', this.model.iShareScreen);
            let parent = this.model.iShareOnThisObj;
            if (parent) {
              parent.triggerStopBtn();
            }
          }

          this.ambientSound.isPlaying && this.fadeOutAmbientAudio(.4);

          if (!!alreadyLoadedTexture) {
            console.log('visited this room before');
            animate(alreadyLoadedTexture);

          } else {
            this.model.showLoading()
            let url = this.currentScene.background.mediumPath;
            const hasLowRes = (this.model.sceneHasLowResImage[this.currentScene.id]);
            if (hasLowRes) {
              url = getLowResImageUrl(this.currentScene.background.mediumPath)
            }
            this.textureLoaderSilent.load(url, (lowResText) => {
              this.model.hideLoading()
              animate(lowResText);
            });
          }
        }
      });
    }

    if (isPaidLocation) {
      this.validateTicketIfPaidLocation(targetScene).then((valid) => {
        if (valid) {
          sceneChange();
        } else {
          let bodyContent = 'This location can be access only after buying a ticket!';

          let price = 0;
          let currency = '';
          let description = '';

          if (Object.keys(targetScene.locationWithPayment).length > 1) {
            const obj = targetScene.locationWithPayment;
            price = obj.price;
            currency = obj.hasOwnProperty('currency') ? obj.currency : 'eur';
            description = obj.description;


            bodyContent = `
            <p>You don´t own a valid ticket for this location. Do you want to pay ${price} ${currency.toUpperCase()} to buy one?</p>
            <p>${obj.duration.fromDate ? "Ticket will be valid from " + obj.duration.fromDate.replace("T", " ") : ""}
            ${obj.duration.untilDate ? " until " + obj.duration.untilDate.replace("T", " ") : ""}</p>
            <p>${obj.duration.days ? "Ticket will be valid for " + obj.duration.days + " " + (obj.duration.days == 1 ? "day." : "days.") : ""}</p>
            <h3 style='margin-top: 50px;'>What's inside?</h3>
            <p>${description}</p>
            `;
          }

          this.model.confirm(bodyContent, () => {
            if (this.model.config.isGuest) {
              this.model.info('info', $trans('error-guest-cannot-buy-tickets'));
              return;
            }
            this.model.buyLocationTicket({
              roomId: this.worldID,
              currentLocation: window.location.href,
              targetLocationId: targetScene.id,
              image: getImgThumb(targetScene.background.mediumPath)
            });
          }, { header: true, title: 'Ticket required', confirmBtnTxt: 'Buy ticket' },
            () => {
              this.setControlsUpdate(true);
              this.controls.enabled = true;
              this.controlsActive = true;
            });
        }
      });
    } else {
      sceneChange();
    }

  }

  _infoElementClickEvent() {
    if (this.model.notAvailableInTourMode()) {
      this.model.alert('error', $trans('error-not-available-intour-mode'));
      return;
    }
    const parent = this.elementSelected?.parent;
    if (!parent?.openModal) return;
    parent.openModal();
    if (this.model.iAmGuide()) {
      this.model.socket.socketTour.onTourClicked(parent.dbConfig);
    }
  }

  _embeddedWebpageClickEvent() {
    this.render3DWorld = false;
    this.elementSelected.parent.openModal();
    if (this.model.tourIsRunning() && this.model.iAmGuide()) {
      this.model.socket.socketTour.onTourClicked(this.elementSelected.parent.dbConfig)
    }
  }
  onTourScreenShareSelectedElement(e) {
    this.elementSelected.parent.showUserOptions();
  }
  onImageGalleryClick(e) {
    const parent = this.elementSelected?.parent;
    if (!parent) return;
    const sourceId = parent.dbConfig?.id ?? parent.getId?.() ?? parent.id ?? parent.uuid;
    const events = this._getClickEventsForSource(sourceId);
    if (events?.length && !this.editMode) {
      events.forEach((ev) => this._executeAction(ev));
      return;
    }
    parent.openModal();
    if (this.model.tourIsRunning() && this.model.iAmGuide()) {
      this.model.socket.socketTour.onTourClicked(parent.dbConfig);
    }
  }
  onSeatCameraClick(e) {
    const chair = this._getVrChairFromSelected();
    if (chair?.isMine()) {
      this.toggleCameraSeat()
    }
  }
  onSeatMicrophoneClick(e) {
    const chair = this._getVrChairFromSelected();
    if (!chair) {
      return;
    }
    if (chair.isMine()) {
      this._toggleAudioEvent();
      return;
    }
    if (chair.isEmpty()) {
      return;
    }
    if (this.model.config.isGuest) {
      return;
    }
    const user = chair.getUserInfo?.() || chair.userData || this.model.socket.getUsersObject()?.[chair.state?.userId];
    this.model.requestToggleOtherUserMic(user, true);
  }
  _getVrChairFromSelected() {
    let obj = this.elementSelected;
    while (obj) {
      if (typeof obj.isMine === 'function' && typeof obj.isEmpty === 'function') {
        return obj;
      }
      obj = obj.parent;
    }
    return null;
  }
  _applyRequestedSeatMicState(e) {
    const { sender, requestedUser } = e.data || {};
    if (!requestedUser || String(requestedUser.userId) !== String(this.model.config.userId)) {
      return;
    }
    if (!this.iSitOnChair()) {
      return;
    }
    if (typeof this.model.iAmInTour === 'function' && this.model.iAmInTour()) {
      return;
    }

    if (sender?.isGuest) {
      return;
    }

    const wantMuted = requestedUser.userAudioMuted === true;
    const iAmMuted = !this.model.iStream.audio;
    const senderName = sender?.userName || $trans('someone-text', {}, 'Someone');

    if (wantMuted && !iAmMuted) {
      this.handleAudioOff();
      this.model.info('info', `${senderName} ${$trans('has-muted-you', {}, 'has muted you.')}`);
    }
  }
  onVideoGalleryClick(e) {
    // autoplay "1" = open modal with video
    if (this.elementSelected && this.elementSelected.parent.dbConfig.autoplay === "1") {
      $("#videoGalleryModal").addClass("is-active");
      const video = $("#videoGalleryVideo")[0];
      video.src = this.elementSelected.parent.dbConfig.url;
      video.load();
      video.play();
      const aspectRatio = video.videoWidth / video.videoHeight;
      if (aspectRatio > 1) {
        // Landscape mode
        video.classList.add('landscape');
      } else {
        // Portrait mode
        video.classList.add('portrait');
      }
      if (this.model.tourIsRunning() && this.model.iAmGuide()) {
        this.model.socket.socketTour.onTourClicked({ type: "videoModal", url: video.src })
      }
    }
  }

  onVideoPlayerClick(e) {
    if (this.elementSelected && this.elementSelected.parent) {
      const videoPlayer = this.elementSelected.parent;
      const videoUrl = videoPlayer.dbConfig.videoUrl;
      const videoTitle = videoPlayer.dbConfig.videoTitle;

      // Check if video URL exists
      if (!videoUrl) {
        this.model.alert("error", $trans('no-video-uploaded-yet'));
        return;
      }

      // Avoid re-applying scene config on every click (can trigger a first-frame preview
      // that races with "play on click"). Only update the scene when the URL changes.
      if (videoPlayer.placeAs3dElement) {
        if (videoPlayer.videoUrl !== videoUrl) {
          videoPlayer.setVideoUrl(videoUrl, videoTitle);
        } else {
          videoPlayer.videoTitle = videoTitle;
        }
      } else {
        // Non-3D mode: safe to update title/url for modal.
        videoPlayer.setVideoUrl(videoUrl, videoTitle);
      }

      if (videoPlayer.placeAs3dElement) {
        const v = videoPlayer.dbConfig?.playOnClick;
        const playOnClickEnabled = !(v === false || v === 'false' || v === 0 || v === '0');
        if (playOnClickEnabled) {
          videoPlayer.playOnClick();
        }
        return;
      }

      // Open modal and play video (non-3D mode only)
      videoPlayer.openModal();

      // Tour integration
      if (this.model.tourIsRunning() && this.model.iAmGuide()) {
        this.model.socket.socketTour.onTourClicked({
          type: "videoPlayerModal",
          url: videoUrl,
          title: videoTitle
        });
      }
    }
  }


  endStream() {
    this.model.iStream.video = false;
    this.model.iStream.audio = false;
    this.model.dispatchEvent({ type: WEBRTC_EVENTS.WEBRTC_STOP_SCOPE });
    $("#gridToggle").addClass('hidden');
  }

  resizeFocusedElement() {
    const breakpoint = 750;

    $(".grid_divider").on("mousedown", (event) => {
      this.isDividerDragging = true;
      $(".focus-mode").css({ 'cursor': $(".localVideoWrapper").width() > breakpoint ? 'ew-resize!important' : 'ns-resize!important' });
    });

    $(".localVideoWrapper").on("mouseup", () => {
      this.isDividerDragging = false;
      $(".focus-mode").css({ 'cursor': 'auto' });
    });

    $(".localVideoWrapper").on("mousemove", (event) => {
      if (this.isDividerDragging) {
        event.preventDefault();
        const totalWidth = $(".localVideoWrapper").width();

        if (totalWidth > breakpoint) {
          let focusedElementWidth = (event.clientX / totalWidth).toFixed(2);
          if (focusedElementWidth >= 0.5 && focusedElementWidth <= 0.9) {
            $(".localVideoWrapper").css({ 'grid-template-columns': `${focusedElementWidth}fr 2px ${1 - focusedElementWidth * 1}fr` });
          }
        } else {
          const totalHeight = $(".localVideoWrapper").height();
          let focusedElementHeight = (event.clientY / totalHeight).toFixed(2);
          if (focusedElementHeight >= 0.65 && focusedElementHeight <= 0.85) {
            $(".localVideoWrapper").css({ 'grid-template-rows': `150px ${focusedElementHeight}fr 2px ${1 - focusedElementHeight * 1}fr` });
          }
        }

        $("#gridToggle").css({ right: `${document.querySelector("#localVideoContainer").getBoundingClientRect().width / 2}px` });
      }
    });
  }

  prepareDonationModal = () => {
    $("#paypal_donation_url").attr("type", "hidden");
    $("#paypal_donation_text").addClass("readonly");
    $("#paypal_donation_image").addClass("active");
    $("#paypal_donation_text").replaceWith("<div id='paypal_donation_text'></div>");
    $("#paypal_donation_image_aspect_ratio").remove();
    $(".upload_paypal_donation_image").remove();
    $(".paypal_donation_image").addClass('simple');
    $(".paypal_donation_cta").addClass('simple');
    $(".paypal_donation_submit").remove();
    $("#paypal_description_label").remove();
    $(".paypal_donation_cta").html(`<img src="./textures/paypal.png" alt="Paypal image" id='paypal_donation'>`);
    $(".paypal-help-txt").parent().remove();
    $(".donation-title").text("Make a donation");
  }

  indicatorClickEvent = () => {

    $(document).on("click", ".indicator", (e) => {
      const el = e.currentTarget;
      console.log('[indicator click]', {
        classes: el?.className,
        indicatorId: el?.dataset?.indicator,
        targetTag: e.target?.tagName,
        action: describeIndicatorClickAction(el?.className),
      });

      this.model.lastScreenShareIClicked !== null && this.model.lastScreenShareIClicked.removeBorderHighlight();
      this.model.lastPeerChairIClicked !== null && this.model.lastPeerChairIClicked.removeBorderHighlight();
    });

    $(document).on("click", ".chair-indicator", (e) => {
      if (this.model.notAvailableInTourMode()) {
        this.model.alert('error', $trans('error-not-available-intour-mode'));
        return;
      }
      const meshId = $(e.target).data('indicator');
      $("#elementSelected").val(meshId);

      const mesh = this.scene.getObjectById(meshId, true);
      this.elementSelected = mesh;
      this._chairClickEvent();
    });

    $(document).on("click", ".screen-share-indicator", async (e) => {
      if (!await this.model.validatePlanFeature(FEATURE_NAMES.UNLIMITED_SCREENSHARE)) {
        if (!this.iSitOnChair()) {
          if (window.openLoginModal) {
            window.openLoginModal($trans('you-need-to-login-to-use-screen-share'));
          }
        }
        return;
      }
      if (this.model.notAvailableInTourMode()) {
        this.model.alert('error', $trans('error-not-available-intour-mode'));
        return;
      }
      if (!this.iSitOnChair()) {
        if (window.openLoginModal) {
          window.openLoginModal($trans('you-need-to-login-to-use-screen-share'));
        }
        this.model.alert('error', $trans('error-please-take-seat'));
        return;
      }
      const meshId = $(e.target).data('indicator');
      $("#elementSelected").val(meshId);

      const mesh = this.scene.getObjectById(meshId, true);
      this.elementSelected = mesh;

      this.elementSelected = mesh;
      this._screenStreamClickEvent();

    });

    $(document).on("click", ".tour-screen-share-indicator", async (e) => {
      if (!this.model.iAmGuide()) {
        this.model.info('success', "Only Guide is allowed to share screen.");
        return;
      }

      const checkingFeatureName = (this.model.tourMode || this.model.guidedMode) ? FEATURE_NAMES.TOURS_SCREENSHARE : FEATURE_NAMES.UNLIMITED_SCREENSHARE
      if (!await this.model.validatePlanFeature(checkingFeatureName)) {
        return;
      }

      const meshId = $(e.target).data('indicator');
      $("#elementSelected").val(meshId);
      this.elementSelected = this.scene.getObjectById(meshId, true);
      this.onTourSelectSourceDeviceModal();
      $("#submit_media_settings").hide();
    });

    $(document).on("click", ".web-link-indicator", (e) => {
      if (this.model.notAvailableInTourMode()) {
        this.model.alert('error', $trans('error-not-available-intour-mode'));
        return;
      }
      const meshId = $(e.target).closest('.web-link-indicator').data('indicator');
      if (!meshId) return;
      $("#elementSelected").val(meshId);

      const mesh = this.scene.getObjectById(meshId, true);
      this.elementSelected = mesh;
      if (!mesh) return;
      this._linkClickEvent(false, true);
    });

    $(document).on("click", ".scene-change-indicator", (e) => {
      if (this.model.isAnimating) {
        return;
      }
      if (this.model.notAvailableInTourMode() && !this.model.iAmGuide()) {
        !this.iAmGuide() && this.model.alert('error', $trans('error-not-available-intour-mode'));
        return;
      }
      const meshId = $(e.target).closest('.scene-change-indicator').data('indicator');
      if (!meshId) return;
      $("#elementSelected").val(meshId);

      const mesh = this.scene.getObjectById(meshId, true);
      this.elementSelected = mesh;
      if (!mesh) return;
      this._sceneChangeClickEvent();
    });

    $(document).on("click", ".paypal-donation-indicator", (e) => {
      if (this.model.notAvailableInTourMode()) {
        this.model.alert('error', $trans('error-not-available-intour-mode'));
        return;
      }
      const meshId = $(e.target).data('indicator');
      $("#elementSelected").val(meshId);

      const mesh = this.scene.getObjectById(meshId, true);
      this.elementSelected = mesh;
      this._payPalDonationClickEvent();
    });

    $(document).on("click", ".chess-indicator", async (e) => {
      if (this.model.notAvailableInTourMode()) {
        this.model.alert('error', $trans('error-not-available-intour-mode'));
        return;
      }

      const meshId = $(e.target).data('indicator');
      $("#elementSelected").val(meshId);

      const mesh = this.scene.getObjectById(meshId, true);
      this.elementSelected = mesh;
      this._chessGameClickEvent();
      this.elementSelected.parent.board.resize();
    });

    $(document).on("click", ".info-indicator", (e) => {
      const meshId = $(e.target).data('indicator');
      $("#elementSelected").val(meshId);

      const mesh = this.scene.getObjectById(meshId, true);
      this.elementSelected = mesh;
      this._infoElementClickEvent();
    });

    $("#inputFieldGuessSend").on("click", () => {
      this._getActiveInputFieldGuess()?.submitAnswer?.();
    });

    $("#inputFieldGuessAnswer").on("keydown", (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        this._getActiveInputFieldGuess()?.submitAnswer?.();
      }
    });

    $("#inputFieldGuessCancel, #inputFieldGuessModal .modal-background, #inputFieldGuessModal .close-modal").on("click", () => {
      const guess = this._getActiveInputFieldGuess();
      if (guess) {
        guess.closeModal?.();
      } else {
        $("#inputFieldGuessModal").removeClass("is-active");
      }
    });

    $("#inputFieldSend").on("click", () => {
      this._getActiveInputField()?.submitValue?.();
    });

    $("#inputFieldValue").on("keydown", (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        this._getActiveInputField()?.submitValue?.();
      }
    });

    $("#inputFieldValue").on("input", () => {
      $("#inputFieldValue").removeClass("is-danger");
      $("#inputFieldError").text('').hide();
    });

    $("#inputFieldCancel, #inputFieldModal .modal-background, #inputFieldModal .close-modal").on("click", () => {
      const input = this._getActiveInputField();
      if (input) {
        input.closeModal?.();
      } else {
        $("#inputFieldModal").removeClass("is-active");
      }
    });

    $(document).on("click", ".video-player-indicator", (e) => {
      if (this.model.notAvailableInTourMode()) {
        this.model.alert('error', $trans('error-not-available-intour-mode'));
        return;
      }
      const meshId = $(e.target).closest('.video-player-indicator').data('indicator');
      if (!meshId) return;
      $("#elementSelected").val(meshId);

      const mesh = this.scene.getObjectById(meshId, true);
      this.elementSelected = mesh;
      if (!mesh) return;
      this.onVideoPlayerClick();
    });

    $(document).on("click", ".shop-indicator", (e) => {
      if (this.model.notAvailableInTourMode()) {
        this.model.alert('error', $trans('error-not-available-intour-mode'));
        return;
      }
      const meshId = $(e.target).data('indicator');
      $("#elementSelected").val(meshId);

      const mesh = this.scene.getObjectById(meshId, true);
      this.elementSelected = mesh;
      this._shopLinkClickEvent();
    });

    $(document).on("click", ".embedded-webpage-indicator", (e) => {
      if (this.model.notAvailableInTourMode()) {
        this.model.alert('error', $trans('error-not-available-intour-mode'));
        return;
      }
      const meshId = $(e.target).data('indicator');
      $("#elementSelected").val(meshId);

      const mesh = this.scene.getObjectById(meshId, true);
      this.elementSelected = mesh;
      this._embeddedWebpageClickEvent();
    });

    $(document).on("click", ".image-gallery-indicator", (e) => {
      if (this.model.notAvailableInTourMode()) {
        this.model.alert('error', $trans('error-not-available-intour-mode'));
        return;
      }
      const meshId = $(e.target).closest('.image-gallery-indicator').data('indicator');
      if (!meshId) return;
      $("#elementSelected").val(meshId);

      const mesh = this.scene.getObjectById(meshId, true);
      this.elementSelected = mesh;
      if (!mesh) return;
      this.onImageGalleryClick();
    });
  }
  toggleCameraSeat = () => {
    this.model.iStream.video = !this.model.iStream.video;
    this.model.userWantsCamera = !this.model.userWantsCamera;
    this.model.userWantsCamera ? this.handleVideoStreamOn() : this.handleVideoStreamOff();
  }
  ctaMenuClickEvents = () => {
    // OWN CHAIR ACTIONS
    $("#toggleAudioTrack").on("click", (e) => {
      this._toggleAudioEvent();
    });
    $("#toggleVideoTrack").on("click", () => {
      this.toggleCameraSeat();
    });
    // $("#toggleGridMode").on("click", () => {
    //   $("#own-chair-menu").removeClass("is-active");
    //   this.handleGridToggle();
    // });
    $("#toggleDeviceSettings").on("click", () => {
      $("#own-chair-menu").removeClass("is-active");
      this.model.onOpenMediaSettings();
      // this.handleGridToggle();
    });
    $("#leave-chair").on("click", () => {
      this.leaveSeat();
    });

    // PEER CHAIR ACTIONS || ROOM OWNER ACTIONS
    $("#mutePeerVideo").on("click", () => {
      if (this.elementSelected.parent.isEmpty()) return;
      const { userId } = this.elementSelected.parent.dbConfig;
      $(`#remoteVideo_${userId}`).length && $(`#remoteVideo_${userId}`).prop("muted", !$(`#remoteVideo_${userId}`).prop("muted"));
    });
    $("#sendPeerMessage, #sendMessageToOwner").on("click", () => {
      this._chatEvent();
    });
    $("#peerVideoCall, #ownerVideoCall").on("click", () => {
      this._videoCallEvent();
    });
    $("#peerProfile, #ownerProfile").on("click", () => {
      this._userInfoEvent();
    });
    $("#peerAddAsFriend").on("click", () => {
      this._userAddAsFriend();
    });
    $("#ownerAddAsFriend").on("click", () => {
      this._userAddAsFriend();
    });
    $("#fullscreen_toggle").on("click", function () {
      if (!document.fullscreenElement && !document.webkitFullscreenElement) {
        if (isAndroid() && isChrome()) {
          document.body.classList.add("is-android-chrome");
        }
        if (isIOS() && isSafari()) {
          alert("Please consider using Safari in full-screen mode for the best experience.");
        }

        // Enter Fullscreen
        const elem = document.documentElement;
        if (elem.requestFullscreen) {
          elem.requestFullscreen();
        } else if (elem.webkitRequestFullscreen) { // Safari
          elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) { // IE11
          elem.msRequestFullscreen();
        }
        // $(this).text("fullscreen_exit"); // Change icon to "exit fullscreen"
      } else {
        if (isIOS() && isSafari()) {
          alert("Please consider using Safari in full-screen mode for the best experience.");
        }
        // Exit Fullscreen
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) { // Safari
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) { // IE11
          document.msExitFullscreen();
        }
        // $(this).text("fullscreen"); // Change icon to "go to fullscreen"

      }
    });

    function checkFullscreen() {
      if (document.fullscreenElement) {
        document.body.classList.add("is-fullscreen");
      } else {
        document.body.classList.remove("is-fullscreen");
      }
    }

    document.addEventListener("fullscreenchange", checkFullscreen);
    document.addEventListener("webkitfullscreenchange", checkFullscreen);
    document.addEventListener("mozfullscreenchange", checkFullscreen);
    document.addEventListener("MSFullscreenChange", checkFullscreen);

    // SCREEN SHARE
    $("#screenShareFullscreen").on("click", () => {
      this._fullScreen();
    });
    $("#toggleGridModeScreenShare").on("click", () => {
      this._gridFocus();
    });
    $("#stopScreenShare").on("click", () => {
      this._stopScreenShare();
    });
    $("#toggleScreenShareAudio").on("click", () => {
      this._toggleScreenAudioEvent();
    });

    /// submit tour screen share modal
    $("#tour_submit_share_on_screen_element").on("click", async () => {
      const isCamera = $('#tour-whatToShareModal').find('input[name="whatToStream"]:checked') === 'camera';

      let microphoneDevice = $("#useThisMicrophone").val();
      let cameraDevice = $("#useThisCamera").val();
      const parent = this.elementSelected.parent;
      const type = isCamera ? SCREEN_SHARE_SEAT_TYPE.CHAIR : SCREEN_SHARE_SEAT_TYPE.SEAT;
      this.onTourScreenShare(this.elementSelected, type);
      $("#tour-whatToShareModal").removeClass("is-active");
    });



    $("#submit_share_on_screen_element").on("click", async () => {
      $('#whatToShareModal').find('input[name="whatToStream"]:checked').trigger("click");
      const isCamera = $('#whatToShareModal').find('input[name="whatToStream"]:checked').val() === 'camera';
      let microphoneDevice = $("#useThisMicrophone").val();
      let cameraDevice = $("#useThisCamera").val();
      const parent = this.elementSelected.parent;
      if (this.model.streamController.screenStarted && !this.model.streamController.screenStarted()) {
        if (isCamera) {
          this.model.streamController.screenController.isCustomPublish = true;
          await this.model.streamController.startScreen(cameraDevice, microphoneDevice);
        } else {
          await this.model.streamController.startScreen();
        }
      } else {
        if (isCamera) {
          this.model.streamController.screenController.joinCamera(cameraDevice, microphoneDevice);
        } else {
          this.model.streamController.screenController.joinDesktop();
        }
      }
      $("#whatToShareModal").removeClass("is-active");
      this.closePreviewVideoModal();
      parent.takeSeat();
      this.model.onTakeScreenShareSeat(parent.dbConfig);
    });

    $('input[name="whatToStream"]').on("change", (e) => {
      const isCamera = e.currentTarget.value === 'camera';
      isCamera ? this.startPreviewVideoModal(true) : this.closePreviewVideoModal();
      $(".right-side").toggleClass("inactive", !isCamera);
      $(".left-side").toggleClass("inactive", isCamera);
    })

    $('#leave-teour-screen-share').on("click", (e) => {
      this.model.tourOnScreenShareSeatStandUp();
    })

  }

  openChooseStreamSourceModal = () => {
    const isCamera = $('input[name="whatToStream"]:checked').val() === 'camera';
    this.model.activePreviewVideoModal = isCamera;

    $("#whatToShareModal").addClass('is-active');
    isCamera && this.startPreviewVideoModal(true);
  }
  onTourSelectSourceDeviceModal = () => {
    const isCamera = $('input[name="tour-whatToStream"]:checked').val() === 'camera';
    // this.model.activePreviewVideoModal = isCamera;
    $("#tour-whatToShareModal").addClass('is-active');
  }

  resetFocusMode = () => {
    $(".localVideoWrapper ").removeClass('focus-mode');
    $("#focused-video").get(0).srcObject = null;
    $("#focused-avatar").attr('src', './textures/defaultAvatar.png');
    $("#focused-label").html('');
    $("#active-focused-element").val('');
    $('.localVideoWrapper').removeAttr('style');
    $("#gridToggle").removeAttr('style');
  }
  handleGridToggle = () => {
    if (!this.customRenderMode) {
      this.customRenderMode = true;
      // SHOW GRID VIDEOS
      // $('.own_chair__controls__toggle-meeting-mode').addClass('selected')


      // $('.localVideoWrapper').addClass('grid-mode');
      // $('#gridToggle').addClass('active');
      // $('#gridToggle').removeClass('hidden');
      // $('.web-rtc-button-wrapper').addClass('top-right');
      //
      // this.model.calculateGridDimensions();
      this.model.dispatchEvent({ type: SCENE_EVENTS.GRID_MODE, data: { showGrid: true } });
      window.activateOwnVideoInsideGrid();

    } else {
      this.customRenderMode = false;
      this.model.dispatchEvent({ type: SCENE_EVENTS.GRID_MODE, data: { showGrid: false } });
      // HIDE GRID VIDEOS
      // $('.localVideoWrapper').removeClass('grid-mode');
      // $(".video-wrapper").removeClass('focus');
      // $('#gridToggle').addClass('hidden');
      // $('#gridToggle').removeClass('active');
      // // $('#own-video').get(0).srcObject = null;
      // $('.web-rtc-button-wrapper').removeClass('top-right');
      // this.resetFocusMode();
    }
  }
  find3dObject = (id) => {
    if (!id || !this.objectsInScene) return null;
    const idStr = String(id);
    return this.objectsInScene.find((obj) => {
      const parent = obj?.parent;
      if (!parent) return false;
      const dbId = parent?.dbConfig?.id;
      const parentId = parent?.id;
      const getId = typeof parent?.getId === 'function' ? parent.getId() : null;
      const uniqueId = parent?.unique_id;
      return [dbId, parentId, getId, uniqueId].some((candidate) => candidate != null && String(candidate) === idStr);
    }) || null;
  }
  findSceneFromObjectId(objectId) {
    let found = null;
    Object.keys(this.model.scenes || {}).forEach(sceneId => {
      (this.model.scenes[sceneId]?.objects || []).forEach(obj => {
        if (obj.id === objectId) {
          found = sceneId;
        }
      });
    });
    return found;
  }

  rotateCameraToFaceObject(targetObject) {
    const targetPosition = new Vector3();
    targetObject.getWorldPosition(targetPosition);
    const direction = new Vector3()
      .subVectors(targetPosition, this.camera.position)
      .normalize();

    const newTargetPosition = new Vector3().addVectors(
      this.camera.position,
      direction
    );
    this.controls.target.copy(newTargetPosition);
    this.controls.update();
  }


  animateCameraLookAt(parent, duration = 1) {
    const targetPosition = this._getLookAtTargetPosition(parent);
    if (!targetPosition) {
      return;
    }

    this.controls.enabled = false;

    const fixedLocalPosition = this.camera.position.clone();
    const startQuat = this.camera.quaternion.clone();
    const camParent = this.camera.parent;
    if (!camParent) {
      this.controls.enabled = true;
      return;
    }

    const tmp = new THREE.Object3D();
    camParent.add(tmp);
    tmp.position.copy(this.camera.position);
    tmp.quaternion.copy(this.camera.quaternion);
    tmp.lookAt(targetPosition);
    const endQuat = tmp.quaternion.clone();
    camParent.remove(tmp);

    const cameraWorldStart = new THREE.Vector3();
    this.camera.getWorldPosition(cameraWorldStart);
    const radius = cameraWorldStart.distanceTo(this.controls.target);
    const tweenState = { t: 0 };

    gsap.to(tweenState, {
      t: 1,
      duration: duration,
      ease: Circ.easeOut,
      onStart: () => {
        // Start fetching destination tiles immediately so they are ready on arrival.
        this.camera.quaternion.copy(endQuat);
        this.camera.position.copy(fixedLocalPosition);
        this.camera.updateMatrixWorld();
        this.updateShphereTextureOnMove?.();
        this.camera.quaternion.copy(startQuat);
        this.camera.updateMatrixWorld();
      },
      onUpdate: () => {
        const q = new THREE.Quaternion().copy(startQuat).slerp(endQuat, tweenState.t);
        this.camera.quaternion.copy(q);
        this.camera.position.copy(fixedLocalPosition);
        const forward = new THREE.Vector3();
        this.camera.getWorldDirection(forward);
        const camWorld = new THREE.Vector3();
        this.camera.getWorldPosition(camWorld);
        const newTarget = camWorld.clone().add(forward.multiplyScalar(radius));
        this.controls.target.copy(newTarget);
        this.controls.update();
        this.updateShphereTextureOnMove?.();
      },
      onComplete: () => {
        this.camera.position.copy(fixedLocalPosition);
        const forward = new THREE.Vector3();
        this.camera.getWorldDirection(forward);
        const camWorld = new THREE.Vector3();
        this.camera.getWorldPosition(camWorld);
        const newTarget = camWorld.clone().add(forward.multiplyScalar(radius));
        this.controls.target.copy(newTarget);
        this.controls.update();
        this.controls.saveState();
        this.controls.enabled = true;
        this.updateShphereTextureOnMove?.();
      }
    });
  }
  animateCameraLookAtOld(parent, duration = 1) {
    const targetObject = parent.mesh;
    const targetPosition = new THREE.Vector3();
    if (!targetObject)
      return;
    targetObject.getWorldPosition(targetPosition);
    this.controls.enabled = false;
    const lookAtPoint = this.controls.target.clone();

    gsap.to(lookAtPoint, {
      x: targetPosition.x,
      y: targetPosition.y,
      z: targetPosition.z,
      duration: duration,
      ease: Expo.easeIn,
      onUpdate: () => {
        this.camera.lookAt(lookAtPoint);
      },
      onComplete: () => {
        this.controls.enabled = true;
        const pointA = this.camera.position.clone();
        const pointB = targetPosition;
        const direction = new THREE.Vector3().subVectors(pointB, pointA).normalize();
        const pointC = new THREE.Vector3().addVectors(pointA, direction.multiplyScalar(this.camera.position.z));
        this.controls.target.copy(pointC);
        this.controls.update(); // Final update to lock the target in place
      }
    });
  }
  animateCameraLookAtVector(targetPosition, duration = 1) {
    this.controls.enabled = false;

    const fixedPosition = this.camera.position.clone();
    const startQuat = this.camera.quaternion.clone();
    const tmp = new THREE.Object3D();
    tmp.position.copy(fixedPosition);
    tmp.lookAt(targetPosition);
    const endQuat = tmp.quaternion.clone();

    const radius = fixedPosition.distanceTo(this.controls.target);
    const tweenState = { t: 0 };

    gsap.to(tweenState, {
      t: 1,
      duration: duration,
      ease: Circ.easeIn,
      onStart: () => {
        this.camera.quaternion.copy(endQuat);
        this.camera.position.copy(fixedPosition);
        this.camera.updateMatrixWorld();
        this.updateShphereTextureOnMove?.();
        this.camera.quaternion.copy(startQuat);
        this.camera.updateMatrixWorld();
      },
      onUpdate: () => {
        const q = new THREE.Quaternion().copy(startQuat).slerp(endQuat, tweenState.t);
        this.camera.quaternion.copy(q);
        this.camera.position.copy(fixedPosition);
        const forward = new THREE.Vector3();
        this.camera.getWorldDirection(forward);
        const newTarget = new THREE.Vector3().copy(fixedPosition).add(forward.multiplyScalar(radius));
        this.controls.target.copy(newTarget);
        this.controls.update();
        this.updateShphereTextureOnMove?.();
      },
      onComplete: () => {
        this.controls.enabled = true;
        this.camera.position.copy(fixedPosition);
        const forward = new THREE.Vector3();
        this.camera.getWorldDirection(forward);
        const newTarget = new THREE.Vector3().copy(fixedPosition).add(forward.multiplyScalar(radius));
        this.controls.target.copy(newTarget);
        this.controls.update();
        this.updateShphereTextureOnMove?.();
      }
    });
  }


  standUpFromChair() {
    this.filtered3DObjects[SCENE_OBJECT_TYPES.guestSeat] && this.filtered3DObjects[SCENE_OBJECT_TYPES.guestSeat].map(item => {
      if (item.state.me) {
        this.elementSelected = item.mesh;
        this.leaveSeatNoPrompt();
      }
    })
  }
  standUpFromScreenShare() {
    this.filtered3DObjects[SCENE_OBJECT_TYPES.screenStream] && this.filtered3DObjects[SCENE_OBJECT_TYPES.screenStream].map(item => {
      if (item.state.me) {
        this.elementSelected = item.mesh;
        this._stopScreenShare();
      }
    })
  }
  iSitOnChair() {
    let iStream = null;
    this.filtered3DObjects[SCENE_OBJECT_TYPES.guestSeat] && this.filtered3DObjects[SCENE_OBJECT_TYPES.guestSeat].forEach((item) => {
      if (item.state && item.state.me) {
        iStream = item;
      }
    });
    return iStream;
  }
  areThereEmptyChairs() {
    const guestSeats = this.filtered3DObjects[SCENE_OBJECT_TYPES.guestSeat];
    if (!guestSeats) return null;
    for (const item of guestSeats) {
      if (item.state && item.state.occupied === false) {
        return item;
      }
    }
    return null;
  }
  iSitOnScreenStream() {
    let iStream = false;
    this.filtered3DObjects[SCENE_OBJECT_TYPES.screenStream] && this.filtered3DObjects[SCENE_OBJECT_TYPES.screenStream].forEach((item) => {
      if (item.state && item.state.me) {
        iStream = item;
      }
    });
    return iStream;
  }
  isScreenStreamButtonAvailable() {
    let isAvailable = true;
    if (!this.filtered3DObjects[SCENE_OBJECT_TYPES.screenStream]) {
      isAvailable = false;
    }
    this.filtered3DObjects[SCENE_OBJECT_TYPES.screenStream] && this.filtered3DObjects[SCENE_OBJECT_TYPES.screenStream].forEach((item) => {
      if (item.state && item.state.occupied) {
        isAvailable = false;
      }
    });
    return isAvailable;
  }

  isCloseScreenStreamButtonAvailable() {
    let isAvailable = true;
    if (!this.filtered3DObjects[SCENE_OBJECT_TYPES.screenStream]) {
      isAvailable = false;
    }
    this.filtered3DObjects[SCENE_OBJECT_TYPES.screenStream] && this.filtered3DObjects[SCENE_OBJECT_TYPES.screenStream].forEach((item) => {
      if (item?.state?.occupied) {
        isAvailable = false;
      }
      if (item?.state?.me) {
        isAvailable = isAvailable || true;
      }
    });
    return isAvailable;
  }
  takeFirstEmptyScreenShareSeat() {
    if (!this.filtered3DObjects[SCENE_OBJECT_TYPES.screenStream]) {
      this.model.alert($trans('no-empty-screen-share-seats'));
      return;
    }
    ///model error message
    this.filtered3DObjects[SCENE_OBJECT_TYPES.screenStream].forEach((item) => {
      if (!item.state.occupied) {
        this.elementSelected = item.mesh;
        this._screenStreamClickEvent();
      }
    })
  }

  autoDeactivateUser = () => {
    this.model.addEventListener(NOTIFICATION_EVENTS.OPENED, ({ data }) => {
      if (!data.id) {
        return;
      }
      switch (data.id) {
        case "deactivate-session-lock":
          let pendingDelay = this.modalDeactivateDelay;
          this.intervalSkipDeactivation = setInterval(() => {
            pendingDelay--;
            const $pendingTimer = $(".deactivate-countdown-timer");
            $pendingTimer.text(`${pendingDelay}s`);
            if (pendingDelay <= 0) {
              clearInterval(this.intervalSkipDeactivation);
              $pendingTimer.remove();
              this.model.dispatchEvent({ type: SCENE_EVENTS.MODAL_DEACTIVATE_USER });
            }
          }, 1000);
          break;
        default:
          break;
      }
    })

    this.model.addEventListener(SCENE_EVENTS.FORCE_QUIT_CHESS_GAME, async () => {
      this.elementSelected.parent.quitGame();
      this.model.chessModeController.leaveRoom();
      this.render3DWorld = true;
      this.customRenderMode = false;
      this.model.chessGameMode = false;
      this.model.dispatchEvent({ type: SCENE_EVENTS.HIDE_CHESS_MENU });
    });

    this.model.addEventListener(SCENE_EVENTS.MODAL_DEACTIVATE_USER, async () => {
      await this.model.closeModal();
      // disconnect the socket
      this.model.socket.forceDisconnect();

      // show the modal
      this.model.dispatchEvent({
        type: NOTIFICATION_EVENTS.CONFIRM_WITHOUT_CLOSE,
        data: {
          id: "activate-session-lock",
          message: $trans('activate-session-lock-message'),
          success: () => {
            window.location.reload();
          },
          confirmBtnTxt: 'Yes',
          cancelBtn: false,
        },
      });
    });

    $(document).on("mousemove keydown touchstart", () => {
      if (this.intervalDeactivate) {
        clearInterval(this.intervalDeactivate);
      }

      if (
        this.isSessionDeactivated ||
        this.model.isFrozenSession ||
        this.model.activeOneOnOneCall ||
        this.model.tourMode ||
        this.model.guidedMode
      ) {
        return;
      }

      let delay = this.intervalDeactivateDelay;
      this.intervalDeactivate = setInterval(() => {
        delay--;
        if (delay <= 0) {
          this.isSessionDeactivated = true;
          this.model.dispatchEvent({
            type: NOTIFICATION_EVENTS.CONFIRM_WITHOUT_CLOSE,
            data: {
              id: "deactivate-session-lock",
              message: $trans('deactivate-session-lock-message', {
                countdown: `<span class="deactivate-countdown-timer">${this.modalDeactivateDelay}s</span>`,
              }),
              successBtn: false,
              cancelBtnTxt: "Stay",
              onCancel: () => {
                this.isSessionDeactivated = false;
                if (this.intervalSkipDeactivation) {
                  clearInterval(this.intervalSkipDeactivation);
                }
              },
            },
          });
          clearInterval(this.intervalDeactivate);
        }
      }, 1000);
    });
  };
  leaveChessGameAndBackToViewMode = () => {
    this.elementSelected.parent.quitGame();
    this.model.chessModeController.leaveRoom();
    this.render3DWorld = true;
    this.customRenderMode = false;
    this.model.chessGameMode = false;
    this.model.dispatchEvent({ type: SCENE_EVENTS.HIDE_CHESS_MENU });
  }

  _setupVapiTopStatusIndicator() {
    const existing = document.getElementById('vapi-agent-top-status');
    if (existing) {
      existing.remove();
    }

    const statusEl = document.createElement('div');
    statusEl.id = 'vapi-agent-top-status';
    statusEl.className = 'vapi-agent-top-status world-bottom-nav__area__item world-bottom-nav__area__location status-side status-agent vrai-status-agent';
    statusEl.setAttribute('aria-live', 'polite');
    statusEl.setAttribute('aria-hidden', 'true');
    statusEl.innerHTML = `
      <svg class="vapi-agent-top-status__icon" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
        <rect x="8" y="8" width="16" height="16" rx="1.5" stroke="currentColor" stroke-width="1.75"/>
        <path d="M12 4v4M16 4v4M20 4v4M12 24v4M16 24v4M20 24v4M4 12h4M4 16h4M4 20h4M24 12h4M24 16h4M24 20h4" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/>
        <text x="16" y="17.2" text-anchor="middle" fill="currentColor" font-size="8" font-weight="700" font-family="Arial, Helvetica, sans-serif">AI</text>
      </svg>
      <div class="divider" aria-hidden="true"></div>
      <span class="vapi-agent-top-status__text"></span>
    `;

    document.body.appendChild(statusEl);
    this._vapiTopStatusEl = statusEl;
    this._vapiTopStatusTextEl = statusEl.querySelector('.vapi-agent-top-status__text');
  }

  _getVapiAgentDisplayName(agentId = null, providedName = '') {
    const explicitName = String(providedName || '').trim();
    if (explicitName) return explicitName;

    const chair = (this.vraiAgentChairs || []).find((item) => {
      const chairId = item?.getId?.() ?? item?.id;
      return chairId != null && agentId != null && String(chairId) === String(agentId);
    });
    const chairName = String(chair?.dbConfig?.chairName || chair?.dbConfig?.name || '').trim();
    if (chairName) return chairName;

    const sceneChair = this.currentScene?.objects?.find((obj) => {
      return obj?.type === 'vraiAgent' && obj?.id != null && agentId != null && String(obj.id) === String(agentId);
    });
    const sceneChairName = String(sceneChair?.chairName || sceneChair?.name || '').trim();
    if (sceneChairName) return sceneChairName;

    return (typeof $trans !== 'undefined' && $trans('vrai-agent-text')) || 'AI Agent';
  }

  _vapiErrorText(value) {
    return typeof value === 'string' && value.trim() ? value.trim() : '';
  }

  _formatVapiAgentError(err) {
    if (err == null) return '';
    const direct = this._vapiErrorText(err);
    if (direct) return direct;
    if (typeof err !== 'object') return '';
    const nodes = [err, err.error, err.error?.error, err.message];
    for (const node of nodes) {
      if (!node || typeof node !== 'object') continue;
      const text = this._vapiErrorText(node.message)
        || this._vapiErrorText(node.errorMsg)
        || this._vapiErrorText(node.msg)
        || this._vapiErrorText(node.error);
      if (text) return text;
    }
    return '';
  }

  _isNormalVapiCallEnd(err) {
    if (!err || typeof err !== 'object') return false;
    const nodes = [err, err.error, err.message, err.error?.error, err.error?.message];
    return nodes.some((node) => {
      if (!node || typeof node !== 'object') return false;
      if (node.type === 'ejected') return true;
      const msg = this._vapiErrorText(node.msg)
        || this._vapiErrorText(node.errorMsg)
        || this._vapiErrorText(node.message);
      return /meeting has ended|ended due to ejection/i.test(msg);
    });
  }

  _isNormalVapiEndMessage(message) {
    const msg = this._vapiErrorText(message);
    return msg === '[object Object]' || /meeting has ended|ended due to ejection/i.test(msg);
  }

  _getVapiTopStatusErrorText(state, data = {}) {
    const fromMessage = this._vapiErrorText(data?.message);
    if (fromMessage && !this._isNormalVapiEndMessage(fromMessage)) return fromMessage;
    const fromError = this._formatVapiAgentError(data?.error);
    if (fromError && !this._isNormalVapiEndMessage(fromError)) return fromError;
    if (state === 'no-assistant') {
      return (typeof $trans !== 'undefined' && $trans('vrai-agent-no-assistant')) || 'Agent not configured';
    }
    if (state === 'media-failed') {
      return (typeof $trans !== 'undefined' && $trans('vrai-agent-media-failed')) || 'Camera/mic access required';
    }
    return (typeof $trans !== 'undefined' && $trans('vrai-agent-connect-failed')) || 'Connection failed';
  }

  _getVapiTopStatusLabel(state, message = '', agentId = null, providedName = '') {
    const agentName = this._getVapiAgentDisplayName(agentId, providedName);
    if (state === 'connect-failed' || state === 'no-assistant' || state === 'media-failed') {
      const errorText = this._vapiErrorText(message) || this._getVapiTopStatusErrorText(state, { message });
      if (!errorText || this._isNormalVapiEndMessage(errorText)) return '';
      return `${agentName}: ${errorText}`;
    }
    if (state === 'agent-thinking') {
      return (typeof $trans !== 'undefined' && $trans('ai-interaction-thinking', {}, 'AI is thinking')) || 'AI is thinking';
    }
    if (state === 'agent-talking') {
      return (typeof $trans !== 'undefined' && $trans('ai-interaction-talking', {}, 'AI is talking')) || 'AI is talking';
    }
    if (state === 'agent') {
      return (typeof $trans !== 'undefined' && $trans('ai-interaction-listening', {}, 'AI is listening')) || 'AI is listening';
    }
    return (typeof $trans !== 'undefined' && $trans('ai-interaction-connecting', {}, 'Connecting to AI')) || 'Connecting to AI';
  }

  _refreshVapiTopStatus(agentId = null, providedName = '', isError = false) {
    const activeAgentId = agentId ?? this._activeVapiTopStatusAgentId;
    if (activeAgentId == null) return;
    this._setVapiTopStatus(
      this._getVapiTopStatusLabel(
        this._activeVapiTopStatusState || 'agent',
        this._activeVapiTopStatusMessage || '',
        activeAgentId,
        providedName
      ),
      isError ? 'vapi-error' : 'calling-agent'
    );
  }

  _setVapiTopStatus(text, className = '') {
    if (!this._vapiTopStatusEl || !this._vapiTopStatusTextEl) return;
    const content = (typeof text === 'string' ? text : '').trim();
    if (!content || content === '[object Object]' || content.endsWith(': [object Object]')) {
      this._hideVapiTopStatus();
      return;
    }

    this._vapiTopStatusTextEl.textContent = content;
    this._vapiTopStatusEl.className = 'vapi-agent-top-status world-bottom-nav__area__item world-bottom-nav__area__location status-side status-agent vrai-status-agent is-visible'
      + (className ? ` ${className}` : '');
    this._vapiTopStatusEl.setAttribute('aria-hidden', 'false');
    this._vapiTopStatusEl.setAttribute('data-ai-state', this._activeVapiTopStatusState || 'agent');
  }

  _hideVapiTopStatus(agentId = null) {
    if (agentId != null && this._activeVapiTopStatusAgentId != null && String(agentId) !== String(this._activeVapiTopStatusAgentId)) {
      return;
    }
    this._activeVapiTopStatusAgentId = null;
    this._activeVapiTopStatusState = '';
    this._activeVapiTopStatusMessage = '';
    if (!this._vapiTopStatusEl || !this._vapiTopStatusTextEl) return;
    this._vapiTopStatusTextEl.textContent = '';
    this._vapiTopStatusEl.className = 'vapi-agent-top-status world-bottom-nav__area__item world-bottom-nav__area__location status-side status-agent vrai-status-agent';
    this._vapiTopStatusEl.setAttribute('aria-hidden', 'true');
    this._vapiTopStatusEl.removeAttribute('data-ai-state');
  }
}

export { ModeView }
